(window.theme = window.theme || {}),
    (window.theme = window.theme || {}),
    (theme.Sections = function () {
        (this.constructors = {}),
            (this.instances = []),
            document.addEventListener("shopify:section:load", this._onSectionLoad.bind(this)),
            document.addEventListener("shopify:section:unload", this._onSectionUnload.bind(this)),
            document.addEventListener("shopify:section:select", this._onSelect.bind(this)),
            document.addEventListener("shopify:section:deselect", this._onDeselect.bind(this)),
            document.addEventListener("shopify:block:select", this._onBlockSelect.bind(this)),
            document.addEventListener("shopify:block:deselect", this._onBlockDeselect.bind(this)),
            document.addEventListener("shopify:section:reorder", this._onSectionReorder.bind(this));
    });
var _createClass = (function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            (descriptor.enumerable = descriptor.enumerable || !1), (descriptor.configurable = !0), "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function (Constructor, protoProps, staticProps) {
        return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
    };
})();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
window.theme = window.theme || {};
var handleizeStr = function (str) {
    return str
        .toLowerCase()
        .replace(/[^\w\u00C0-\u024f]+/g, "-")
        .replace(/^-+|-+$/g, "");
};
function checkFirstIndexSection() {
    var isSlideshowFirstSection = !1,
        main_wrapper = document.querySelector("#MainContent"),
        slideShowFirst = !1;
    if (main_wrapper) {
        var first_shopifySection = main_wrapper.querySelectorAll(".shopify-section")[0];
        first_shopifySection &&
            first_shopifySection.classList.contains("index-section--slideshow") &&
            ((isSlideshowFirstSection = !0), (slideShowFirst = !0), first_shopifySection.querySelector(".slideshow-section-wrapper").classList.contains("page-width") && (isSlideshowFirstSection = !1));
    }
    if (isSlideshowFirstSection) {
        var isSlideshowFirstSection = !1,
            main_wrapper = document.querySelector("#MainContent"),
            no_overlapHeader = document.querySelector(".shopify-section-header").classList.contains("no-overlap");
        if (!no_overlapHeader && main_wrapper) {
            var first_shopifySection = main_wrapper.querySelectorAll(".shopify-section")[0];
            first_shopifySection &&
                first_shopifySection.classList.contains("index-section--slideshow") &&
                ((isSlideshowFirstSection = !0), first_shopifySection.querySelector(".slideshow-section-wrapper").classList.contains("page-width") && (isSlideshowFirstSection = !1));
        }
        document.querySelector(".shopify-section-header") &&
            (isSlideshowFirstSection ? document.querySelector(".shopify-section-header").classList.remove("showAlternateHeader") : document.querySelector(".shopify-section-header").classList.add("showAlternateHeader"));
    } else {
        var noOverlap = !1,
            showAlternateHeader = !1,
            custom_page_header_section = document.querySelector(".custom_page_header_section"),
            alternate_logo = document.querySelector(".alternate_logo"),
            main_logo = document.querySelector(".main_logo"),
            PageContainer = document.querySelector("#PageContainer");
        custom_page_header_section || (showAlternateHeader = !0),
            document.querySelector(".no-overlap") && ((showAlternateHeader = !0), (noOverlap = !0)),
            slideShowFirst && (showAlternateHeader = !0),
            showAlternateHeader
                ? (PageContainer && (noOverlap || PageContainer.classList.add("marginTop")),
                  document.querySelector(".shopify-section-header") && document.querySelector(".shopify-section-header").classList.add("showAlternateHeader"),
                  alternate_logo && (alternate_logo.classList.remove("hide"), main_logo.classList.add("hide")))
                : (document.querySelector(".shopify-section-header").classList.remove("showAlternateHeader"),
                  PageContainer && PageContainer.classList.remove("marginTop"),
                  alternate_logo && (alternate_logo.classList.add("hide"), main_logo.classList.remove("hide")));
    }
}
(theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
    _createInstance: function (container, constructor) {
        var id = container.getAttribute("data-section-id"),
            type = container.getAttribute("data-section-type");
        if (((constructor = constructor || this.constructors[type]), !(typeof constructor > "u"))) {
            var instance = Object.assign(new constructor(container), { id, type, container });
            this.instances.push(instance);
        }
    },
    _onSectionLoad: function (evt) {
        var container = document.querySelector('[data-section-id="' + evt.detail.sectionId + '"]');
        container && this._createInstance(container), checkFirstIndexSection(), container.classList.contains("fade-in-animation") && container.classList.add("fadeIn-animation");
        var zoomFadeAnimationElems = container.querySelectorAll(".zoom-fade-animation:not(.zoomFade-animation)");
        zoomFadeAnimationElems.length &&
            zoomFadeAnimationElems.forEach(function (block, index) {
                var containerPosition = block.getBoundingClientRect();
                containerPosition.top + 200 < window.innerHeight && block.classList.add("zoomFade-animation");
            }),
            window.SPR && (window.SPR.initDomEls(), window.SPR.loadProducts());
    },
    _onSectionReorder: function (evt) {
        checkFirstIndexSection();
    },
    _onSectionUnload: function (evt) {
        var sectionEl = evt.target;
        checkFirstIndexSection(),
            (this.instances = this.instances.filter(function (instance) {
                var isEventInstance = instance.id === evt.detail.sectionId;
                return isEventInstance && typeof instance.onUnload == "function" && instance.onUnload(evt), !isEventInstance;
            }));
    },
    _onSelect: function (evt) {
        var instance = this.instances.find(function (instance2) {
            return instance2.id === evt.detail.sectionId;
        });
        typeof instance < "u" && typeof instance.onSelect == "function" && instance.onSelect(evt), checkFirstIndexSection();
    },
    _onDeselect: function (evt) {
        var instance = this.instances.find(function (instance2) {
            return instance2.id === evt.detail.sectionId;
        });
        typeof instance < "u" && typeof instance.onDeselect == "function" && instance.onDeselect(evt), checkFirstIndexSection();
    },
    _onBlockSelect: function (evt) {
        var instance = this.instances.find(function (instance2) {
            return instance2.id === evt.detail.sectionId;
        });
        typeof instance < "u" && typeof instance.onBlockSelect == "function" && instance.onBlockSelect(evt);
    },
    _onBlockDeselect: function (evt) {
        var instance = this.instances.find(function (instance2) {
            return instance2.id === evt.detail.sectionId;
        });
        typeof instance < "u" && typeof instance.onBlockDeselect == "function" && instance.onBlockDeselect(evt);
    },
    register: function (type, constructor) {
        (this.constructors[type] = constructor),
            document.querySelectorAll('[data-section-type="' + type + '"]').forEach(
                function (container) {
                    this._createInstance(container, constructor);
                }.bind(this)
            );
    },
})),
    checkFirstIndexSection(),
    (window.slate = window.slate || {}),
    (slate.utils = {
        getParameterByName: function (name, url) {
            url || (url = window.location.href), (name = name.replace(/[[\]]/g, "\\$&"));
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(url);
            return results ? (results[2] ? decodeURIComponent(results[2].replace(/\+/g, " ")) : "") : null;
        },
        resizeSelects: function (selects) {
            selects.forEach(function (select) {
                var arrowWidth = 55,
                    test = document.createElement("span");
                (test.innerHTML = select.selectedOptions[0].label), document.querySelector(".site-footer").appendChild(test);
                var width = test.offsetWidth + arrowWidth;
                test.remove(), (select.style.width = width + "px");
            });
        },
        keyboardKeys: { TAB: 9, ENTER: 13, ESCAPE: 27, LEFTARROW: 37, RIGHTARROW: 39 },
    }),
    (window.slate = window.slate || {}),
    (slate.rte = {
        wrapTable: function (options) {
            options.tables.forEach(function (table) {
                var wrapper = document.createElement("div");
                wrapper.classList.add(options.tableWrapperClass), table.parentNode.insertBefore(wrapper, table), wrapper.appendChild(table);
            });
        },
        wrapIframe: function (options) {
            options.iframes.forEach(function (iframe) {
                var wrapper = document.createElement("div");
                wrapper.classList.add(options.iframeWrapperClass), iframe.parentNode.insertBefore(wrapper, iframe), wrapper.appendChild(iframe), (iframe.src = iframe.src);
            });
        },
    }),
    (window.slate = window.slate || {}),
    (slate.a11y = {
        state: { firstFocusable: null, lastFocusable: null },
        pageLinkFocus: function (element) {
            if (!element) return;
            var focusClass = "js-focus-hidden";
            element.setAttribute("tabIndex", "-1"), element.focus(), element.classList.add(focusClass), element.addEventListener("blur", callback, { once: !0 });
            function callback() {
                element.classList.remove(focusClass), element.removeAttribute("tabindex");
            }
        },
        trapFocus: function (options) {
            var focusableElements = Array.from(options.container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])')).filter(function (element) {
                var width = element.offsetWidth,
                    height = element.offsetHeight;
                return width !== 0 && height !== 0 && getComputedStyle(element).getPropertyValue("display") !== "none";
            });
            (this.state.firstFocusable = focusableElements[0]),
                (this.state.lastFocusable = focusableElements[focusableElements.length - 1]),
                options.elementToFocus || (options.elementToFocus = options.container),
                options.container.setAttribute("tabindex", "-1"),
                options.elementToFocus.focus(),
                this._setupHandlers(),
                document.addEventListener("focusin", this._onFocusInHandler),
                document.addEventListener("focusout", this._onFocusOutHandler);
        },
        _setupHandlers: function () {
            this._onFocusInHandler || (this._onFocusInHandler = this._onFocusIn.bind(this)),
                this._onFocusOutHandler || (this._onFocusOutHandler = this._onFocusIn.bind(this)),
                this._manageFocusHandler || (this._manageFocusHandler = this._manageFocus.bind(this));
        },
        _onFocusOut: function () {
            document.removeEventListener("keydown", this._manageFocusHandler);
        },
        _onFocusIn: function (evt) {
            (evt.target !== this.state.lastFocusable && evt.target !== this.state.firstFocusable) || document.addEventListener("keydown", this._manageFocusHandler);
        },
        _manageFocus: function (evt) {
            evt.keyCode === slate.utils.keyboardKeys.TAB &&
                (evt.target === this.state.lastFocusable && !evt.shiftKey && (evt.preventDefault(), this.state.firstFocusable.focus()),
                evt.target === this.state.firstFocusable && evt.shiftKey && (evt.preventDefault(), this.state.lastFocusable.focus()));
        },
        removeTrapFocus: function (options) {
            options.container && options.container.removeAttribute("tabindex"), document.removeEventListener("focusin", this._onFocusInHandler);
        },
        accessibleLinks: function (options) {
            var body = document.querySelector("body"),
                idSelectors = { newWindow: "a11y-new-window-message", external: "a11y-external-message", newWindowExternal: "a11y-new-window-external-message" };
            (options.links === void 0 || !options.links.length) && (options.links = document.querySelectorAll("a[href]:not([aria-describedby])"));
            function generateHTML(customMessages) {
                typeof customMessages != "object" && (customMessages = {});
                var messages = Object.assign({ newWindow: "Opens in a new window.", external: "Opens external website.", newWindowExternal: "Opens external website in a new window." }, customMessages),
                    container = document.createElement("ul"),
                    htmlMessages = "";
                for (var message in messages) htmlMessages += "<li id=" + idSelectors[message] + ">" + messages[message] + "</li>";
                container.setAttribute("hidden", !0), (container.innerHTML = htmlMessages), body.appendChild(container);
            }
            function _externalSite(link) {
                var hostname = window.location.hostname;
                return link.hostname !== hostname;
            }
            options.links.forEach(function (link) {
                var target = link.getAttribute("target"),
                    rel = link.getAttribute("rel"),
                    isExternal = _externalSite(link),
                    isTargetBlank = target === "_blank";
                if ((isExternal && link.setAttribute("aria-describedby", idSelectors.external), isTargetBlank)) {
                    if (!rel || rel.indexOf("noopener") === -1) {
                        var relValue = rel === void 0 ? "" : rel + " ";
                        (relValue = relValue + "noopener"), link.setAttribute("rel", relValue);
                    }
                    link.setAttribute("aria-describedby", idSelectors.newWindow);
                }
                isExternal && isTargetBlank && link.setAttribute("aria-describedby", idSelectors.newWindowExternal);
            }),
                generateHTML(options.messages);
        },
    }),
    (theme.Images = (function () {
        function preload(images, size) {
            typeof images == "string" && (images = [images]);
            for (var i = 0; i < images.length; i++) {
                var image = images[i];
                this.loadImage(this.getSizedImageUrl(image, size));
            }
        }
        function loadImage(path) {
            new Image().src = path;
        }
        function switchImage(image, element, callback) {
            var size = this.imageSize(element.src),
                imageUrl = this.getSizedImageUrl(image.src, size);
            callback ? callback(imageUrl, image, element) : (element.src = imageUrl);
        }
        function imageSize(src) {
            var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/);
            return match !== null ? (match[2] !== void 0 ? match[1] + match[2] : match[1]) : null;
        }
        function getSizedImageUrl(src, size) {
            if (size === null) return src;
            if (size === "master") return this.removeProtocol(src);
            var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
            if (match !== null) {
                var prefix = src.split(match[0]),
                    suffix = match[0];
                return this.removeProtocol(prefix[0] + "_" + size + suffix);
            }
            return null;
        }
        function removeProtocol(path) {
            return path.replace(/http(s)?:/, "");
        }
        return { preload, loadImage, switchImage, imageSize, getSizedImageUrl, removeProtocol };
    })()),
    (theme.Currency = (function () {
        var moneyFormat = "${{amount}}";
        function formatMoney(cents, format) {
            typeof cents == "string" && (cents = cents.replace(".", ""));
            var value = "",
                placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
                formatString = format || moneyFormat;
            function formatWithDelimiters(number, precision, thousands, decimal) {
                if (((thousands = thousands || ","), (decimal = decimal || "."), isNaN(number) || number === null)) return 0;
                number = (number / 100).toFixed(precision);
                var parts = number.split("."),
                    dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
                    centsAmount = parts[1] ? decimal + parts[1] : "";
                return dollarsAmount + centsAmount;
            }
            switch (formatString.match(placeholderRegex)[1]) {
                case "amount":
                    value = formatWithDelimiters(cents, 2);
                    break;
                case "amount_no_decimals":
                    value = formatWithDelimiters(cents, 0);
                    break;
                case "amount_with_comma_separator":
                    value = formatWithDelimiters(cents, 2, ".", ",");
                    break;
                case "amount_no_decimals_with_comma_separator":
                    value = formatWithDelimiters(cents, 0, ".", ",");
                    break;
                case "amount_no_decimals_with_space_separator":
                    value = formatWithDelimiters(cents, 0, " ");
                    break;
                case "amount_with_apostrophe_separator":
                    value = formatWithDelimiters(cents, 2, "'");
                    break;
            }
            return formatString.replace(placeholderRegex, value);
        }
        return { formatMoney };
    })()),
    (slate.Variants = (function () {
        function Variants(options) {
            (this.container = options.container),
                (this.product = options.product),
                (this.originalSelectorId = options.originalSelectorId),
                (this.enabledPickAnOption = options.pickAnOption),
                (this.enabledShow_preOrder_btn = options.show_preOrder_btn),
                (this.enableLinkedOptions = options.enableLinkedOptions),
                (this.enableHistoryState = options.enableHistoryState),
                (this.singleOptions = this.container.querySelectorAll(options.singleOptionSelector)),
                (this.singleOptionColorSelect = this.container.querySelector(options.singleOptionColorSelector)),
                (this.currentVariant = this._getVariantFromOptions()),
                this._initGallery(),
                this.singleOptions.forEach(
                    function (option) {
                        option.addEventListener("change", this._onSelectChange.bind(this));
                    }.bind(this)
                ),
                this.singleOptionColorSelect && this.singleOptionColorSelect.dispatchEvent(new Event("change", { bubbles: !0 })),
                (this.delegateElement = new Delegate(this.container)),
                this.delegateElement.on("model:played", "[data-product-single-media-group]", this._disableDrag.bind(this)),
                this.delegateElement.on("model:paused", "[data-product-single-media-group]", this._enableDrag.bind(this));

                console.log("asadasd");
        }
        return (
            (Variants.prototype = Object.assign({}, Variants.prototype, {
                _initGallery: function (startIndex) {
                  console.log("startIndex=="+startIndex);
                    // var main_slider = this.container.querySelector(".product-single__media__carousel"),
                    //     thumbnails_slider = this.container.querySelector(".thumbnails-slider"),
                    //     main_slider_options = JSON.parse(main_slider.getAttribute("data-flickity-config")),
                    //     product_image__zoom = this.container.querySelector(".product_image__zoom"),
                    //     thumbnails_grid = this.container.querySelector(".thumbnails-grid");
                    // if (main_slider) {
                    //     startIndex && (main_slider_options.initialIndex = startIndex), (this.flickityInstance = new Flickity(main_slider, main_slider_options)), this.flickityInstance.element.classList.add("rendered");
                    //     var _this = this;
                    //     this.flickityInstance.on("select", function (index) {
                    //         var flickity_slider = _this.flickityInstance.element,
                    //             videoSlides = flickity_slider.querySelectorAll("[data-product-media-type-video]"),
                    //             modelViewerSlides = flickity_slider.querySelectorAll("[data-product-media-type-model]"),
                    //             selectedSlide = _this.flickityInstance.selectedElement;
                    //         videoSlides.length > 0 &&
                    //             videoSlides.forEach(function (item, index2) {
                    //                 var isVideoTag2 = item.querySelector("video");
                    //                 if (isVideoTag2) {
                    //                     var videoId2 = isVideoTag2.getAttribute("id"),
                    //                         videoObj2 = document.getElementById(videoId2);
                    //                     videoObj2 && videoObj2.pause();
                    //                 } else {
                    //                     var videoHost2 = item.querySelector(".product-single__media").getAttribute("data-media-host"),
                    //                         videoId2 = item.querySelector("iframe").getAttribute("id");
                    //                     if (videoHost2 == "youtube") {
                    //                         if (window.YT) {
                    //                             var player2 = YT.get(videoId2);
                    //                             player2 && player2.pauseVideo();
                    //                         }
                    //                     } else if (window.Vimeo) {
                    //                         var player2 = new Vimeo.Player(item.querySelector("iframe"));
                    //                         player2 && player2.pause();
                    //                     }
                    //                 }
                    //             });
                    //         var selectedSlideVideo = selectedSlide.querySelector("[data-product-media-type-video]");
                    //         if (selectedSlideVideo) {
                    //             var isVideoTag = selectedSlideVideo.querySelector("video");
                    //             if (isVideoTag) {
                    //                 var videoId = isVideoTag.getAttribute("id"),
                    //                     videoObj = document.getElementById(videoId);
                    //                 videoObj && videoObj.play();
                    //             } else {
                    //                 var videoHost = selectedSlideVideo.querySelector(".product-single__media").getAttribute("data-media-host"),
                    //                     videoId = selectedSlideVideo.querySelector("iframe").getAttribute("id");
                    //                 if (videoHost == "youtube") {
                    //                     if (window.YT) {
                    //                         var player = YT.get(videoId);
                    //                         player && player.playVideo();
                    //                     }
                    //                 } else if (window.Vimeo) {
                    //                     var player = new Vimeo.Player(selectedSlideVideo.querySelector("iframe"));
                    //                     player && player.play();
                    //                 }
                    //             }
                    //         }
                    //         var selectedSlideModel = selectedSlide.querySelector("[data-product-media-type-model]");
                    //         if (selectedSlideModel) {
                    //             var modelViewerEl = selectedSlide.querySelector("model-viewer");
                    //             modelViewerEl && modelViewerEl.dispatchEvent(new CustomEvent("mediaVisible", { bubbles: !0, cancelable: !0 }));
                    //         } else
                    //             modelViewerSlides.length > 0 &&
                    //                 modelViewerSlides.forEach(function (item, index2) {
                    //                     var modelViewerEl2 = item.querySelector("model-viewer");
                    //                     modelViewerEl2 && modelViewerEl2.dispatchEvent(new CustomEvent("mediaHidden", { bubbles: !0, cancelable: !0 }));
                    //                 });
                    //     });
                    // }
                    // if (thumbnails_slider) {
                    //     var thumbnails_slider_options = JSON.parse(thumbnails_slider.getAttribute("data-thumb_flickity_options"));
                    //     thumbnails_slider_options.asNavFor = main_slider;
                    //     var thumb_flickityInstance = new Flickity(thumbnails_slider, thumbnails_slider_options);
                    // }
                    // if (product_image__zoom) {
                    //     var imagesArr = main_slider.querySelectorAll(".image_type");
                    //     imagesArr.length &&
                    //         imagesArr.forEach(function (item, index) {
                    //             item.addEventListener("click", function (e) {
                    //                 e.preventDefault();
                    //                 var pswpElement = document.querySelectorAll(".pswp")[0],
                    //                     items = [];
                    //                 imagesArr.forEach(function (imageEl, index2) {
                    //                     var imageObj = { src: imageEl.getAttribute("data-image-url"), w: +imageEl.getAttribute("data-image-width"), h: +imageEl.getAttribute("data-image-height") };
                    //                     items.push(imageObj);
                    //                 });
                    //                 var options = { index },
                    //                     gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
                    //                 gallery.init();
                    //             });
                    //         });
                    // }
                    // if (thumbnails_grid) {
                    //     var thumbnail_images = thumbnails_grid.querySelectorAll(".product-single__thumbnail-image");
                    //     thumbnail_images.length &&
                    //         thumbnail_images.forEach(function (thumb, index) {
                    //             thumb.addEventListener("click", function (e) {
                    //                 e.preventDefault(), _this.flickityInstance.select(index);
                    //             });
                    //         });
                    // }
                },
                _disableDrag: function (event) {
                    (this.flickityInstance.options.draggable = !1), this.flickityInstance.updateDraggable();
                },
                _enableDrag: function (event) {
                    (this.flickityInstance.options.draggable = !0), this.flickityInstance.updateDraggable();
                },
                _getCurrentOptions: function () {
                    var result = [];
                    return (
                        this.singleOptions.forEach(function (option) {
                            var type = option.getAttribute("type"),
                                isRadioOrCheckbox = type === "radio" || type === "checkbox";
                            (!isRadioOrCheckbox || option.checked) && result.push({ value: option.value, index: option.getAttribute("data-index") });
                        }),
                        result
                    );
                },
                _getVariantFromOptions: function () {
                    var selectedValues = this._getCurrentOptions(),
                        variants = this.product.variants,
                        found = variants.find(function (variant) {
                            return selectedValues.every(function (values) {
                                return variant[values.index] === values.value;
                            });
                        });
                    return found;
                },
                _onSelectChange: function (e) {
                    var variant = this._getVariantFromOptions();

                    var varservings = $('.product-variant-swatches[data-varid="' + variant.id + '"]').data('servings');
                    var subwidget = $('.bundleapp-plan-selector-group--selected').data('productinfo');
                    var varservingsprice = $('.product-variant-swatches[data-varid="' + variant.id + '"]').data('servingprice');
                    var varservingspricesub = varservingsprice.replace(/[^$\d.]/g, '') + ' / Servings';
                    var varservingssellprice = $('.product-variant-swatches[data-varid="' + variant.id + '"]').data('servingsellprice');
                    var varservingssellpricesub = varservingssellprice.replace(/[^$\d.]/g, '') + ' / Servings';
                    var vardiscount = $('.product_swatches').find('.selling_discount_info[data-varid="' + variant.id + '"]').find('option').data('discount');

                    $('.bundleapp-plan-selector-group').attr('data-selectvarid', variant.id);
                    $('.product-variant-servings').text(varservings);
                    $('.product_servings_number').text(varservings);
                    $('.product_servings_info').text(varservingspricesub);
                    $('.product_sell_servings_info').text(varservingssellpricesub);
                    $('.subscribediscount').text(vardiscount);

                    if(subwidget == 'onetimepurchase'){
                        $('.variant-per-servings').text(varservingsprice);
                        $('.selling_plan_select_container_sticky').hide();
                    }else{
                        console.log('subscription');
                        $('.variant-per-servings').text(varservingssellprice);
                        $('.selling_plan_select_container_sticky').hide();
                        $('.selling_plan_select_container_sticky[data-varid="' + variant.id + '"]').show();
                    }
                                   
                    if (this.enabledPickAnOption)
                        if (variant) {
                            var form = this.container.querySelector(".disabled_btns");
                            if (form) {
                                var submit_btn = form.querySelector('[type="submit"]');
                                form.classList.remove("disabled_btns"), submit_btn && (submit_btn.disabled = !1);
                            }
                        } else {
                            var selectedValuesArr = this._getCurrentOptions(),
                                allOptionsPicked = !0;
                            if (
                                (selectedValuesArr.forEach(function (selectedValue) {
                                    selectedValue.value == "" && (allOptionsPicked = !1);
                                }),
                                !allOptionsPicked)
                            )
                                return;
                        }
                    this.container.dispatchEvent(new CustomEvent("variantChange", { detail: { variant }, bubbles: !0, cancelable: !0 })),
                        variant &&
                            (this._updateMasterSelect(variant),
                            this._updateImages(variant, e),
                            this._updatePrice(variant),
                            this._updateSKU(variant),
                            (this.currentVariant = variant),
                            this.enableHistoryState && this._updateHistoryState(variant));
                },
                _updateImages: function (variant, event) {
                                    
                    var mainslideravailable = $(".thumb-slider .swiper-slide").length;
                    
                    if (mainslideravailable > 1) {
                      
                      var imageindex = variant.featured_image.position;
                      var indexposition = imageindex - 1;
                      const startEvent = new CustomEvent("repositionmainslider", {
                        detail: { index: indexposition },
                      });
                
                      document.dispatchEvent(startEvent);
                    }

                  
                    var all_media__block = this.container.querySelector(".all_media__block"),
                        all_thumb_media__block = this.container.querySelector(".all_thumb_media__block"),
                        slider = this.container.querySelector("[data-product-main-slider]");
                    if (all_media__block) {
                        var thumb_slider = this.container.querySelector(".product-single__thumbnails"),
                            el_target = event.target,
                            optionName = el_target.getAttribute("data-option-name").toLowerCase(),
                            optionValue = el_target.value.toLowerCase(),
                            rebuild_flag = !1;
                        if (
                            (slider.querySelectorAll(".product-single__media__slide").forEach(function (item, index) {
                                var item_wrapper = item.querySelector("[data-product-single-media-wrapper]");
                                if (item_wrapper) {
                                    var itemOptionName = item_wrapper.getAttribute("data-media-option-name");
                                    itemOptionName == optionName && (rebuild_flag = !0);
                                }
                            }),
                            rebuild_flag)
                        ) {
                            if (slider.classList.contains("flickity-enabled")) {
                                var flkty = Flickity.data(slider);
                                flkty.destroy();
                            }
                            var slider_old_images = slider.querySelectorAll("[product-image-media]");
                            slider_old_images.length &&
                                slider_old_images.forEach(function (imageEl, index) {
                                    var parentEl = imageEl.closest(".product-single__media__slide");
                                    parentEl && parentEl.remove();
                                });
                            var show_default_image = !0;
                            if (
                                (all_media__block.querySelectorAll(".product-single__media__slide").forEach(function (item, index) {
                                    var item_wrapper = item.querySelector("[data-product-single-media-wrapper]"),
                                        itemOptionName = item_wrapper.getAttribute("data-media-option-name"),
                                        itemOptionValue = item_wrapper.getAttribute("data-media-option-value");
                                    if (itemOptionName == optionName && optionValue == itemOptionValue) {
                                        var clone = item.cloneNode(!0);
                                        (show_default_image = !1), slider.appendChild(clone);
                                    }
                                }),
                                thumb_slider)
                            ) {
                                if (thumb_slider.classList.contains("flickity-enabled")) {
                                    var thumb_flkty = Flickity.data(thumb_slider);
                                    thumb_flkty.destroy();
                                }
                                var old_thumbs_images = thumb_slider.querySelectorAll("[product-image-media]");
                                old_thumbs_images.length &&
                                    old_thumbs_images.forEach(function (imageEl, index) {
                                        imageEl.remove();
                                    }),
                                    all_thumb_media__block.querySelectorAll(".product-single__thumbnails-block").forEach(function (item, index) {
                                        var itemOptionName = item.getAttribute("data-media-option-name"),
                                            itemOptionValue = item.getAttribute("data-media-option-value");
                                        if (itemOptionName == optionName && optionValue == itemOptionValue) {
                                            var clone = item.cloneNode(!0);
                                            thumb_slider.appendChild(clone);
                                        }
                                    });
                            }
                            show_default_image &&
                                (all_media__block.querySelectorAll(".product-single__media__slide").forEach(function (item, index) {
                                    var clone = item.cloneNode(!0);
                                    slider.appendChild(clone);
                                }),
                                thumb_slider &&
                                    all_thumb_media__block.querySelectorAll(".product-single__thumbnails-block").forEach(function (item, index) {
                                        var clone = item.cloneNode(!0);
                                        thumb_slider.appendChild(clone);
                                    }));
                            var featuredMediaIndex = 0,
                                variantMedia = variant.featured_media;
                            if (variantMedia) {
                                var variantMediaId = variant.featured_media.id,
                                    featuredMedia = slider.querySelector('.image_type[data-image-id="' + variantMediaId + '"]');
                                if (featuredMedia) {
                                    var featuredMediaParent = featuredMedia.closest(".product-single__media__slide");
                                    featuredMediaParent && (featuredMediaIndex = [].slice.call(featuredMediaParent.parentNode.children).indexOf(featuredMediaParent));
                                }
                            }
                            this._initGallery(featuredMediaIndex);
                        }
                    } else {
                      
                        var variantImage = variant.featured_image || {},
                            currentVariantImage = this.currentVariant.featured_image || {};
                        if (!variant.featured_image || variantImage.src === currentVariantImage.src) return;
                        var featuredMediaIndex = 0,
                            variantMedia = variant.featured_media;
                        if (variantMedia) {
                            var variantMediaId = variant.featured_media.id,
                                featuredMedia = slider.querySelector('.image_type[data-image-id="' + variantMediaId + '"]');
                            if (featuredMedia) {
                                var featuredMediaParent = featuredMedia.closest(".product-single__media__slide");
                                featuredMediaParent &&
                                    ((featuredMediaIndex = [].slice.call(featuredMediaParent.parentNode.children).indexOf(featuredMediaParent)), this.flickityInstance && this.flickityInstance.selectCell(featuredMediaIndex));
                            }
                        }
                    }
                },
                _updatePrice: function (variant) {
                    (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price && variant.unit_price === this.currentVariant.unit_price) ||
                        this.container.dispatchEvent(new CustomEvent("variantPriceChange", { detail: { variant }, bubbles: !0, cancelable: !0 }));
                },
                _updateSKU: function (variant) {
                    variant.sku !== this.currentVariant.sku && this.container.dispatchEvent(new CustomEvent("variantSKUChange", { detail: { variant }, bubbles: !0, cancelable: !0 }));
                },
                _updateHistoryState: function (variant) {
                    if (!(!history.replaceState || !variant)) {
                        var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + variant.id;
                        window.history.replaceState({ path: newurl }, "", newurl);
                    }
                },
                _updateMasterSelect: function (variant) {
                    var masterSelect = this.container.querySelector(this.originalSelectorId);
                    masterSelect && (masterSelect.value = variant.id);
                },
            })),
            Variants
        );
    })()),
    (this.Shopify = this.Shopify || {}),
    (this.Shopify.theme = this.Shopify.theme || {}),
    (this.Shopify = this.Shopify || {}),
    (this.Shopify.theme = this.Shopify.theme || {}),
    (window.theme = window.theme || {}),
    (theme.TouchEvents = function (element, options) {
        this.axis,
            (this.checkEvents = []),
            (this.eventHandlers = {}),
            (this.eventModel = {}),
            (this.events = [
                ["touchstart", "touchmove", "touchend", "touchcancel"],
                ["pointerdown", "pointermove", "pointerup", "pointercancel"],
                ["mousedown", "mousemove", "mouseup"],
            ]),
            this.eventType,
            (this.difference = {}),
            this.direction,
            (this.start = {}),
            (this.element = element),
            (this.options = Object.assign({}, { dragThreshold: 10, start: function () {}, move: function () {}, end: function () {} }, options)),
            (this.checkEvents = this._getCheckEvents()),
            (this.eventModel = this._getEventModel()),
            this._setupEventHandlers();
    }),
    (theme.TouchEvents.prototype = Object.assign({}, theme.TouchEvents.prototype, {
        destroy: function () {
            this.element.removeEventListener("dragstart", this.eventHandlers.preventDefault),
                this.element.removeEventListener(this.events[this.eventModel][0], this.eventHandlers.touchStart),
                this.eventModel || this.element.removeEventListener(this.events[2][0], this.eventHandlers.touchStart),
                this.element.removeEventListener("click", this.eventHandlers.preventClick);
        },
        _setupEventHandlers: function () {
            (this.eventHandlers.preventDefault = this._preventDefault.bind(this)),
                (this.eventHandlers.preventClick = this._preventClick.bind(this)),
                (this.eventHandlers.touchStart = this._touchStart.bind(this)),
                (this.eventHandlers.touchMove = this._touchMove.bind(this)),
                (this.eventHandlers.touchEnd = this._touchEnd.bind(this)),
                this.element.addEventListener("dragstart", this.eventHandlers.preventDefault),
                this.element.addEventListener(this.events[this.eventModel][0], this.eventHandlers.touchStart),
                this.eventModel || this.element.addEventListener(this.events[2][0], this.eventHandlers.touchStart),
                this.element.addEventListener("click", this.eventHandlers.preventClick);
        },
        _touchStart: function (event) {
            (this.eventType = this.eventModel),
                event.type === "mousedown" && !this.eventModel && (this.eventType = 2),
                !this.checkEvents[this.eventType](event) &&
                    (this.eventType && this._preventDefault(event),
                    document.addEventListener(this.events[this.eventType][1], this.eventHandlers.touchMove),
                    document.addEventListener(this.events[this.eventType][2], this.eventHandlers.touchEnd),
                    this.eventType < 2 && document.addEventListener(this.events[this.eventType][3], this.eventHandlers.touchEnd),
                    (this.start = { xPosition: this.eventType ? event.clientX : event.touches[0].clientX, yPosition: this.eventType ? event.clientY : event.touches[0].clientY, time: new Date().getTime() }),
                    Object.keys(this.difference).forEach(
                        function (key) {
                            delete this.difference[key];
                        }.bind(this)
                    ),
                    this.options.start(event));
        },
        _touchMove: function (event) {
            (this.difference = this._getDifference(event)),
                (document["on" + this.events[this.eventType][1]] = function (event2) {
                    this._preventDefault(event2);
                }.bind(this)),
                this.axis
                    ? this.axis === "xPosition"
                        ? (this.direction = this.difference.xPosition < 0 ? "left" : "right")
                        : this.axis === "yPosition" && (this.direction = this.difference.yPosition < 0 ? "up" : "down")
                    : this.options.dragThreshold < Math.abs(this.difference.xPosition)
                    ? (this.axis = "xPosition")
                    : this.options.dragThreshold < Math.abs(this.difference.yPosition)
                    ? (this.axis = "yPosition")
                    : (this.axis = !1),
                this.options.move(event, this.direction, this.difference);
        },
        _touchEnd: function (event) {
            document.removeEventListener(this.events[this.eventType][1], this.eventHandlers.touchMove),
                document.removeEventListener(this.events[this.eventType][2], this.eventHandlers.touchEnd),
                this.eventType < 2 && document.removeEventListener(this.events[this.eventType][3], this.eventHandlers.touchEnd),
                (document["on" + this.events[this.eventType][1]] = function () {
                    return !0;
                }),
                this.options.end(event, this.direction, this.difference),
                (this.axis = !1);
        },
        _getDifference: function (event) {
            return {
                xPosition: (this.eventType ? event.clientX : event.touches[0].clientX) - this.start.xPosition,
                yPosition: (this.eventType ? event.clientY : event.touches[0].clientY) - this.start.yPosition,
                time: new Date().getTime() - this.start.time,
            };
        },
        _getCheckEvents: function () {
            return [
                function (event) {
                    return (event.touches && event.touches.length > 1) || (event.scale && event.scale !== 1);
                },
                function (event) {
                    return !event.isPrimary || (event.buttons && event.buttons !== 1) || (event.pointerType !== "touch" && event.pointerType !== "pen");
                },
                function (event) {
                    return event.buttons && event.buttons !== 1;
                },
            ];
        },
        _getEventModel: function () {
            return window.navigator.pointerEnabled ? 1 : 0;
        },
        _preventDefault: function (event) {
            event.preventDefault ? event.preventDefault() : (event.returnValue = !1);
        },
        _preventClick: function (event) {
            Math.abs(this.difference.xPosition) > this.options.dragThreshold && this._preventDefault(event);
        },
    })),
    (theme.Helpers = (function () {
        var touchDevice = !1,
            classes = { preventScrolling: "prevent-scrolling" },
            scrollPosition = window.pageYOffset;
        function setTouch() {
            touchDevice = !0;
        }
        function isTouch() {
            return touchDevice;
        }
        function enableScrollLock() {
            (scrollPosition = window.pageYOffset), (document.body.style.top = "-" + scrollPosition + "px"), document.body.classList.add(classes.preventScrolling);
        }
        function disableScrollLock() {
            document.body.classList.remove(classes.preventScrolling), document.body.style.removeProperty("top"), window.scrollTo(0, scrollPosition);
        }
        function debounce(func, wait, immediate) {
            var timeout;
            return function () {
                var context = this,
                    args = arguments,
                    later = function () {
                        (timeout = null), immediate || func.apply(context, args);
                    },
                    callNow = immediate && !timeout;
                clearTimeout(timeout), (timeout = setTimeout(later, wait)), callNow && func.apply(context, args);
            };
        }
        function getScript(source, beforeEl) {
            return new Promise(function (resolve, reject) {
                var script = document.createElement("script"),
                    prior = beforeEl || document.getElementsByTagName("script")[0];
                (script.async = !0), (script.defer = !0);
                function onloadHander(_, isAbort) {
                    (isAbort || !script.readyState || /loaded|complete/.test(script.readyState)) && ((script.onload = null), (script.onreadystatechange = null), (script = void 0), isAbort ? reject() : resolve());
                }
                (script.onload = onloadHander), (script.onreadystatechange = onloadHander), (script.src = source), prior.parentNode.insertBefore(script, prior);
            });
        }
        function prepareTransition(element) {
            element.addEventListener(
                "transitionend",
                function (event) {
                    event.currentTarget.classList.remove("is-transitioning");
                },
                { once: !0 }
            );
            var properties = ["transition-duration", "-moz-transition-duration", "-webkit-transition-duration", "-o-transition-duration"],
                duration = 0;
            properties.forEach(function (property) {
                var computedValue = getComputedStyle(element)[property];
                computedValue && (computedValue.replace(/\D/g, ""), duration || (duration = parseFloat(computedValue)));
            }),
                duration !== 0 && (element.classList.add("is-transitioning"), element.offsetWidth);
        }
        /*!
         * Serialize all form data into a SearchParams string
         * (c) 2020 Chris Ferdinandi, MIT License, https://gomakethings.com
         * @param  {Node}   form The form to serialize
         * @return {String}      The serialized form data
         */ function serialize(form) {
            var arr = [];
            return (
                Array.prototype.slice.call(form.elements).forEach(function (field) {
                    if (!(!field.name || field.disabled || ["file", "reset", "submit", "button"].indexOf(field.type) > -1)) {
                        if (field.type === "select-multiple") {
                            Array.prototype.slice.call(field.options).forEach(function (option) {
                                option.selected && arr.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(option.value));
                            });
                            return;
                        }
                        (["checkbox", "radio"].indexOf(field.type) > -1 && !field.checked) || arr.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value));
                    }
                }),
                arr.join("&")
            );
        }
        function cookiesEnabled() {
            var cookieEnabled = navigator.cookieEnabled;
            return cookieEnabled || ((document.cookie = "testcookie"), (cookieEnabled = document.cookie.indexOf("testcookie") !== -1)), cookieEnabled;
        }
        function promiseStylesheet(stylesheet) {
            var stylesheetUrl = stylesheet || theme.stylesheet;
            return (
                typeof this.stylesheetPromise > "u" &&
                    (this.stylesheetPromise = new Promise(function (resolve) {
                        var link = document.querySelector('link[href="' + stylesheetUrl + '"]');
                        link.loaded && resolve(),
                            link.addEventListener("load", function () {
                                setTimeout(resolve, 0);
                            });
                    })),
                this.stylesheetPromise
            );
        }
        return { setTouch, isTouch, enableScrollLock, disableScrollLock, debounce, getScript, prepareTransition, serialize, cookiesEnabled, promiseStylesheet };
    })()),
    (theme.LibraryLoader = (function () {
        var types = { link: "link", script: "script" },
            status = { requested: "requested", loaded: "loaded" },
            cloudCdn = "https://cdn.shopify.com/shopifycloud/",
            libraries = {
                plyrShopifyStyles: { tagId: "plyr-shopify-styles", src: cloudCdn + "plyr/v2.0/shopify-plyr.css", type: types.link },
                modelViewerUiStyles: { tagId: "shopify-model-viewer-ui-styles", src: cloudCdn + "model-viewer-ui/assets/v1.0/model-viewer-ui.css", type: types.link },
            };
        function load(libraryName, callback) {
            var library = libraries[libraryName];
            if (library && library.status !== status.requested) {
                if (((callback = callback || function () {}), library.status === status.loaded)) {
                    callback();
                    return;
                }
                library.status = status.requested;
                var tag;
                switch (library.type) {
                    case types.script:
                        tag = createScriptTag(library, callback);
                        break;
                    case types.link:
                        tag = createLinkTag(library, callback);
                        break;
                }
                (tag.id = library.tagId), (library.element = tag);
                var firstScriptTag = document.getElementsByTagName(library.type)[0];
                firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
            }
        }
        function createScriptTag(library, callback) {
            var tag = document.createElement("script");
            return (
                (tag.src = library.src),
                tag.addEventListener("load", function () {
                    (library.status = status.loaded), callback();
                }),
                tag
            );
        }
        function createLinkTag(library, callback) {
            var tag = document.createElement("link");
            return (
                (tag.href = library.src),
                (tag.rel = "stylesheet"),
                (tag.type = "text/css"),
                tag.addEventListener("load", function () {
                    (library.status = status.loaded), callback();
                }),
                tag
            );
        }
        return { load };
    })()),
    (window.theme = window.theme || {}),
    (theme.Header = (function () {
        var selectors2 = {
                body: "body",
                navigation: "#AccessibleNav",
                siteNavHasDropdown: "[data-has-dropdowns]",
                siteNavChildLinks: ".site-nav__child-link",
                siteNavActiveDropdown: ".site-nav--active-dropdown",
                siteNavHasCenteredDropdown: ".site-nav--has-centered-dropdown",
                siteNavCenteredDropdown: ".site-nav__dropdown--centered",
                siteNavLinkMain: ".site-nav__link--main",
                siteNavChildLink: ".site-nav__link--last",
                siteNavDropdown: ".site-nav__dropdown",
                siteHeader: ".site-header",
                headerCartLink: "#HeaderCart",
                disclosureLocale: "[data-disclosure-locale]",
                disclosureCurrency: "[data-disclosure-currency]",
            },
            config = { activeClass: "site-nav--active-dropdown", childLinkClass: "site-nav__child-link", rightDropdownClass: "site-nav__dropdown--right", leftDropdownClass: "site-nav__dropdown--left" },
            cache = {};
        function closeSearchMobileDropdown() {
            var header_toggle_search_btn = document.querySelector(".header-search-button.active");
            header_toggle_search_btn && header_toggle_search_btn.classList.remove("active");
            var searchDropdown = document.querySelector(".search-form__container.show_form");
            searchDropdown && (searchDropdown.classList.remove("show_form"), document.querySelector("body").classList.remove("show_overlay"), document.querySelector("body").classList.remove("show_search_overlay"));
        }
        function closeCartDrawer() {
            var Drawer = document.querySelector(".Drawer.show");
            Drawer && (Drawer.classList.remove("show"), document.querySelector("body").classList.remove("show_overlay"));
        }
        function init() {
            const pursuitAppHeight = () => {
                document.documentElement.style.setProperty("--app-height", `${window.innerHeight}px`);
            };
            window.addEventListener("resize", pursuitAppHeight),
                pursuitAppHeight(),
                cacheSelectors(),
                styleDropdowns(document.querySelectorAll(selectors2.siteNavHasDropdown)),
                positionFullWidthDropdowns(),
                cache.search_categories_menu_parent && cache.search_categories_menu_parent.addEventListener("click", submenuParentClickHandler),
                cache.customer_nav_dropdown_parent && cache.customer_nav_dropdown_parent.addEventListener("click", submenuParentClickHandler),
                cache.parents.forEach(function (element) {
                    element.addEventListener("click", submenuParentClickHandler);
                }),
                cache.siteNavChildLink.forEach(function (element) {
                    element.addEventListener("focusout", submenuFocusoutHandler);
                }),
                cache.topLevel.forEach(function (element) {
                    element.addEventListener("focus", hideDropdown);
                }),
                cache.subMenuLinks.forEach(function (element) {
                    element.addEventListener("click", stopImmediatePropagation);
                }),
                window.addEventListener("resize", resizeHandler);
            var nav_bar = document.querySelector(".site-header__mobile-nav");
            if (nav_bar) {
                let closeSearchDropdown2 = function () {
                    var search_bar__interior = document.querySelector(".search-bar__interior"),
                        searchPopoverEl = document.querySelector(".predictive-search-wrapper--drawer"),
                        searchBarElement = document.querySelector("form.search-bar__form");
                    search_bar__interior &&
                        searchPopoverEl &&
                        searchBarElement &&
                        search_bar__interior.classList.contains("is-fixed") &&
                        document.body.classList.contains("no-mobile-scroll") &&
                        (search_bar__interior.classList.remove("is-fixed"),
                        document.body.classList.remove("no-mobile-scroll"),
                        searchPopoverEl.setAttribute("aria-hidden", "true"),
                        searchBarElement.classList.remove("is-expanded"),
                        document.querySelector("[data-predictive-search-drawer-input]") && document.querySelector("[data-predictive-search-drawer-input]").blur());
                };
                var closeSearchDropdown = closeSearchDropdown2,
                    nav_bar_links = nav_bar.querySelectorAll(".item-has-mega-menu"),
                    menuItems = document.querySelectorAll(".has-mega-menu"),
                    nav_bar_links_child = nav_bar.querySelectorAll(".item-has-mega-menu > a"),
                    nav_bar_links_dropdown = nav_bar.querySelectorAll(".nav-dropdown .has-mega-menu"),
                    nav_bar_links_dropdown_child = nav_bar.querySelectorAll(".nav-dropdown .has-mega-menu > a");
                if (
                    (nav_bar_links_child.forEach(function (link) {
                        link.addEventListener("touchend", function (e) {
                            console.log("here");
                            var parentItem = e.target.closest("li");
                            parentItem.classList.contains("visible")
                                ? parentItem.classList.remove("visible")
                                : (e.preventDefault(),
                                  e.stopPropagation(),
                                  nav_bar_links.forEach(function (item) {
                                      item.classList.remove("visible");
                                  }),
                                  parentItem.classList.toggle("visible"),
                                  document.addEventListener(
                                      "touchend",
                                      function (event) {
                                          event.target.closest(".navigation_wrapper") ||
                                              nav_bar_links.forEach(function (item) {
                                                  item.classList.remove("visible");
                                              });
                                      },
                                      { once: !0 }
                                  ));
                        });
                    }),
                    nav_bar_links_dropdown_child.forEach(function (link) {
                        link.addEventListener("touchend", function (e) {
                            var parentItem = e.target.closest("li");
                            parentItem.classList.contains("visible")
                                ? parentItem.classList.remove("visible")
                                : (e.preventDefault(),
                                  e.stopPropagation(),
                                  nav_bar_links_dropdown.forEach(function (item) {
                                      item.classList.remove("visible");
                                  }),
                                  parentItem.classList.toggle("visible"),
                                  document.addEventListener(
                                      "touchend",
                                      function (event) {
                                          event.target.closest(".navigation_wrapper") ||
                                              (nav_bar_links.forEach(function (item) {
                                                  item.classList.remove("visible");
                                              }),
                                              nav_bar_links_dropdown.forEach(function (item) {
                                                  item.classList.remove("visible");
                                              }));
                                      },
                                      { once: !0 }
                                  ));
                        });
                    }),
                    nav_bar_links.length)
                )
                    var hi = new SV.HoverIntent(nav_bar_links, {
                        onEnter: function (targetItem) {
                            targetItem.classList.add("visible"), closeSearchDropdown2(), hideDropdown();
                        },
                        onExit: function (targetItem) {
                            targetItem.classList.remove("visible");
                            var targetItemLinks = targetItem.querySelectorAll(".link");
                            targetItemLinks.length &&
                                targetItemLinks.forEach(function (link, index) {
                                    link.blur();
                                });
                        },
                        exitDelay: 300,
                        interval: 100,
                        sensitivity: 7,
                    });
                if (menuItems.length)
                    var hi = new SV.HoverIntent(menuItems, {
                        onEnter: function (targetItem) {
                            targetItem.classList.add("visible"), closeSearchDropdown2(), hideDropdown();
                        },
                        onExit: function (targetItem) {
                            targetItem.classList.remove("visible");
                        },
                        exitDelay: 300,
                        interval: 100,
                        sensitivity: 7,
                    });
            }
            var headerCartLink = document.querySelector(selectors2.headerCartLink);
            headerCartLink &&
                headerCartLink.addEventListener("click", function (e) {
                    e.preventDefault();
                    var link_type = this.getAttribute("data-link-type");
                    if (link_type == "drawer") {
                        closeSearchMobileDropdown(), document.querySelector(".js-menu--is-open") && theme.MobileNav.closeMobileNav();
                        var card_drawer = document.querySelector("#sidebar-cart");
                        card_drawer &&
                            (card_drawer.classList.add("show"),
                            document.querySelector("body").classList.add("show_overlay"),
                            card_drawer.addEventListener(
                                "transitionend",
                                () => {
                                    card_drawer.focus(), slate.a11y.trapFocus({ container: card_drawer, elementToFocus: card_drawer });
                                },
                                { once: !0 }
                            ));
                    } else window.location.href = window.routes.cartUrl;
                });
            var search_product_type_Dropdown = document.querySelector("#search-product-type");
            search_product_type_Dropdown &&
                search_product_type_Dropdown.addEventListener("click", function (e) {
                    e.preventDefault();
                    var el = e.target,
                        search_product_type_Dropdown2 = el.closest("#search-product-type"),
                        search_categories_menuParent = el.closest("[data-search-form-container]"),
                        search_labelEl = search_categories_menuParent.querySelector(".search_categories_button__label"),
                        value = el.getAttribute("data-value");
                    search_product_type_Dropdown2.setAttribute("data-search-type", value), search_labelEl && (search_labelEl.innerHTML = value);
                    var inputElement = search_categories_menuParent.querySelector("[data-predictive-search-drawer-input]");
                    inputElement && inputElement.value !== "" && inputElement.dispatchEvent(new Event("keyup", { bubbles: !0 }));
                });
            var header_toggle_search_btn = document.querySelector(".header-search-button");
            header_toggle_search_btn &&
                (header_toggle_search_btn.addEventListener("click", function (e) {
                    e.preventDefault(), document.querySelector(".js-menu--is-open") && theme.MobileNav.closeMobileNav(), closeCartDrawer();
                    var btn_parent = this.closest(".search-bar__interior"),
                        searchDropdown = btn_parent.querySelector(".search-form__container");
                    searchDropdown &&
                        (this.classList.contains("active")
                            ? (searchDropdown.classList.remove("show_form"),
                              this.classList.remove("active"),
                              document.querySelector("body").classList.remove("show_overlay"),
                              document.querySelector("body").classList.remove("show_search_overlay"))
                            : (searchDropdown.classList.add("show_form"), this.classList.add("active"), document.querySelector("body").classList.add("show_overlay"), document.querySelector("body").classList.add("show_search_overlay")));
                }),
                document.addEventListener("click", function (e) {
                    var el = e.target;
                    if ((document.querySelector(".show_search_overlay"), el.classList.contains("search-bar__interior") || el.closest(".search-bar__interior"))) return !1;
                    theme.Header.closeSearchMobileDropdown();
                }));
            var search_submit_btn = document.querySelector(selectors2.siteHeader).querySelector(".search-button__submit");
            search_submit_btn &&
                search_submit_btn.addEventListener("click", function (e) {
                    e.preventDefault();
                    var form = this.closest(".search-form__container"),
                        formValue = form.querySelector(".search-form__input").value,
                        searchFilterEl = form.querySelector("#search-product-type"),
                        formProductType = "*";
                    searchFilterEl && (formProductType = searchFilterEl.getAttribute("data-search-type"));
                    var productQuery = "" + formValue + "*" + (formProductType !== "" ? "&product_type:" + formProductType : ""),
                        formAction = window.routes.searchUrl + "?q=" + productQuery + "&type=product";
                    window.location.href = formAction;
                });
            var enable_live_search = document.querySelector(selectors2.siteHeader).getAttribute("data-enable_live_search");
            enable_live_search == "true" && new theme.SearchBar(document.querySelector(".search-bar__interior"));
            var enable_overlap_header = document.querySelector(selectors2.siteHeader).getAttribute("data-enable_overlap_header");
            enable_overlap_header == "false" &&
                document.querySelector(".shopify-section-header") &&
                (document.querySelector(".shopify-section-header").classList.add("showAlternateHeader"),
                document.querySelector(".shopify-section-header").classList.add("no-overlap"),
                document.querySelector("body").classList.add("no-overlap-header"));
            var enable_sticky_header = document.querySelector(selectors2.siteHeader).getAttribute("data-enable_sticky_header");
            if (enable_sticky_header == "true") {
                const headerEl = document.querySelector(".shopify-section-header");
                headerEl &&
                    window.addEventListener("scroll", function () {
                        var window_scrollY = window.scrollY;
                        window_scrollY > 10 ? headerEl.classList.add("is_sticky") : headerEl.classList.remove("is_sticky");
                    });
            }
            cache.localeDisclosure.length &&
                cache.localeDisclosure.forEach(function (item, index) {
                    new theme.Disclosure(item);
                }),
                cache.currencyDisclosure.length &&
                    cache.currencyDisclosure.forEach(function (item, index) {
                        new theme.Disclosure(item);
                    });
        }
        function stopImmediatePropagation(event) {
            event.stopImmediatePropagation();
        }
        function cacheSelectors() {
            var navigation = document.querySelector(selectors2.navigation),
                search_categories_menu = document.querySelector(".search_categories_menu"),
                customer_nav_dropdown = document.querySelector(".customer_nav_dropdown__wrapper");
            (cache = {
                nav: navigation,
                topLevel: document.querySelectorAll(selectors2.siteNavLinkMain),
                parents: navigation.querySelectorAll(selectors2.siteNavHasDropdown),
                search_categories_menu_parent: search_categories_menu,
                customer_nav_dropdown_parent: customer_nav_dropdown,
                subMenuLinks: document.querySelectorAll(selectors2.siteNavChildLinks),
                activeDropdown: document.querySelector(selectors2.siteNavActiveDropdown),
                siteHeader: document.querySelector(selectors2.siteHeader),
                siteNavChildLink: document.querySelectorAll(selectors2.siteNavChildLink),
            }),
                (cache.localeDisclosure = cache.siteHeader.querySelectorAll(selectors2.disclosureLocale)),
                (cache.currencyDisclosure = cache.siteHeader.querySelectorAll(selectors2.disclosureCurrency));
        }
        function showDropdown(element) {
            element.classList.add(config.activeClass),
                cache.activeDropdown && hideDropdown(),
                (cache.activeDropdown = element),
                element.querySelector(selectors2.siteNavLinkMain).setAttribute("aria-expanded", "true"),
                setTimeout(function () {
                    window.addEventListener("keyup", keyUpHandler), document.body.addEventListener("click", hideDropdown);
                }, 250);
        }
        function hideDropdown() {
            cache.activeDropdown &&
                (cache.activeDropdown.querySelector(selectors2.siteNavLinkMain).setAttribute("aria-expanded", "false"),
                cache.activeDropdown.classList.remove(config.activeClass),
                (cache.activeDropdown = document.querySelector(selectors2.siteNavActiveDropdown)),
                window.removeEventListener("keyup", keyUpHandler),
                document.body.removeEventListener("click", hideDropdown));
        }
        function styleDropdowns(dropdownListItems) {
            var mainMenuDropdowns = document.querySelectorAll(".nav-dropdown");
            mainMenuDropdowns.length &&
                mainMenuDropdowns.forEach(function (item, index) {
                    item.classList.remove("right_side"), overlapDropdown(item) ? item.classList.add("right_side") : item.classList.remove("right_side");
                }),
                dropdownListItems.forEach(function (item) {
                    var dropdownLi = item.querySelector(selectors2.siteNavDropdown);
                    dropdownLi &&
                        (isRightOfLogo(item)
                            ? (dropdownLi.classList.remove(config.leftDropdownClass), dropdownLi.classList.add(config.rightDropdownClass))
                            : (dropdownLi.classList.remove(config.rightDropdownClass), dropdownLi.classList.add(config.leftDropdownClass)));
                });
        }
        function overlapDropdown(item) {
            var rect = item.getBoundingClientRect(),
                rightOffset = rect.right,
                headerWidth = Math.floor(cache.siteHeader.offsetWidth);
            return rightOffset > headerWidth;
        }
        function isRightOfLogo(item) {
            var rect = item.getBoundingClientRect(),
                win = item.ownerDocument.defaultView,
                leftOffset = rect.left + win.pageXOffset,
                headerWidth = Math.floor(cache.siteHeader.offsetWidth) / 2;
            return leftOffset > headerWidth;
        }
        function positionFullWidthDropdowns() {
            document.querySelectorAll(selectors2.siteNavHasCenteredDropdown).forEach(function (el) {
                var fullWidthDropdown = el.querySelector(selectors2.siteNavCenteredDropdown),
                    fullWidthDropdownOffset = el.offsetTop + 41;
                fullWidthDropdown.style.top = fullWidthDropdownOffset + "px";
            });
        }
        function keyUpHandler(event) {
            event.keyCode === 27 && hideDropdown();
        }
        function resizeHandler() {
            adjustStyleAndPosition();
        }
        function submenuParentClickHandler(event) {
            var element = event.currentTarget;
            element.classList.contains(config.activeClass) ? hideDropdown() : showDropdown(element);
        }
        function submenuFocusoutHandler() {
            setTimeout(function () {
                document.activeElement.classList.contains(config.childLinkClass) || !cache.activeDropdown || hideDropdown();
            });
        }
        var adjustStyleAndPosition = theme.Helpers.debounce(function () {
            styleDropdowns(document.querySelectorAll(selectors2.siteNavHasDropdown)), positionFullWidthDropdowns();
        }, 50);
        function unload() {
            cache.topLevel.forEach(function (element) {
                element.removeEventListener("focus", hideDropdown);
            }),
                cache.subMenuLinks.forEach(function (element) {
                    element.removeEventListener("click", stopImmediatePropagation);
                }),
                cache.search_categories_menu_parent && cache.search_categories_menu_parent.removeEventListener("click", submenuParentClickHandler),
                cache.customer_nav_dropdown_parent && cache.customer_nav_dropdown_parent.removeEventListener("click", submenuParentClickHandler),
                cache.parents.forEach(function (element) {
                    element.removeEventListener("click", submenuParentClickHandler);
                }),
                cache.siteNavChildLink.forEach(function (element) {
                    element.removeEventListener("focusout", submenuFocusoutHandler);
                }),
                window.removeEventListener("resize", resizeHandler),
                window.removeEventListener("keyup", keyUpHandler),
                document.body.removeEventListener("click", hideDropdown);
        }
        return { init, unload, closeCartDrawer, closeSearchMobileDropdown };
    })()),
    (window.theme = window.theme || {}),
    (theme.MobileNav = (function () {
        var classes = {
                mobileNavOpenIcon: "mobile-nav--open",
                mobileNavCloseIcon: "mobile-nav--close",
                navLinkWrapper: "mobile-nav__item",
                navLink: "mobile-nav__link",
                subNavLink: "mobile-nav__sublist-link",
                return: "mobile-nav__return-btn",
                subNavActive: "is-active",
                subNavClosing: "is-closing",
                navOpen: "js-menu--is-open",
                subNavShowing: "sub-nav--is-open",
                thirdNavShowing: "third-nav--is-open",
                fourthNavShowing: "fourth-nav--is-open",
                subNavToggleBtn: "js-toggle-submenu",
            },
            cache = {},
            isTransitioning,
            activeSubNav,
            activeTrigger,
            menuLevel = 1,
            mediumUpQuery = "(min-width: " + theme.breakpoints.medium + "px)",
            mql = window.matchMedia(mediumUpQuery);
        function init() {
            cacheSelectors(),
                cache.mobileNavToggle && cache.mobileNavToggle.addEventListener("click", toggleMobileNav),
                cache.subNavToggleBtns.forEach(function (element) {
                    element.addEventListener("click", toggleSubNav);
                }),
                cache.mobileMenuOverlay.addEventListener("click", closeMobileNav),
                mql.addListener(initBreakpoints);
        }
        function initBreakpoints() {
            mql.matches && cache.mobileNavContainer.classList.contains(classes.navOpen) && closeMobileNav();
        }
        function toggleMobileNav() {
            var mobileNavIsOpen = cache.mobileNavToggle.classList.contains(classes.mobileNavCloseIcon);
            (document.scrollingElement.scrollTop = 0),
                setTimeout(function () {
                    window.scrollTo({ top: 0, behavior: "instant" }), (document.scrollingElement.scrollTop = 0);
                }, 100),
                setTimeout(function () {
                    mobileNavIsOpen ? closeMobileNav() : openMobileNav();
                }, 200);
        }
        function cacheSelectors() {
            cache = {
                pageContainer: document.querySelector("#PageContainer"),
                siteHeader: document.querySelector(".site-header"),
                mobileNavToggle: document.querySelector(".js-mobile-nav-toggle"),
                mobileNavContainer: document.querySelector(".mobile-nav-wrapper"),
                mobileNav: document.querySelector("#MobileNav"),
                sectionHeader: document.querySelector(".shopify-section-header"),
                subNavToggleBtns: document.querySelectorAll("." + classes.subNavToggleBtn),
                bodyElem: document.querySelector("body"),
                mobileMenuOverlay: document.querySelector(".mobile_menu_overlay"),
            };
        }
        function openMobileNav() {
            theme.Header.closeSearchMobileDropdown(), theme.Header.closeCartDrawer();
            var translateHeaderHeight = cache.siteHeader.offsetHeight;
            theme.Helpers.prepareTransition(cache.mobileNavContainer), cache.mobileNavContainer.classList.add(classes.navOpen), cache.bodyElem.classList.add(classes.navOpen);
            var mobileNavHeight = cache.mobileNav.offsetHeight,
                mobileNavDropdownsArr = cache.mobileNav.querySelectorAll(".mobile-nav__dropdown");
            mobileNavDropdownsArr.length &&
                mobileNavDropdownsArr.forEach(function (item, index) {
                    var itemHeight = item.offsetHeight;
                    itemHeight > mobileNavHeight && (mobileNavHeight = itemHeight);
                }),
                (cache.mobileNav.style.minHeight = mobileNavHeight + "px"),
                (cache.mobileNavContainer.style.top = translateHeaderHeight + "px"),
                slate.a11y.trapFocus({ container: cache.sectionHeader, elementToFocus: cache.mobileNavToggle }),
                cache.mobileNavToggle.classList.add(classes.mobileNavCloseIcon),
                cache.mobileNavToggle.classList.remove(classes.mobileNavOpenIcon),
                cache.mobileNavToggle.setAttribute("aria-expanded", !0),
                window.addEventListener("keyup", keyUpHandler);
        }
        function keyUpHandler(event) {
            event.which === 27 && closeMobileNav();
        }
        function closeMobileNav() {
            theme.Helpers.prepareTransition(cache.mobileNavContainer),
                cache.mobileNavContainer.classList.remove(classes.navOpen),
                cache.mobileNavContainer.classList.remove(classes.subNavShowing),
                cache.mobileNavContainer.classList.remove(classes.thirdNavShowing),
                cache.mobileNavContainer.classList.remove(classes.fourthNavShowing),
                cache.bodyElem.classList.remove(classes.navOpen),
                slate.a11y.trapFocus({ container: document.querySelector("html"), elementToFocus: document.body }),
                cache.mobileNavContainer.addEventListener("transitionend", mobileNavRemoveTrapFocus, { once: !0 }),
                cache.mobileNavToggle.classList.add(classes.mobileNavOpenIcon),
                cache.mobileNavToggle.classList.remove(classes.mobileNavCloseIcon),
                cache.mobileNavToggle.setAttribute("aria-expanded", !1),
                cache.mobileNavToggle.focus(),
                window.removeEventListener("keyup", keyUpHandler),
                window.scrollTo(0, 0);
        }
        function mobileNavRemoveTrapFocus() {
            slate.a11y.removeTrapFocus({ container: cache.mobileNav });
        }
        function toggleSubNav(event) {
            if (!isTransitioning) {
                var toggleBtn = event.currentTarget,
                    isReturn = toggleBtn.classList.contains(classes.return);
                if (((isTransitioning = !0), isReturn)) {
                    var subNavToggleBtn = document.querySelectorAll("." + classes.subNavToggleBtn + "[data-level='" + (menuLevel - 1) + "']");
                    subNavToggleBtn.forEach(function (element) {
                        element.classList.remove(classes.subNavActive);
                    }),
                        activeTrigger && activeTrigger.classList.remove(classes.subNavActive);
                } else toggleBtn.classList.add(classes.subNavActive);
                (activeTrigger = toggleBtn), goToSubnav(toggleBtn.getAttribute("data-target"));
            }
        }
        function goToSubnav(target) {
            var targetMenu = target ? document.querySelector('.mobile-nav__dropdown[data-parent="' + target + '"]') : cache.mobileNav;
            (menuLevel = targetMenu.dataset.level ? Number(targetMenu.dataset.level) : 1), activeSubNav && (theme.Helpers.prepareTransition(activeSubNav), activeSubNav.classList.add(classes.subNavClosing)), (activeSubNav = targetMenu);
            var translateMenuHeight = targetMenu.offsetHeight,
                openNavClass = menuLevel > 2 && menuLevel != 4 ? classes.thirdNavShowing : classes.subNavShowing;
            menuLevel == 4 && (openNavClass = classes.fourthNavShowing),
                cache.mobileNavContainer.classList.remove(classes.thirdNavShowing),
                cache.mobileNavContainer.classList.remove(classes.fourthNavShowing),
                cache.mobileNavContainer.classList.add(openNavClass),
                target || cache.mobileNavContainer.classList.remove(classes.thirdNavShowing, classes.fourthNavShowing, classes.subNavShowing);
            var container = menuLevel === 1 ? cache.sectionHeader : targetMenu;
            cache.mobileNavContainer.addEventListener("transitionend", trapMobileNavFocus, { once: !0 });
            function trapMobileNavFocus() {
                cache.mobileNavContainer.removeEventListener("transitionend", trapMobileNavFocus), (isTransitioning = !1);
            }
            activeSubNav.classList.remove(classes.subNavClosing);
        }
        function unload() {
            mql.removeListener(initBreakpoints);
        }
        return { init, unload, closeMobileNav };
    })()),
    (window.Modals = (function () {
        function Modal(id, name, options) {
            var defaults = { close: ".js-modal-close", open: ".js-modal-open-" + name, openClass: "modal--is-active", closeModalOnClick: !1 };
            if (((this.modal = document.getElementById(id)), !this.modal)) return !1;
            (this.nodes = { parents: [document.querySelector("html"), document.body] }),
                (this.config = Object.assign(defaults, options)),
                (this.modalIsOpen = !1),
                (this.focusOnOpen = this.config.focusOnOpen ? document.getElementById(this.config.focusOnOpen) : this.modal),
                (this.openElement = document.querySelector(this.config.open)),
                this.init();
        }
        return (
            (Modal.prototype.init = function () {
                this.openElement.addEventListener("click", this.open.bind(this)), this.modal.querySelector(this.config.close).addEventListener("click", this.closeModal.bind(this));
            }),
            (Modal.prototype.open = function (evt) {
                var self2 = this,
                    externalCall = !1;
                this.modalIsOpen ||
                    (evt ? evt.preventDefault() : (externalCall = !0),
                    evt && evt.stopPropagation && evt.stopPropagation(),
                    this.modalIsOpen && !externalCall && this.closeModal(),
                    this.modal.classList.add(this.config.openClass),
                    this.nodes.parents.forEach(function (node) {
                        node.classList.add(self2.config.openClass), node.classList.add("show_overlay");
                    }),
                    (this.modalIsOpen = !0),
                    slate.a11y.trapFocus({ container: this.modal, elementToFocus: this.focusOnOpen }),
                    this.bindEvents());
            }),
            (Modal.prototype.closeModal = function () {
                if (this.modalIsOpen) {
                    document.activeElement.blur(), this.modal.classList.remove(this.config.openClass);
                    var self2 = this;
                    this.nodes.parents.forEach(function (node) {
                        node.classList.remove(self2.config.openClass), node.classList.remove("show_overlay");
                    }),
                        (this.modalIsOpen = !1),
                        slate.a11y.removeTrapFocus({ container: this.modal }),
                        this.openElement.focus(),
                        this.unbindEvents();
                }
            }),
            (Modal.prototype.bindEvents = function () {
                (this.keyupHandler = this.keyupHandler.bind(this)), (this.clickHandler = this.clickHandler.bind(this)), document.body.addEventListener("keyup", this.keyupHandler), document.body.addEventListener("click", this.clickHandler);
            }),
            (Modal.prototype.unbindEvents = function () {
                document.body.removeEventListener("keyup", this.keyupHandler), document.body.removeEventListener("click", this.clickHandler);
            }),
            (Modal.prototype.keyupHandler = function (event) {
                event.keyCode === 27 && this.closeModal();
            }),
            (Modal.prototype.clickHandler = function (event) {
                this.config.closeModalOnClick && !this.modal.contains(event.target) && this.closeModal();
            }),
            Modal
        );
    })()),
    (theme.Slideshow = (function () {
        var selectors2 = {
                button: "[data-slider-button]",
                indicator: "[data-slider-indicator]",
                indicators: "[data-slider-indicators]",
                pause: "[data-slider-pause]",
                slider: "[data-slider]",
                sliderItem: "[data-slider-item]",
                sliderItemLink: "[data-slider-item-link]",
                sliderTrack: "[data-slider-track]",
                sliderContainer: "[data-slider-container]",
            },
            classes = {
                isPaused: "slideshow__pause--is-paused",
                indicator: "slider-indicators__item",
                indicatorActive: "slick-active",
                sliderInitialized: "slick-initialized",
                slideActive: "slideshow__slide--active",
                slideClone: "slick-cloned",
            },
            attributes = { buttonNext: "data-slider-button-next" };
        function Slideshow(container, options) {
            (this.container = container), (this.slider = this.container.querySelector(selectors2.slider));
            var self2 = this;
            this.slider &&
                ((this.eventHandlers = {}),
                (this.lastSlide = 0),
                (this.slideIndex = 0),
                (this.sliderContainer = null),
                (this.slides = []),
                (this.options = Object.assign({}, { autoplay: !1, canUseKeyboardArrows: !0, canUseTouchEvents: !1, slideActiveClass: classes.slideActive, slideInterval: 0, slidesToShow: 0, slidesToScroll: 1, type: "fade" }, options)),
                (this.sliderContainer = this.slider.querySelector(selectors2.sliderContainer)),
                (this.adaptHeight = this.sliderContainer.getAttribute("data-adapt-height") === "true"),
                (this.slides = Array.from(this.sliderContainer.querySelectorAll(selectors2.sliderItem))),
                (this.lastSlide = this.slides.length - 1),
                (this.buttons = this.container.querySelectorAll(selectors2.button)),
                (this.indicators = this.container.querySelectorAll(selectors2.indicators)),
                !(this.slides.length <= 1) &&
                    ((this.timeout = 250),
                    this.options.autoplay && this.startAutoplay(),
                    this.adaptHeight && this.setSlideshowHeight(),
                    this.checkSlideshowHeight(),
                    this.options.type === "slide"
                        ? ((this.isFirstSlide = !1),
                          (this.isLastSlide = !1),
                          (this.sliderItemWidthTotal = 0),
                          (this.sliderTrack = this.slider.querySelector(selectors2.sliderTrack)),
                          (this.sliderItemWidthTotal = 0),
                          theme.Helpers.promiseStylesheet().then(
                              function () {
                                  this._setupSlideType();
                              }.bind(this)
                          ))
                        : this.setupSlider(0),
                    this._setupEventHandlers()));
        }
        return (
            (Slideshow.prototype = Object.assign({}, Slideshow.prototype, {
                previousSlide: function () {
                    this._move();
                },
                nextSlide: function () {
                    this._move("next");
                },
                setSlide: function (index) {
                    this._setPosition(Number(index));
                },
                startAutoplay: function () {
                    (this.isAutoPlaying = !0),
                        window.clearTimeout(this.autoTimeOut),
                        (this.autoTimeOut = window.setTimeout(
                            function () {
                                var nextSlideIndex = this._getNextSlideIndex("next");
                                this._setPosition(nextSlideIndex);
                            }.bind(this),
                            this.options.slideInterval
                        ));
                },
                stopAutoplay: function () {
                    (this.isAutoPlaying = !1), window.clearTimeout(this.autoTimeOut);
                },
                setupSlider: function (index) {
                    (this.slideIndex = index), this.indicators.length && this._setActiveIndicator(index), this._setupActiveSlide(index);
                },
                destroy: function () {
                    this.adaptHeight && window.removeEventListener("resize", this.eventHandlers.debounceResize),
                        this.container.removeEventListener("focus", this.eventHandlers.focus, !0),
                        this.slider.removeEventListener("focusin", this.eventHandlers.focusIn, !0),
                        this.slider.removeEventListener("focusout", this.eventHandlers.focusOut, !0),
                        this.container.removeEventListener("blur", this.eventHandlers.blur, !0),
                        this.buttons &&
                            this.buttons.forEach(
                                function (button) {
                                    button.removeEventListener("click", this.eventHandlers.clickButton);
                                }.bind(this)
                            ),
                        this.indicators.forEach(function (indicatorWrapper) {
                            indicatorWrapper.childNodes.forEach(function (indicator) {
                                indicator.firstElementChild.removeEventListener("click", this.eventHandlers.onClickIndicator), indicator.firstElementChild.removeEventListener("keydown", this.eventHandlers.onKeydownIndicator);
                            }, this);
                        }, this),
                        this.options.type === "slide" &&
                            (window.removeEventListener("resize", this.eventHandlers.debounceResizeSlideIn), this.touchEvents && this.options.canUseTouchEvents && (this.touchEvents.destroy(), (this.touchEvents = null)));
                },
                _setupEventHandlers: function () {
                    (this.eventHandlers.focus = this._onFocus.bind(this)),
                        (this.eventHandlers.focusIn = this._onFocusIn.bind(this)),
                        (this.eventHandlers.focusOut = this._onFocusOut.bind(this)),
                        (this.eventHandlers.blur = this._onBlur.bind(this)),
                        (this.eventHandlers.keyUp = this._onKeyUp.bind(this)),
                        (this.eventHandlers.clickButton = this._onClickButton.bind(this)),
                        (this.eventHandlers.onClickIndicator = this._onClickIndicator.bind(this)),
                        (this.eventHandlers.onKeydownIndicator = this._onKeydownIndicator.bind(this)),
                        (this.eventHandlers.onClickPause = this._onClickPause.bind(this)),
                        this.adaptHeight &&
                            ((this.eventHandlers.debounceResize = theme.Helpers.debounce(
                                function () {
                                    this.setSlideshowHeight();
                                }.bind(this),
                                50
                            )),
                            window.addEventListener("resize", this.eventHandlers.debounceResize)),
                        this.checkSlideshowHeight(),
                        this.container.addEventListener("focus", this.eventHandlers.focus, !0),
                        this.slider.addEventListener("focusin", this.eventHandlers.focusIn, !0),
                        this.slider.addEventListener("focusout", this.eventHandlers.focusOut, !0),
                        this.container.addEventListener("blur", this.eventHandlers.blur, !0),
                        this.buttons &&
                            this.buttons.forEach(
                                function (button) {
                                    button.addEventListener("click", this.eventHandlers.clickButton);
                                }.bind(this)
                            ),
                        this.indicators.forEach(function (indicatorWrapper) {
                            indicatorWrapper.childNodes.forEach(function (indicator) {
                                indicator.firstElementChild.addEventListener("click", this.eventHandlers.onClickIndicator), indicator.firstElementChild.addEventListener("keydown", this.eventHandlers.onKeydownIndicator);
                            }, this);
                        }, this),
                        this.options.type === "slide" &&
                            ((this.eventHandlers.debounceResizeSlideIn = theme.Helpers.debounce(
                                function () {
                                    (this.sliderItemWidthTotal = 0), this._setupSlideType(!0);
                                }.bind(this),
                                50
                            )),
                            window.addEventListener("resize", this.eventHandlers.debounceResizeSlideIn),
                            this.options.canUseTouchEvents && this.options.slidesToScroll < this.slides.length && this._setupTouchEvents());
                    var _this = this,
                        containerHover = new SV.HoverIntent(_this.slides, {
                            onEnter: function (targetItem) {
                                _this.stopAutoplay();
                            },
                            onExit: function (targetItem) {
                                _this.startAutoplay();
                            },
                            exitDelay: 300,
                            interval: 100,
                            sensitivity: 7,
                        });
                },
                _setupTouchEvents: function () {
                    this.touchEvents = new theme.TouchEvents(this.sliderTrack, {
                        start: function () {
                            this._onTouchStart();
                        }.bind(this),
                        move: function (event, direction, difference) {
                            this._onTouchMove(event, direction, difference);
                        }.bind(this),
                        end: function (event, direction, difference) {
                            this._onTouchEnd(event, direction, difference);
                        }.bind(this),
                    });
                },
                _setupSlideType: function (onResize) {
                    (this.sliderItemWidth = Math.floor(this.sliderContainer.offsetWidth / this.options.slidesToShow)),
                        (this.sliderTranslateXMove = this.sliderItemWidth * this.options.slidesToScroll),
                        onResize || this.sliderContainer.classList.add(classes.sliderInitialized),
                        this.slides.forEach(function (sliderItem, index) {
                            var sliderItemLink = sliderItem.querySelector(selectors2.sliderItemLink);
                            (sliderItem.style.width = this.sliderItemWidth + "px"),
                                (this.sliderItemWidthTotal = this.sliderItemWidthTotal + sliderItem.offsetWidth),
                                index < this.options.slidesToShow && sliderItem.classList.add(this.options.slideActiveClass);
                        }, this),
                        (this.sliderTrack.style.width = Math.floor(this.sliderItemWidthTotal) + "px"),
                        (this.sliderTrack.style.transform = "translateX(-0px)"),
                        this.buttons.length && (this.buttons[0].setAttribute("aria-disabled", !0), this.buttons[1].removeAttribute("aria-disabled")),
                        this.indicators.length && this._setActiveIndicator(0);
                },
                _onTouchStart: function () {
                    this.touchStartPosition = this._getTranslateXPosition();
                },
                _onTouchMove: function (event, direction, difference) {
                    var threshold = 80;
                    if (Shopify.designMode && (event.clientX <= threshold || event.clientX >= window.innerWidth - threshold)) {
                        event.target.dispatchEvent(new MouseEvent("mouseup", { bubbles: !0, cancelable: !0 }));
                        return;
                    }
                    (direction !== "left" && direction !== "right") || ((this.touchMovePosition = this.touchStartPosition + difference.xPosition), (this.sliderTrack.style.transform = "translateX(" + this.touchMovePosition + "px"));
                },
                _onTouchEnd: function (event, direction, difference) {
                    var nextTranslateXPosition = 0;
                    if (Object.keys(difference).length !== 0) {
                        var slideDirection = direction === "left" ? "next" : "";
                        direction === "left"
                            ? this._isNextTranslateXLast(this.touchStartPosition)
                                ? (nextTranslateXPosition = this.touchStartPosition)
                                : (nextTranslateXPosition = this.touchStartPosition - this.sliderTranslateXMove)
                            : ((nextTranslateXPosition = this.touchStartPosition + this.sliderTranslateXMove), this._isNextTranslateXFirst(this.touchStartPosition) && (nextTranslateXPosition = 0)),
                            (this.slideIndex = this._getNextSlideIndex(slideDirection)),
                            (this.sliderTrack.style.transition = "transform 500ms ease 0s"),
                            (this.sliderTrack.style.transform = "translateX(" + nextTranslateXPosition + "px"),
                            window.setTimeout(
                                function () {
                                    this.sliderTrack.style.transition = "";
                                }.bind(this),
                                500
                            ),
                            this._verifyFirstLastSlideTranslateX(nextTranslateXPosition),
                            this._postTransitionEnd();
                    }
                },
                _onClickButton: function (event) {
                    if (!(event.detail > 1)) {
                        var button = event.currentTarget,
                            nextButton = button.hasAttribute(attributes.buttonNext);
                        (this.options.type === "slide" && button.getAttribute("aria-disabled") === "true") || (this.options.autoplay && this.isAutoPlaying && this.stopAutoplay(), nextButton ? this.nextSlide() : this.previousSlide());
                    }
                },
                _onClickIndicator: function (event) {
                    event.preventDefault(),
                        !event.target.classList.contains(classes.indicatorActive) &&
                            (this.options.autoplay && this.isAutoPlaying && this.stopAutoplay(), (this.slideIndex = Number(event.target.dataset.slideNumber)), this.goToSlideByIndex(this.slideIndex));
                },
                goToSlideByIndex: function (index) {
                    if ((this._setPosition(index), this.options.type === "slide" && this.sliderTrack)) {
                        this.sliderTrack.style.transition = "transform 500ms ease 0s";
                        var newPosition = index * this.slides[0].offsetWidth;
                        (this.sliderTrack.style.transform = "translateX(-" + newPosition + "px)"),
                            this.options.slidesToShow > 1 && (this._verifyFirstLastSlideTranslateX(newPosition), this.buttons.length && this._disableArrows(), this._setupMultipleActiveSlide(index, index + (this.options.slidesToShow - 1)));
                    }
                },
                _onKeydownIndicator: function (event) {
                    event.keyCode === slate.utils.keyboardKeys.ENTER && (this._onClickIndicator(event), this.slider.focus());
                },
                _onClickPause: function (event) {
                    event.currentTarget.classList.contains(classes.isPaused) ? (event.currentTarget.classList.remove(classes.isPaused), this.startAutoplay()) : (event.currentTarget.classList.add(classes.isPaused), this.stopAutoplay());
                },
                _onFocus: function () {
                    this.container.addEventListener("keyup", this.eventHandlers.keyUp);
                },
                _onFocusIn: function () {
                    this.slider.hasAttribute("aria-live") || (this.options.autoplay && this.isAutoPlaying && this.stopAutoplay(), this.slider.setAttribute("aria-live", "polite"));
                },
                _onBlur: function () {
                    this.container.removeEventListener("keyup", this.eventHandlers.keyUp);
                },
                _onFocusOut: function () {
                    this.slider.removeAttribute("aria-live"),
                        setTimeout(
                            function () {
                                document.activeElement.closest("#" + this.slider.getAttribute("id")) || (this.options.autoplay && !this.isAutoPlaying && this.startAutoplay());
                            }.bind(this),
                            this.timeout
                        );
                },
                _onKeyUp: function (event) {
                    switch (event.keyCode) {
                        case slate.utils.keyboardKeys.LEFTARROW:
                            if (!this.options.canUseKeyboardArrows || (this.options.type === "slide" && this.isFirstSlide)) return;
                            this.previousSlide();
                            break;
                        case slate.utils.keyboardKeys.RIGHTARROW:
                            if (!this.options.canUseKeyboardArrows || (this.options.type === "slide" && this.isLastSlide)) return;
                            this.nextSlide();
                            break;
                        case slate.utils.keyboardKeys.ESCAPE:
                            this.slider.blur();
                            break;
                    }
                },
                _move: function (direction) {
                    if (this.options.type === "slide") (this.slideIndex = this._getNextSlideIndex(direction)), this._moveSlideshow(direction);
                    else {
                        var nextSlideIndex = this._getNextSlideIndex(direction);
                        this._setPosition(nextSlideIndex);
                    }
                },
                _moveSlideshow: function (direction) {
                    this.direction = direction;
                    var valueXToMove = 0,
                        currentTranslateXPosition = this._getTranslateXPosition(),
                        currentActiveSlidesIndex = this._getActiveSlidesIndex(),
                        currentActiveSlidesMinIndex = Math.min.apply(Math, currentActiveSlidesIndex),
                        currentActiveSlidesMaxIndex = Math.max.apply(Math, currentActiveSlidesIndex);
                    (this.nextMinIndex = direction === "next" ? currentActiveSlidesMinIndex + this.options.slidesToShow : currentActiveSlidesMinIndex - this.options.slidesToShow),
                        (this.nextMaxIndex = direction === "next" ? currentActiveSlidesMaxIndex + this.options.slidesToShow : currentActiveSlidesMinIndex - 1),
                        (this.sliderTrack.style.transition = "transform 500ms ease 0s"),
                        direction === "next"
                            ? ((valueXToMove = currentTranslateXPosition - this.sliderTranslateXMove), (this.sliderTrack.style.transform = "translateX(" + valueXToMove + "px)"))
                            : ((valueXToMove = currentTranslateXPosition + this.sliderTranslateXMove), (this.sliderTrack.style.transform = "translateX(" + valueXToMove + "px)")),
                        this._verifyFirstLastSlideTranslateX(valueXToMove),
                        this._postTransitionEnd(),
                        this._setupMultipleActiveSlide(this.nextMinIndex, this.nextMaxIndex);
                },
                _setPosition: function (nextSlideIndex) {
                    (this.slideIndex = nextSlideIndex),
                        this.indicators.length && this._setActiveIndicator(nextSlideIndex),
                        this._setupActiveSlide(nextSlideIndex),
                        this.options.autoplay && this.isAutoPlaying && this.startAutoplay(),
                        this.container.dispatchEvent(new CustomEvent("slider_slide_changed", { detail: nextSlideIndex }));
                },
                _setupActiveSlide: function (index) {
                    this.slides.forEach(function (slide) {
                        slide.classList.remove(this.options.slideActiveClass);
                    }, this),
                        this.slides[index].classList.add(this.options.slideActiveClass);
                },
                _setupMultipleActiveSlide: function (minIndex, maxIndex) {
                    this.slides.forEach(function (slide) {
                        var sliderIndex = Number(slide.getAttribute("data-slider-slide-index")),
                            sliderItemLink = slide.querySelector(selectors2.sliderItemLink);
                        slide.classList.remove(this.options.slideActiveClass),
                            sliderItemLink && sliderItemLink.setAttribute("tabindex", -1),
                            sliderIndex >= minIndex && sliderIndex <= maxIndex && slide.classList.add(this.options.slideActiveClass);
                    }, this);
                },
                _setActiveIndicator: function (index) {
                    this.indicators.forEach(function (indicatorWrapper) {
                        var activeIndicator = indicatorWrapper.querySelector("." + classes.indicatorActive),
                            nextIndicator = indicatorWrapper.childNodes[index];
                        activeIndicator && (activeIndicator.classList.remove(classes.indicatorActive), activeIndicator.firstElementChild.removeAttribute("aria-current")),
                            nextIndicator.classList.add(classes.indicatorActive),
                            nextIndicator.firstElementChild.setAttribute("aria-current", !0);
                    }, this);
                },
                setSlideshowHeight: function () {
                    var minAspectRatio = this.sliderContainer.getAttribute("data-min-aspect-ratio");
                    this.sliderContainer.style.height = document.documentElement.offsetWidth / minAspectRatio + "px";
                },
                checkSlideshowHeight: function () {
                    var sliderContainer = this.sliderContainer,
                        sliderContainerHeight = sliderContainer.offsetHeight,
                        windowWidth = document.documentElement.offsetWidth;
                    if (!sliderContainer.classList.contains("slideshow--adapt") && windowWidth > 749) {
                        var slideSContentArr = sliderContainer.querySelectorAll(".slideshow__text-content");
                        if (slideSContentArr.length) {
                            var maxHeight = 0;
                            slideSContentArr.forEach(function (item, index) {
                                var contentHeight = item.offsetHeight;
                                contentHeight > maxHeight && (maxHeight = contentHeight);
                            }),
                                windowWidth > 749 ? (maxHeight += 350) : (maxHeight += 200),
                                maxHeight > sliderContainerHeight && (sliderContainer.style.minHeight = maxHeight + "px");
                        }
                    } else if (!sliderContainer.classList.contains("mobile-slideshow--adapt") && windowWidth <= 749) {
                        var slideSContentArr = sliderContainer.querySelectorAll(".slideshow__text-content");
                        if (slideSContentArr.length) {
                            var maxHeight = 0;
                            slideSContentArr.forEach(function (item, index) {
                                var contentHeight = item.offsetHeight;
                                contentHeight > maxHeight && (maxHeight = contentHeight);
                            }),
                                windowWidth > 749 ? (maxHeight += 300) : (maxHeight += 200),
                                maxHeight > sliderContainerHeight && (sliderContainer.style.height = maxHeight + "px");
                        }
                    }
                },
                _getNextSlideIndex: function (direction) {
                    var counter = direction === "next" ? 1 : -1;
                    if (direction === "next") {
                        if (this.slideIndex === this.lastSlide) return this.options.type === "slide" ? this.lastSlide : 0;
                    } else if (!this.slideIndex) return this.options.type === "slide" ? 0 : this.lastSlide;
                    return this.slideIndex + counter;
                },
                _getActiveSlidesIndex: function () {
                    var currentActiveSlides = this.slides.filter(function (sliderItem) {
                            if (sliderItem.classList.contains(this.options.slideActiveClass)) return sliderItem;
                        }, this),
                        currentActiveSlidesIndex = currentActiveSlides.map(function (sliderItem) {
                            return Number(sliderItem.getAttribute("data-slider-slide-index"));
                        });
                    return currentActiveSlidesIndex;
                },
                _disableArrows: function () {
                    if (this.buttons.length !== 0) {
                        var previousButton = this.buttons[0],
                            nextButton = this.buttons[1];
                        this.isFirstSlide ? previousButton.setAttribute("aria-disabled", !0) : previousButton.removeAttribute("aria-disabled"),
                            this.isLastSlide ? nextButton.setAttribute("aria-disabled", !0) : nextButton.removeAttribute("aria-disabled");
                    }
                },
                _verifyFirstLastSlideTranslateX: function (translateXValue) {
                    this._isNextTranslateXFirst(translateXValue) ? (this.isFirstSlide = !0) : (this.isFirstSlide = !1), this._isNextTranslateXLast(translateXValue) ? (this.isLastSlide = !0) : (this.isLastSlide = !1);
                },
                _getTranslateXPosition: function () {
                    return Number(this.sliderTrack.style.transform.match(/(-?[0-9]+)/g)[0]);
                },
                _isNextTranslateXFirst: function (translateXValue) {
                    return translateXValue === 0;
                },
                _isNextTranslateXLast: function (translateXValue) {
                    var translateXValueAbsolute = Math.abs(translateXValue),
                        nextTranslateXValue = translateXValueAbsolute + this.sliderTranslateXMove;
                    return nextTranslateXValue >= this.sliderItemWidthTotal;
                },
                _postTransitionEnd: function () {
                    this.buttons.length && this._disableArrows(), this.indicators.length && this._setActiveIndicator(this.slideIndex);
                },
            })),
            Slideshow
        );
    })()),
    (theme.Video = (function () {
        var autoplayCheckComplete = !1,
            playOnClickChecked = !1,
            playOnClick = !1,
            youtubeLoaded = !1,
            videos = {},
            videoPlayers = [],
            videoOptions = {
                ratio: 16 / 9,
                scrollAnimationDuration: 400,
                playerVars: { iv_load_policy: 3, modestbranding: 1, autoplay: 1, playsinline: 1, controls: 0, wmode: "opaque", branding: 0, autohide: 0, rel: 0 },
                events: { onReady: onPlayerReady, onStateChange: onPlayerChange },
            },
            classes = {
                playing: "video-is-playing",
                paused: "video-is-paused",
                loading: "video-is-loading",
                loaded: "video-is-loaded",
                backgroundVideoWrapper: "video-background-wrapper",
                backgroundVideo: "video--background",
                supportsAutoplay: "autoplay",
            },
            selectors2 = { section: ".video-section", videoWrapper: ".video-section-wrapper", fallbackText: ".icon__fallback-text" };
        function init(video) {
            if (video) {
                videos[video.id] = {
                    id: video.id,
                    videoId: video.dataset.id,
                    type: video.dataset.type,
                    status: "background",
                    video,
                    videoWrapper: video.closest(selectors2.videoWrapper),
                    section: video.closest(selectors2.section),
                    controls: 0,
                };
                debugger;
                if ((console.log(youtubeLoaded), console.log("init"), !youtubeLoaded)) {
                    var tag = document.createElement("script");
                    tag.src = "https://www.youtube.com/iframe_api";
                    var firstScriptTag = document.getElementsByTagName("script")[0];
                    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
                }
                playOnClickCheck();
            }
        }
        function customPlayVideo(playerId) {
            (!playOnClickChecked && !playOnClick) || (playerId && typeof videoPlayers[playerId].playVideo == "function" && privatePlayVideo(playerId));
        }
        function pauseVideo(playerId) {
            alert("pauseVideo"), videoPlayers[playerId] && typeof videoPlayers[playerId].pauseVideo == "function" && videoPlayers[playerId].pauseVideo();
        }
        function loadVideos() {
            for (var key in videos) videos.hasOwnProperty(key) && createPlayer(key);
            initEvents(), (youtubeLoaded = !0);
        }
        function editorLoadVideo(key) {
            youtubeLoaded && (createPlayer(key), initEvents());
        }
        function privatePlayVideo(id, clicked) {
            var videoData = videos[id],
                player = videoPlayers[id],
                videoWrapper = videoData.videoWrapper;
            if (playOnClick) setAsPlaying(videoData);
            else if (clicked || autoplayCheckComplete) {
                videoWrapper.classList.remove(classes.loading), setAsPlaying(videoData), player.playVideo();
                return;
            } else player.playVideo();
        }
        function setAutoplaySupport(supported) {
            var supportClass = classes.supportsAutoplay;
            document.documentElement.classList.remove(classes.supportsAutoplay), document.documentElement.classList.add(supportClass), supported || (playOnClick = !0), (autoplayCheckComplete = !0);
        }
        function playOnClickCheck() {
            playOnClickChecked || (playOnClick && setAutoplaySupport(!1), (playOnClickChecked = !0));
        }
        function onPlayerReady(evt) {
            evt.target.setPlaybackQuality("hd1080");
            var videoData = getVideoOptions(evt),
                videoTitle = evt.target.getVideoData().title;
            playOnClickCheck(),
                document.getElementById(videoData.id).setAttribute("tabindex", "-1"),
                sizeBackgroundVideos(),
                videoData.type === "background" && (evt.target.mute(), privatePlayVideo(videoData.id)),
                videoData.videoWrapper.classList.add(classes.loaded);
        }
        function onPlayerChange(evt) {
            var videoData = getVideoOptions(evt);
            switch (
                (videoData.status === "background" &&
                    !autoplayCheckComplete &&
                    (evt.data === YT.PlayerState.PLAYING || evt.data === YT.PlayerState.BUFFERING) &&
                    (setAutoplaySupport(!0), (autoplayCheckComplete = !0), videoData.videoWrapper.classList.remove(classes.loading)),
                evt.data)
            ) {
                case YT.PlayerState.ENDED:
                    setAsFinished(videoData);
                    break;
                case YT.PlayerState.PAUSED:
                    setTimeout(function () {
                        evt.target.getPlayerState() === YT.PlayerState.PAUSED && setAsPaused(videoData);
                    }, 200);
                    break;
            }
        }
        function setAsFinished(videoData) {
            videoPlayers[videoData.id].seekTo(0);
        }
        function setAsPlaying(videoData) {
            var videoWrapper = videoData.videoWrapper;
            videoWrapper.classList.remove(classes.loading), videoData.status !== "background" && (document.getElementById(videoData.id).setAttribute("tabindex", "0"), setTimeout(function () {}, videoOptions.scrollAnimationDuration));
        }
        function setAsPaused(videoData) {
            var videoWrapper = videoData.videoWrapper;
            videoWrapper.classList.remove(classes.playing);
        }
        function getVideoOptions(evt) {
            var id = evt.target.getIframe().id;
            return videos[id];
        }
        function toggleExpandVideo(playerId, expand) {
            var video = videos[playerId],
                elementTop = video.videoWrapper.getBoundingClientRect().top + window.pageYOffset,
                offset = 0,
                newHeight = 0;
            if (expand) {
                if (
                    ((newHeight = video.videoWrapper.offsetWidth / videoOptions.ratio),
                    (offset = (window.innerHeight - newHeight) / 2),
                    (video.videoWrapper.style.height = video.videoWrapper.getBoundingClientRect().height + "px"),
                    (video.videoWrapper.style.height = newHeight + "px"),
                    Shopify.designMode)
                ) {
                    var scrollBehavior = document.documentElement.style.scrollBehavior;
                    (document.documentElement.style.scrollBehavior = "smooth"), window.scrollTo({ top: elementTop - offset }), (document.documentElement.style.scrollBehavior = scrollBehavior);
                }
            } else {
                (newHeight = video.videoWrapper.dataset.desktopHeight), (video.videoWrapper.style.height = newHeight + "px");
                var x = window.scrollX,
                    y = window.scrollY;
                window.scrollTo(x, y);
            }
        }
        function startVideoOnClick(playerId) {
            var video = videos[playerId];
            video.videoWrapper.classList.add(classes.loading),
                (video.videoWrapper.style.height = video.videoWrapper.offsetHeight + "px"),
                (video.status = "open"),
                unsetBackgroundVideo(playerId, video),
                videoPlayers[playerId].unMute(),
                privatePlayVideo(playerId, !0),
                toggleExpandVideo(playerId, !0),
                document.addEventListener("keydown", handleVideoPlayerKeydown);
        }
        var handleVideoPlayerKeydown = function (evt) {
            var playerId = document.activeElement.dataset.controls;
            evt.keyCode !== slate.utils.keyboardKeys.ESCAPE || !playerId || toggleExpandVideo(playerId, !1);
        };
        function sizeBackgroundVideos() {
            var backgroundVideos = document.querySelectorAll("." + classes.backgroundVideo);
            backgroundVideos.forEach(function (el) {
                sizeBackgroundVideo(el);
            });
        }
        function sizeBackgroundVideo(videoPlayer) {
            if (youtubeLoaded) {
                var videoWrapper = videoPlayer.closest(selectors2.videoWrapper),
                    videoWidth = videoWrapper.clientWidth,
                    playerWidth = videoPlayer.clientWidth,
                    desktopHeight = videoWrapper.clientHeight;
                if (videoWidth / videoOptions.ratio < desktopHeight) {
                    playerWidth = Math.ceil(desktopHeight * videoOptions.ratio);
                    var styles = "width: " + playerWidth + "px; height: " + desktopHeight + "px; left: " + (videoWidth - playerWidth) / 2 + "px; top: 0;";
                    videoPlayer.style.cssText = styles;
                } else {
                    desktopHeight = Math.ceil(videoWidth / videoOptions.ratio);
                    var styles2 = "width: " + videoWidth + "px; height: " + desktopHeight + "px; top: " + (desktopHeight - desktopHeight) / 2 + "px; left: 0;";
                    videoPlayer.style.cssText = styles2;
                }
                theme.Helpers.prepareTransition(videoPlayer), videoWrapper.classList.add(classes.loaded);
            }
        }
        function unsetBackgroundVideo(playerId) {
            var player = document.getElementById(playerId);
            player.classList.remove(classes.backgroundVideo),
                setTimeout(function () {
                    document.getElementById(playerId).style.cssText = null;
                }, 600),
                videos[playerId].videoWrapper.classList.remove(classes.backgroundVideoWrapper),
                videos[playerId].videoWrapper.classList.add(classes.playing),
                (videos[playerId].status = "open");
        }
        function setBackgroundVideo(playerId) {
            var player = document.getElementById(playerId);
            player.classList.add(classes.backgroundVideo), videos[playerId].videoWrapper.classList.add(classes.backgroundVideoWrapper), (videos[playerId].status = "background"), sizeBackgroundVideo(player);
        }
        var handleWindowResize = theme.Helpers.debounce(function () {
                if (youtubeLoaded) {
                    var key,
                        fullscreen = window.innerHeight === screen.height;
                    sizeBackgroundVideos(), setAutoplaySupport(!0);
                    for (key in videos) videoPlayers[key].playVideo(), setAsPlaying(videos[key]);
                }
            }, 200),
            handleWindowScroll = theme.Helpers.debounce(function () {
                if (youtubeLoaded) {
                    for (var key in videos)
                        if (videos.hasOwnProperty(key)) {
                            var videoWrapper = videos[key].videoWrapper,
                                condition =
                                    videoWrapper.getBoundingClientRect().top + window.pageYOffset + videoWrapper.offsetHeight * 0.75 < window.pageYOffset ||
                                    videoWrapper.getBoundingClientRect().top + window.pageYOffset + videoWrapper.offsetHeight * 0.25 > window.pageYOffset + window.innerHeight;
                            if (videoWrapper.classList.contains(classes.playing)) {
                                if (!condition) return;
                                toggleExpandVideo(key, !1);
                            }
                        }
                }
            }, 50);
        function initEvents() {
            window.addEventListener("resize", handleWindowResize), window.addEventListener("scroll", handleWindowScroll);
        }
        function createPlayer(key) {
            var args = Object.assign(videoOptions, videos[key]);
            console.log(args), console.log(key), console.log("createPlayer"), (args.playerVars.controls = args.controls), (videoPlayers[key] = new YT.Player(key, args));
        }
        function removeEvents() {
            document.removeEventListener("keydown", handleVideoPlayerKeydown), window.removeEventListener("resize", handleWindowResize), window.removeEventListener("scroll", handleWindowScroll);
        }
        return { init, editorLoadVideo, loadVideos, playVideo: customPlayVideo, pauseVideo, removeEvents };
    })());
function onYouTubeIframeAPIReady() {
    theme.Video.loadVideos();
}
(theme.ProductVideo = (function () {
    var videos = {},
        hosts = { shopify: "shopify", external: "external" },
        selectors2 = { productMediaWrapper: "[data-product-single-media-wrapper]" },
        attributes = { enableVideoLooping: "enable-video-looping", videoId: "video-id" };
    function init(videoContainer, sectionId) {
        if (!videoContainer) return;
        var videoElement = videoContainer.querySelector("iframe, video");
        if (!videoElement) return;
        var mediaId = videoContainer.getAttribute("data-media-id");
        (videos[mediaId] = {
            mediaId,
            sectionId,
            host: hostFromVideoElement(videoElement),
            container: videoContainer,
            element: videoElement,
            ready: function () {
                createPlayer(this);
            },
        }),
            window.Shopify.loadFeatures([{ name: "video-ui", version: "2.0", onLoad: setupVideos }]);
        let videoElementParent = videoElement.closest(".product-single__media");
        if (videoElementParent) {
            let _loadScript2 = function () {
                var _this = this;
                return new Promise(function (resolve, reject) {
                    var script = document.createElement("script");
                    document.body.appendChild(script), (script.onload = resolve), (script.onerror = reject), (script.async = !0), (script.src = videoHost === "youtube" ? "//www.youtube.com/iframe_api" : "//player.vimeo.com/api/player.js");
                });
            };
            var _loadScript = _loadScript2;
            let videoHost = videoElementParent.getAttribute("data-media-host");
            videoHost == "youtube" ? window.YT == null && _loadScript2() : videoHost == "vimeo" && window.Vimeo == null && _loadScript2();
        }
        theme.LibraryLoader.load("plyrShopifyStyles");
    }
    function setupVideos(errors) {
        if (errors) {
            fallbackToNativeVideo();
            return;
        }
        loadVideos();
    }
    function createPlayer(video) {
        if (!video.player) {
            var productMediaWrapper = video.container.closest(selectors2.productMediaWrapper),
                enableLooping = productMediaWrapper.getAttribute("data-" + attributes.enableVideoLooping);
            video.player = new Shopify.Video(video.element, { loop: { active: enableLooping } });
            var pauseVideo = function () {
                video.player && video.player.pause();
            };
            productMediaWrapper.addEventListener("mediaHidden", pauseVideo),
                productMediaWrapper.addEventListener("xrLaunch", pauseVideo),
                productMediaWrapper.addEventListener("mediaVisible", function () {
                    theme.Helpers.isTouch() || (video.player && video.player.play());
                });
        }
    }
    function hostFromVideoElement(video) {
        return video.tagName === "VIDEO" ? hosts.shopify : hosts.external;
    }
    function loadVideos() {
        for (var key in videos)
            if (videos.hasOwnProperty(key)) {
                var video = videos[key];
                video.ready();
            }
    }
    function fallbackToNativeVideo() {
        for (var key in videos)
            if (videos.hasOwnProperty(key)) {
                var video = videos[key];
                if (video.nativeVideo) continue;
                video.host === hosts.shopify && (video.element.setAttribute("controls", "controls"), (video.nativeVideo = !0));
            }
    }
    function removeSectionVideos(sectionId) {
        for (var key in videos)
            if (videos.hasOwnProperty(key)) {
                var video = videos[key];
                video.sectionId === sectionId && (video.player && video.player.destroy(), delete videos[key]);
            }
    }
    return { init, hosts, loadVideos, removeSectionVideos };
})()),
    (theme.ProductModel = (function () {
        var modelJsonSections = {},
            models = {},
            xrButtons = {},
            selectors2 = { mediaGroup: "[data-product-single-media-group]", xrButton: "[data-shopify-xr]" },
            _this = this;
        function init(modelViewerContainers, sectionId) {
            (modelJsonSections[sectionId] = { loaded: !1 }),
                modelViewerContainers.forEach(function (modelViewerContainer, index) {
                    var mediaId = modelViewerContainer.getAttribute("data-media-id"),
                        modelViewerElement = modelViewerContainer.querySelector("model-viewer"),
                        modelId = modelViewerElement.getAttribute("data-model-id");
                    if (index === 0) {
                        var mediaGroup = modelViewerContainer.closest(selectors2.mediaGroup);
                        if (mediaGroup) {
                            modelViewerElement.addEventListener("shopify_model_viewer_ui_toggle_play", function () {
                                mediaGroup.dispatchEvent(new CustomEvent("model:played", { bubbles: !0 }));
                            }),
                                modelViewerElement.addEventListener("shopify_model_viewer_ui_toggle_pause", function () {
                                    mediaGroup.dispatchEvent(new CustomEvent("model:paused", { bubbles: !0 }));
                                });
                            var xrButton = mediaGroup.querySelector(selectors2.xrButton);
                            xrButtons[sectionId] = { element: xrButton, defaultId: modelId };
                        }
                    }
                    models[mediaId] = { modelId, sectionId, container: modelViewerContainer, element: modelViewerElement };
                }),
                window.Shopify.loadFeatures([
                    { name: "shopify-xr", version: "1.0", onLoad: setupShopifyXr },
                    { name: "model-viewer-ui", version: "1.0", onLoad: setupModelViewerUi },
                ]),
                theme.LibraryLoader.load("modelViewerUiStyles");
        }
        function setupShopifyXr(errors) {
            if (!errors) {
                if (!window.ShopifyXR) {
                    document.addEventListener("shopify_xr_initialized", function () {
                        setupShopifyXr();
                    });
                    return;
                }
                for (var sectionId in modelJsonSections)
                    if (modelJsonSections.hasOwnProperty(sectionId)) {
                        var modelSection = modelJsonSections[sectionId];
                        if (modelSection.loaded) continue;
                        var modelJson = document.querySelector("#ModelJson-" + sectionId);
                        window.ShopifyXR.addModels(JSON.parse(modelJson.innerHTML)), (modelSection.loaded = !0);
                    }
                window.ShopifyXR.setupXRElements();
            }
        }
        function setupModelViewerUi(errors) {
            if (!errors) {
                for (var key in models)
                    if (models.hasOwnProperty(key)) {
                        var model = models[key];
                        model.modelViewerUi || (model.modelViewerUi = new Shopify.ModelViewerUI(model.element)), setupModelViewerListeners(model);
                    }
            }
        }
        function setupModelViewerListeners(model) {
            var xrButton = xrButtons[model.sectionId];
            model.container.addEventListener("mediaVisible", function () {
                xrButton.element.setAttribute("data-shopify-model3d-id", model.modelId), !theme.Helpers.isTouch() && model.modelViewerUi.play();
            }),
                model.container.addEventListener("mediaHidden", function () {
                    xrButton.element.setAttribute("data-shopify-model3d-id", xrButton.defaultId), model.modelViewerUi.pause();
                }),
                model.container.addEventListener("xrLaunch", function () {
                    model.modelViewerUi.pause();
                });
        }
        function removeSectionModels(sectionId) {
            for (var key in models)
                if (models.hasOwnProperty(key)) {
                    var model = models[key];
                    model.sectionId === sectionId && (models[key].modelViewerUi.destroy(), delete models[key]);
                }
            delete modelJsonSections[sectionId];
        }
        return { init, removeSectionModels };
    })()),
    (theme.FormStatus = (function () {
        var selectors2 = { statusMessage: "[data-form-status]" };
        function init() {
            var statusMessages = document.querySelectorAll(selectors2.statusMessage);
            statusMessages.forEach(function (statusMessage) {
                statusMessage.setAttribute("tabindex", -1),
                    statusMessage.focus(),
                    statusMessage.addEventListener(
                        "blur",
                        function (evt) {
                            evt.target.removeAttribute("tabindex");
                        },
                        { once: !0 }
                    );
            });
        }
        return { init };
    })()),
    (theme.Disclosure = (function () {
        var selectors2 = {
                disclosureForm: "[data-disclosure-form]",
                disclosureList: "[data-disclosure-list]",
                disclosureToggle: "[data-disclosure-toggle]",
                disclosureInput: "[data-disclosure-input]",
                disclosureOptions: "[data-disclosure-option]",
            },
            classes = { listVisible: "disclosure-list--visible" };
        function Disclosure(disclosure) {
            (this.container = disclosure), this._cacheSelectors(), this._setupListeners();
        }
        return (
            (Disclosure.prototype = Object.assign({}, Disclosure.prototype, {
                _cacheSelectors: function () {
                    this.cache = {
                        disclosureForm: this.container.closest(selectors2.disclosureForm),
                        disclosureList: this.container.querySelector(selectors2.disclosureList),
                        disclosureToggle: this.container.querySelector(selectors2.disclosureToggle),
                        disclosureInput: this.container.querySelector(selectors2.disclosureInput),
                        disclosureOptions: this.container.querySelectorAll(selectors2.disclosureOptions),
                    };
                },
                _setupListeners: function () {
                    (this.eventHandlers = this._setupEventHandlers()),
                        this.cache.disclosureToggle.addEventListener("click", this.eventHandlers.toggleList),
                        this.cache.disclosureOptions.forEach(function (disclosureOption) {
                            disclosureOption.addEventListener("click", this.eventHandlers.connectOptions);
                        }, this),
                        this.container.addEventListener("keyup", this.eventHandlers.onDisclosureKeyUp),
                        this.cache.disclosureList.addEventListener("focusout", this.eventHandlers.onDisclosureListFocusOut),
                        this.cache.disclosureToggle.addEventListener("focusout", this.eventHandlers.onDisclosureToggleFocusOut),
                        document.body.addEventListener("click", this.eventHandlers.onBodyClick);
                },
                _setupEventHandlers: function () {
                    return {
                        connectOptions: this._connectOptions.bind(this),
                        toggleList: this._toggleList.bind(this),
                        onBodyClick: this._onBodyClick.bind(this),
                        onDisclosureKeyUp: this._onDisclosureKeyUp.bind(this),
                        onDisclosureListFocusOut: this._onDisclosureListFocusOut.bind(this),
                        onDisclosureToggleFocusOut: this._onDisclosureToggleFocusOut.bind(this),
                    };
                },
                _connectOptions: function (event) {
                    event.preventDefault(), this._submitForm(event.currentTarget.dataset.value);
                },
                _onDisclosureToggleFocusOut: function (event) {
                    var disclosureLostFocus = this.container.contains(event.relatedTarget) === !1;
                    disclosureLostFocus && this._hideList();
                },
                _onDisclosureListFocusOut: function (event) {
                    var childInFocus = event.currentTarget.contains(event.relatedTarget),
                        isVisible = this.cache.disclosureList.classList.contains(classes.listVisible);
                    isVisible && !childInFocus && this._hideList();
                },
                _onDisclosureKeyUp: function (event) {
                    event.which === slate.utils.keyboardKeys.ESCAPE && (this._hideList(), this.cache.disclosureToggle.focus());
                },
                _onBodyClick: function (event) {
                    var isOption = this.container.contains(event.target),
                        isVisible = this.cache.disclosureList.classList.contains(classes.listVisible);
                    isVisible && !isOption && this._hideList();
                },
                _submitForm: function (value) {
                    (this.cache.disclosureInput.value = value), this.cache.disclosureForm.submit();
                },
                _hideList: function () {
                    this.cache.disclosureList.classList.remove(classes.listVisible), this.cache.disclosureToggle.setAttribute("aria-expanded", !1);
                },
                _toggleList: function () {
                    var ariaExpanded = this.cache.disclosureToggle.getAttribute("aria-expanded") === "true";
                    this.cache.disclosureList.classList.toggle(classes.listVisible), this.cache.disclosureToggle.setAttribute("aria-expanded", !ariaExpanded);
                },
                destroy: function () {
                    this.cache.disclosureToggle.removeEventListener("click", this.eventHandlers.toggleList),
                        this.cache.disclosureOptions.forEach(function (disclosureOption) {
                            disclosureOption.removeEventListener("click", this.eventHandlers.connectOptions);
                        }, this),
                        this.container.removeEventListener("keyup", this.eventHandlers.onDisclosureKeyUp),
                        this.cache.disclosureList.removeEventListener("focusout", this.eventHandlers.onDisclosureListFocusOut),
                        this.cache.disclosureToggle.removeEventListener("focusout", this.eventHandlers.onDisclosureToggleFocusOut),
                        document.body.removeEventListener("click", this.eventHandlers.onBodyClick);
                },
            })),
            Disclosure
        );
    })()),
    (window.theme = theme || {}),
    (theme.customerTemplates = (function () {
        var selectors2 = { RecoverHeading: "#RecoverHeading", RecoverEmail: "#RecoverEmail", LoginHeading: "#LoginHeading" };
        function initEventListeners() {
            (this.recoverHeading = document.querySelector(selectors2.RecoverHeading)), (this.recoverEmail = document.querySelector(selectors2.RecoverEmail)), (this.loginHeading = document.querySelector(selectors2.LoginHeading));
            var recoverPassword = document.getElementById("RecoverPassword"),
                hideRecoverPasswordLink = document.getElementById("HideRecoverPasswordLink");
            recoverPassword &&
                recoverPassword.addEventListener(
                    "click",
                    function (evt) {
                        evt.preventDefault(), showRecoverPasswordForm(), this.recoverHeading.setAttribute("tabindex", "-1"), this.recoverHeading.focus();
                    }.bind(this)
                ),
                hideRecoverPasswordLink &&
                    hideRecoverPasswordLink.addEventListener(
                        "click",
                        function (evt) {
                            evt.preventDefault(), hideRecoverPasswordForm(), this.loginHeading.setAttribute("tabindex", "-1"), this.loginHeading.focus();
                        }.bind(this)
                    ),
                this.recoverHeading &&
                    this.recoverHeading.addEventListener("blur", function (evt) {
                        evt.target.removeAttribute("tabindex");
                    }),
                this.loginHeading &&
                    this.loginHeading.addEventListener("blur", function (evt) {
                        evt.target.removeAttribute("tabindex");
                    });
        }
        function showRecoverPasswordForm() {
            document.getElementById("RecoverPasswordForm").classList.remove("hide"), document.getElementById("CustomerLoginForm").classList.add("hide"), this.recoverEmail.getAttribute("aria-invalid") === "true" && this.recoverEmail.focus();
        }
        function hideRecoverPasswordForm() {
            document.getElementById("RecoverPasswordForm").classList.add("hide"), document.getElementById("CustomerLoginForm").classList.remove("hide");
        }
        function resetPasswordSuccess() {
            var formState = document.querySelector(".reset-password-success");
            if (formState) {
                var resetSuccess = document.getElementById("ResetSuccess");
                resetSuccess.classList.remove("hide"), resetSuccess.focus();
            }
        }
        function customerAddressForm() {
            var newAddressForm = document.getElementById("AddressNewForm"),
                newAddressFormButton = document.getElementById("AddressNewButton");
            newAddressForm &&
                (Shopify && new Shopify.CountryProvinceSelector("AddressCountryNew", "AddressProvinceNew", { hideElement: "AddressProvinceContainerNew" }),
                document.querySelectorAll(".address-country-option").forEach(function (option) {
                    var formId = option.dataset.formId,
                        countrySelector = "AddressCountry_" + formId,
                        provinceSelector = "AddressProvince_" + formId,
                        containerSelector = "AddressProvinceContainer_" + formId;
                    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, { hideElement: containerSelector });
                }),
                document.querySelectorAll(".address-new-toggle").forEach(function (button) {
                    button.addEventListener("click", function () {
                        var isExpanded = newAddressFormButton.getAttribute("aria-expanded") === "true";
                        newAddressForm.classList.toggle("hide"), newAddressFormButton.setAttribute("aria-expanded", !isExpanded), newAddressFormButton.focus();
                    });
                }),
                document.querySelectorAll(".address-edit-toggle").forEach(function (button) {
                    button.addEventListener("click", function (evt) {
                        var formId = evt.target.dataset.formId,
                            editButton = document.getElementById("EditFormButton_" + formId),
                            editAddress = document.getElementById("EditAddress_" + formId),
                            isExpanded = editButton.getAttribute("aria-expanded") === "true";
                        editAddress.classList.toggle("hide"), editButton.setAttribute("aria-expanded", !isExpanded), editButton.focus();
                    });
                }),
                document.querySelectorAll(".address-delete").forEach(function (button) {
                    button.addEventListener("click", function (evt) {
                        var target = evt.target.dataset.target,
                            confirmMessage = evt.target.dataset.confirmMessage;
                        confirm(confirmMessage || "Are you sure you wish to delete this address?") && Shopify.postLink(target, { parameters: { _method: "delete" } });
                    });
                }));
        }
        function checkUrlHash() {
            var hash = window.location.hash;
            hash === "#recover" && showRecoverPasswordForm.bind(this)();
        }
        return {
            init: function () {
                initEventListeners(), checkUrlHash(), resetPasswordSuccess(), customerAddressForm();
            },
        };
    })()),
    (window.theme = window.theme || {}),
    (theme.Cart = (function () {
        var selectors2 = { cartErrorMessage: "[data-cart-error-message]", cartErrorMessageWrapper: "[data-cart-error-message-wrapper]" },
            classes = { cartNoCookies: "cart--no-cookies", hide: "hide", inputError: "input--error" },
            _this,
            freeProductAdded = false;
        function Cart(container) {
            if (
                ((_this = this),
                (this.container = container),
                (this.options = JSON.parse(this.container.getAttribute("data-section-settings"))),
                (this.itemCount = this.options.itemCount),
                (this.totalPrice = this.options.totalPrice),
                (this.delegateElement = new Delegate(this.container)),
                (this._onNoteChange = this._onNoteChange.bind(this)),
                theme.Helpers.cookiesEnabled() || this.container.classList.add(classes.cartNoCookies),
                this.container.addEventListener("change", this._onNoteChange),
                this.delegateElement.on("click", '[data-action="update-item-quantity"], [data-action="remove-item"]', this._updateItemQuantity.bind(this)),
                this.delegateElement.on("change", ".QuantitySelector__CurrentQuantity", this._updateItemQuantity.bind(this)),
                this.delegateElement.on("click", '[data-action="close-drawer"][data-drawer-id="' + this.container.id + '"]', this._closeModal),
                document.addEventListener("click", function (e) {
                    var el = e.target;
                    if (!el.classList.contains("Cart-Drawer") && !el.closest(".Cart-Drawer") && !el.closest("#HeaderCart")) {
                        var Drawer = document.querySelector("#sidebar-cart");
                        Drawer && Drawer.classList.contains("show") && (Drawer.classList.remove("show"), document.querySelector("body").classList.remove("show_overlay"));
                    }
                }),
                this.options.hasShippingEstimator)
            ) {
                (_this.countrySelect = this.container.querySelector('[name="country"]')), (_this.provinceSelect = this.container.querySelector('[name="province"]'));
                var defaultCountry = _this.countrySelect.getAttribute("data-default");
                if (defaultCountry) {
                    for (var i = 0; i !== _this.countrySelect.options.length; ++i)
                        if (_this.countrySelect.options[i].text === defaultCountry) {
                            _this.countrySelect.selectedIndex = i;
                            break;
                        }
                } else _this.countrySelect.selectedIndex = 0;
                (this._onCountryChangedListener = this._onCountryChanged.bind(this)), this.countrySelect.addEventListener("change", this._onCountryChangedListener);
                var event = new Event("change", { bubbles: !0 });
                _this.countrySelect.dispatchEvent(event);
                var defaultProvince = _this.provinceSelect.getAttribute("data-default");
                defaultProvince && (_this.provinceSelect.value = defaultProvince), this.delegateElement.on("click", ".ShippingEstimator__Submit", this._fetchRates.bind(this));
            }
            var CartSpecialInstructionsSubmit = this.container.querySelector(".CartSpecialInstructionsSubmit");
            CartSpecialInstructionsSubmit &&
                CartSpecialInstructionsSubmit.addEventListener("click", function (e) {
                    e.preventDefault();
                    var noteField = this.closest("form").querySelector("#CartSpecialInstructions");
                    if (noteField) {
                        var note = noteField.value,
                            headers = new Headers({ "Content-Type": "application/json" }),
                            request = { method: "POST", headers, body: JSON.stringify({ note }) };
                        fetch("/cart/update.js", request)
                            .then(function (response) {
                                response.status == 200 &&
                                    ((CartSpecialInstructionsSubmit.innerHTML = theme.strings.added_note),
                                    setTimeout(function () {
                                        CartSpecialInstructionsSubmit.innerHTML = theme.strings.add_note;
                                    }, 2e3));
                            })
                            .catch(
                                function () {
                                    _this._showCartError(noteField);
                                }.bind(this)
                            );
                    }
                }),
                document.addEventListener("cart:refresh", function () {
                    _this._rerenderCart();
                });
        }
        return (
            (Cart.prototype = Object.assign({}, Cart.prototype, {
                _onCountryChanged: function () {
                    var selectedOption = _this.countrySelect.options[_this.countrySelect.selectedIndex],
                        provinces = JSON.parse(selectedOption.getAttribute("data-provinces") || "[]");
                    if (((_this.provinceSelect.innerHTML = ""), provinces.length === 0)) {
                        _this.provinceSelect.parentNode.style.display = "none";
                        return;
                    }
                    provinces.forEach(function (data) {
                        _this.provinceSelect.options.add(new Option(data[1], data[0]));
                    }),
                        (_this.provinceSelect.parentNode.style.display = "block");
                },
                _fetchRates: function () {
                    var country = _this.container.querySelector('[name="country"]').value,
                        province = _this.container.querySelector('[name="province"]').value,
                        city = _this.container.querySelector('[name="city"]').value,
                        zip = _this.container.querySelector('[name="zip"]').value;
                    fetch(window.routes.cartUrl + "/shipping_rates.json?shipping_address[zip]=" + zip + "&shipping_address[country]=" + country + "&shipping_address[province]=" + province, {
                        credentials: "same-origin",
                        method: "GET",
                    }).then(function (response) {
                        response.json().then(function (result) {
                            var resultsContainer = _this.container.querySelector(".ShippingEstimator__Results"),
                                ShippingEstimatorParentRow = _this.container.querySelector(".ShippingEstimator"),
                                errorContainer = _this.container.querySelector(".ShippingEstimator__Error");
                            if (response.ok) {
                                var shippingRates = result.shipping_rates;
                                if (shippingRates.length === 0) resultsContainer.innerHTML = "<p>" + theme.strings.shippingEstimatorNoResults + "</p>";
                                else {
                                    var html = "<ul>";
                                    shippingRates.forEach(function (item) {
                                        html += '<li class="h6"><span class="title ">' + item.name + ':</span><span class="shipping_price">' + theme.Currency.formatMoney(item.price, theme.moneyFormat) + "</span></li>";
                                    }),
                                        (html += "</ul>");
                                    var address_city = city;
                                    address_city.length == 0 && (address_city = province),
                                        (html += '<p class="Shipping_to_address h6">' + theme.strings.shippingTo + " " + address_city + "</p>"),
                                        (resultsContainer.firstElementChild.innerHTML = html);
                                }
                                (errorContainer.style.display = "none"), (resultsContainer.style.display = "block"), ShippingEstimatorParentRow.classList.remove("hide");
                            } else {
                                var errorHtml = "";
                                Object.keys(result).forEach(function (key) {
                                    errorHtml += '<li class="Alert__ErrorItem">' + key + " " + result[key] + "</li>";
                                }),
                                    (errorContainer.innerHTML = '<ul class="Alert__ErrorList">' + errorHtml + "</ul>"),
                                    (resultsContainer.style.display = "none"),
                                    (errorContainer.style.display = "block"),
                                    ShippingEstimatorParentRow.classList.remove("hide");
                            }
                        });
                    });
                },
                _sidebarDrawerOpen: function () {
                    var Drawer = document.querySelector("#sidebar-cart");
                    Drawer &&
                        (Drawer.classList.contains("show") ||
                            (Drawer.classList.add("show"),
                            document.querySelector("body").classList.add("show_overlay"),
                            Drawer.addEventListener(
                                "transitionend",
                                () => {
                                    Drawer.focus(), slate.a11y.trapFocus({ container: Drawer, elementToFocus: Drawer });
                                },
                                { once: !0 }
                            )));
                },
                _onProductAdded: function () {
                    var quick_view_modal = document.querySelector('#modal-quick-view[aria-hidden="false"]');
                    quick_view_modal && quick_view_modal.querySelector(".close-quick-view").dispatchEvent(new Event("click", { bubbles: !0 })),
                        _this.options.type == "drawer"
                            ? _this._rerenderCart().then(function () {
                                  _this._sidebarDrawerOpen();
                              })
                            : (window.location.href = window.routes.cartUrl);
                },
                _closeModal: function () {
                    var Drawer = this.closest(".Drawer");
                    Drawer && (Drawer.classList.remove("show"), document.querySelector("body").classList.remove("show_overlay"));
                },
                _updateItemQuantity: function (event, target) {
                    var quantity = null,
                        inventory_qty = null,
                        inventory_management = "",
                        inventory_policy = "";
                    if (
                        (target.tagName === "INPUT" ? (quantity = parseInt(target.value)) : (quantity = parseInt(target.getAttribute("data-quantity"))),
                        (inventory_management = target.getAttribute("data-inventory_management")),
                        (inventory_qty = parseInt(target.getAttribute("data-inventory_qty"))),
                        (inventory_policy = target.getAttribute("data-inventory_policy")),
                        quantity > inventory_qty && inventory_management != "" && inventory_policy != "continue")
                    ) {
                        var parentEl = target.closest(".CartItem");
                        if (parentEl) {
                            var qtyErrorEls = parentEl.querySelectorAll(".QuantitySelector__error-message");
                            qtyErrorEls.length &&
                                qtyErrorEls.forEach(function (qtyErrorEl, index) {
                                    qtyErrorEl.classList.remove("hide");
                                });
                        }
                    } else
                        fetch(window.routes.cartChangeUrl + ".js", {
                            body: JSON.stringify({ id: target.getAttribute("data-line-id"), quantity }),
                            credentials: "same-origin",
                            method: "POST",
                            headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
                        }).then(function (cart) {
                            cart.json().then(function (content) {
                                (_this.itemCount = content.item_count), (_this.totalPrice = content.totalPrice), _this._rerenderCart();
                            });
                        });
                    event.preventDefault();

                    const addToCartBtn = document.querySelector(".product-form__cart-submit");
                    if (addToCartBtn) {
                    if (addToCartBtn.hasAttribute("data-limited-quantity")) {
                        var limitedQuantity = addToCartBtn.getAttribute("data-limited-quantity");
                        if (limitedQuantity) {
                          addToCartBtn.removeAttribute("disabled");
                         }
                        }
                    }
                },
                _showSpinner: function () {
                    document.querySelectorAll(".protect-plus-toggle-container").forEach((toggle) => {
                        toggle.classList.add("loading");
                    });
                },
                _hideSpinner: function () {
                    document.querySelectorAll(".protect-plus-toggle-container").forEach((toggle) => {
                        toggle.classList.remove("loading");
                    });
                },
                _rerenderCart: function () {
                    return (
                        (_this.options = JSON.parse(_this.container.getAttribute("data-section-settings"))),
                        fetch(window.routes.cartUrl + "?view=" + (this.options.drawer && window.theme.pageType !== "cart" ? "drawer" : "ajax") + "&timestamp=" + Date.now(), { credentials: "same-origin", method: "GET" }).then(function (
                            content
                        ) {
                            content.text().then(function (html) {
                                if ((_this._replaceContent(html), _this.options.hasShippingEstimator)) {
                                    (_this.countrySelect = _this.container.querySelector('[name="country"]')), (_this.provinceSelect = _this.container.querySelector('[name="province"]'));
                                    var defaultCountry = _this.countrySelect.getAttribute("data-default");
                                    if (defaultCountry) {
                                        for (var i = 0; i !== _this.countrySelect.options.length; ++i)
                                            if (_this.countrySelect.options[i].text === defaultCountry) {
                                                _this.countrySelect.selectedIndex = i;
                                                break;
                                            }
                                    } else _this.countrySelect.selectedIndex = 0;
                                    (_this._onCountryChangedListener = _this._onCountryChanged.bind(this)), _this.countrySelect.addEventListener("change", _this._onCountryChangedListener);
                                    var event = new Event("change", { bubbles: !0 });
                                    _this.countrySelect.dispatchEvent(event);
                                    var defaultProvince = _this.provinceSelect.getAttribute("data-default");
                                    defaultProvince && (_this.provinceSelect.value = defaultProvince);
                                }
                                var CartSpecialInstructionsSubmit = _this.container.querySelector(".CartSpecialInstructionsSubmit");
                                CartSpecialInstructionsSubmit &&
                                    CartSpecialInstructionsSubmit.addEventListener("click", function (e) {
                                        e.preventDefault();
                                        var noteField = this.closest("form").querySelector("#CartSpecialInstructions");
                                        if (noteField) {
                                            var note = noteField.value,
                                                headers = new Headers({ "Content-Type": "application/json" }),
                                                request = { method: "POST", headers, body: JSON.stringify({ note }) };
                                            fetch("/cart/update.js", request)
                                                .then(function (response) {
                                                    response.status == 200 &&
                                                        ((CartSpecialInstructionsSubmit.innerHTML = theme.strings.added_note),
                                                        setTimeout(function () {
                                                            CartSpecialInstructionsSubmit.innerHTML = theme.strings.add_note;
                                                        }, 2e3));
                                                })
                                                .catch(
                                                    function () {
                                                        _this._showCartError(noteField);
                                                    }.bind(this)
                                                );
                                        }
                                    }),
                                    _this._showSpinner(),
                                    setTimeout(() => {
                                        handleCartUpdate(), _this._hideSpinner();
                                    }, 500),
                                    setTimeout(() => {
                                        _this._checkAndAddTierProduct();
                                    }, 500),
                                    window.freeProductData &&
                                        window.freeProductData.freeProductEnabled &&
                                        fetch("/cart.js", { method: "GET", credentials: "same-origin", headers: { "Content-Type": "application/json" } })
                                            .then((response) => response.json())
                                            .then((cart) => {
                                                _this._checkAndHandleFreeProduct(cart.items);
                                            })
                                            .catch((error) => console.error("Error fetching cart:", error));
                            });
                        })
                    );
                },
                _checkAndHandleFreeProduct: function (cartItems) {
                    const selectedProductQuantity = this._getSelectedProductQuantity(cartItems),
                        freeProductQuantity = this._getFreeProductQuantity(cartItems);
                    if (selectedProductQuantity > 0) {
                        let desiredFreeProductQuantity;
                        window.freeProductData.freeProductLimit ? (desiredFreeProductQuantity = 1) : (desiredFreeProductQuantity = selectedProductQuantity),
                            freeProductQuantity < desiredFreeProductQuantity
                                ? (this._addFreeProductToCart(desiredFreeProductQuantity - freeProductQuantity), (freeProductAdded = !0))
                                : freeProductQuantity > desiredFreeProductQuantity && (this._removeFreeProductFromCart(cartItems, freeProductQuantity - desiredFreeProductQuantity), (freeProductAdded = !1));
                    } else freeProductAdded && (this._removeFreeProductFromCart(cartItems, freeProductQuantity), (freeProductAdded = !1));
                },
                _getSelectedProductQuantity: function (cartItems) {
                    let selectedProductQuantity = 0;
                    return (
                        window.freeProductData.selectedSubscriptionProduct &&
                            window.freeProductData.selectedSubscriptionProduct.length > 0 &&
                            (selectedProductQuantity += cartItems.reduce(
                                (quantity, item) =>
                                    quantity +
                                    window.freeProductData.selectedSubscriptionProduct.reduce(
                                        (innerQuantity, selected) =>
                                            innerQuantity + (item.variant_id === selected.id && item.selling_plan_allocation && selected.sellingPlanIds.includes(item.selling_plan_allocation.selling_plan.id) ? item.quantity : 0),
                                        0
                                    ),
                                0
                            )),
                        window.freeProductData.selectedMultipleProducts &&
                            window.freeProductData.selectedMultipleProducts.length > 0 &&
                            (selectedProductQuantity += cartItems.reduce((quantity, item) => quantity + (window.freeProductData.selectedMultipleProducts.includes(item.variant_id) ? item.quantity : 0), 0)),
                        selectedProductQuantity
                    );
                },
                _getFreeProductQuantity: function (cartItems) {
                    if (!window.freeProductData.freeProduct) return 0;
                    const freeProductItem = cartItems.find((item) => item.variant_id === window.freeProductData.freeProduct);
                    return freeProductItem ? freeProductItem.quantity : 0;
                },
                _addFreeProductToCart: function (quantity) {
                    !window.freeProductData.freeProduct ||
                        quantity <= 0 ||
                        fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: window.freeProductData.freeProduct, quantity }) })
                            .then((response) => response.json())
                            .then(() => {
                                this._fetchCartState();
                            })
                            .catch((error) => console.error("Error adding free product:", error));
                },
                _removeFreeProductFromCart: function(cartItems, quantity) {
                    if (!window.freeProductData.freeProduct || quantity <= 0) return;
        
                    const freeProductItem = cartItems.find(item => item.variant_id === window.freeProductData.freeProduct);
                    if (freeProductItem) {
                        const lineItemId = cartItems.findIndex(item => item.variant_id === window.freeProductData.freeProduct) + 1;
                        
                        fetch("/cart/change.js", {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify({ line: lineItemId, quantity: 0 })
                        })
                        .then(response => response.json())
                        .then(() => {
                            this._fetchCartState();
                            document.dispatchEvent(new CustomEvent('cart:refresh'));
                        })
                        .catch(error => console.error("Error removing free product:", error));
                    }
                },
                _fetchCartState: function () {
                    fetch("/cart.js", { method: "GET", credentials: "same-origin", headers: { "Content-Type": "application/json" } })
                        .then((response) => response.json())
                        .then((cart) => {
                            (this.totalPrice = cart.items.reduce((total, item) => total + (item.line_price || 0), 0)), (this.itemCount = cart.item_count), this._rerenderCart();
                        })
                        .catch((error) => console.error("Error fetching cart:", error));
                },
                _checkAndAddTierProduct: function () {
                    var _this2 = this;
                    fetch("/cart.js", { method: "GET", credentials: "same-origin", headers: { "Content-Type": "application/json" } })
                        .then((response) => response.json())
                        .then((cart) => {
                            let cartTotal = cart.items.reduce((total, item) => total + item.final_line_price, 0),
                                tierProductIds = new Set(
                                    _this2.container.querySelectorAll(".product-tier__offer").forEach((tierProduct) => {
                                        var productOffer = parseInt(tierProduct.getAttribute("data-product-offer"), 10),
                                            variantId = tierProduct.getAttribute("data-variant-id");
                                        _this2.totalPrice >= productOffer
                                            ? cart.items.some((item) => item.variant_id.toString() === variantId && item.properties && item.properties["_free-rewards"] === "true") || _this2._addProductVariantToCart(variantId, productOffer)
                                            : cart.items.forEach((item, index) => {
                                                  item.variant_id.toString() === variantId && item.properties && item.properties["_free-rewards"] === "true" && _this2._removeProductVariantFromCart(index + 1);
                                              });
                                    })
                                );
                        })
                        .catch((error) => console.error("Error fetching cart:", error));
                },
                _removeProductVariantFromCart: function (lineItemId) {
                    var _this2 = this;
                    fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ line: lineItemId, quantity: 0 }) })
                        .then((response) => response.json())
                        .then((data) => {
                            this._fetchCartStateAndRerender();
                        })
                        .catch((error) => console.error("Error removing product:", error));
                },
                _addProductVariantToCart: function (variantId, productOffer) {
                    var _this2 = this;
                    fetch("/cart.js", { method: "GET", credentials: "same-origin", headers: { "Content-Type": "application/json" } })
                        .then((response) => response.json())
                        .then((cart) => {
                            var alreadyInCart = cart.items.some((item) => item.variant_id.toString() === variantId);
                            if (alreadyInCart) return Promise.resolve(null);
                            var payload = { items: [{ id: variantId, quantity: 1, properties: { "_free-rewards": "true" } }] };
                            return fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) });
                        })
                        .then((response) => (response ? response.json() : null))
                        .then((data) => {
                            data && (console.log("Product added:", data), _this2._fetchCartStateAndRerender());
                        })
                        .catch((error) => {
                            console.error("Error:", error);
                        });
                },
                _fetchCartStateAndRerender: function () {
                    fetch("/cart.js", { method: "GET", credentials: "same-origin", headers: { "Content-Type": "application/json" } })
                        .then((response) => response.json())
                        .then((cart) => {
                            (this.totalPrice = cart.items.reduce((total, item) => total + (item.line_price || 0), 0)), (this.itemCount = cart.item_count), this._rerenderCart();
                        })
                        .catch((error) => console.error("Error fetching cart:", error));
                },
                _replaceContent: function (html) {
                    var tempElement = document.createElement("div");
                    tempElement.innerHTML = html;
                    var cartNodeParent = this.container.querySelector(".Cart").parentNode;
                    if (this.options.drawer && window.theme.pageType !== "cart") {
                        var currentScrollPosition = this.container.querySelector(".Drawer__Main").scrollTop;
                        cartNodeParent.replaceChild(tempElement.querySelector(".Cart"), this.container.querySelector(".Cart")), (this.container.querySelector(".Drawer__Main").scrollTop = currentScrollPosition);
                    } else
                        this.itemCount === 0
                            ? (this.container.innerHTML = tempElement.querySelector(".shopify-section > div").innerHTML)
                            : cartNodeParent.replaceChild(tempElement.querySelector(".Cart"), this.container.querySelector(".Cart"));
                    var cartResult = JSON.parse(tempElement.querySelector('[data-section-type="cart-template"]').getAttribute("data-section-settings")),
                        header__CartCount = document.querySelector(".header_cart_count"),
                        header_total_priceEl = document.querySelector(".cart_total_price");
                    (this.itemCount = cartResult.itemCount),
                        (this.totalPrice = cartResult.totalPrice),
                        header__CartCount && (header__CartCount.innerHTML = this.itemCount),
                        header_total_priceEl && (header_total_priceEl.innerHTML = theme.Currency.formatMoney(this.totalPrice, theme.moneyFormat));
                },
                _onNoteChange: function (evt) {
                    if (evt.target.hasAttribute("data-cart-notes")) {
                        var note = evt.target.value;
                        this._hideCartError();
                        var headers = new Headers({ "Content-Type": "application/json" }),
                            request = { method: "POST", headers, body: JSON.stringify({ note }) };
                        fetch("/cart/update.js", request).catch(
                            function () {
                                this._showCartError(evt.target);
                            }.bind(this)
                        );
                    }
                },
                _showCartError: function (elementToFocus) {
                    (document.querySelector(selectors2.cartErrorMessage).textContent = theme.strings.cartError),
                        document.querySelector(selectors2.cartErrorMessageWrapper).classList.remove(classes.hide),
                        elementToFocus && elementToFocus.focus();
                },
                _hideCartError: function () {
                    document.querySelector(selectors2.cartErrorMessageWrapper).classList.add(classes.hide), (document.querySelector(selectors2.cartErrorMessage).textContent = "");
                },
            })),
            Cart
        );
    })()),
    (window.theme = window.theme || {}),
    (theme.HeaderSection = (function () {
        function Header() {
            theme.Header.init(), theme.MobileNav.init();
        }
        return (
            (Header.prototype = Object.assign({}, Header.prototype, {
                onUnload: function () {
                    theme.Header.unload(), theme.MobileNav.unload();
                },
            })),
            Header
        );
    })()),
    (theme.AnnouncementBar = (function () {
        function AnnouncementBar(container) {
            var _this = this;
            if (
                ((this.container = container),
                (this.AnnouncementBar__Slider = this.container.querySelector(".AnnouncementBar__Slider")),
                (this.AnnouncementBar__close_button = this.container.querySelector(".AnnouncementBar__close_button")),
                this.AnnouncementBar__Slider)
            ) {
                let slideHeightCalculate2 = function () {
                    var maxSlideHeight = 0,
                        slidesLength = _this.AnnouncementBar__Slider.querySelectorAll(".AnnouncementBar__Content").length;
                    slidesLength > 1 &&
                        (_this.AnnouncementBar__Slider.querySelectorAll(".AnnouncementBar__Content").forEach(function (item, index) {
                            item.style.height = "auto";
                            var slideHeight = item.offsetHeight;
                            slideHeight > maxSlideHeight && (maxSlideHeight = slideHeight);
                        }),
                        _this.AnnouncementBar__Slider.querySelectorAll(".AnnouncementBar__Content").forEach(function (item, index) {
                            item.style.height = maxSlideHeight + "px";
                        }),
                        setTimeout(function () {
                            document.documentElement.style.setProperty("--announcement-bar-height", document.querySelector('[data-section-type="announcement-bar"]').offsetHeight + "px");
                        }, 200));
                };
                var slideHeightCalculate = slideHeightCalculate2;
                (this.options = JSON.parse(this.AnnouncementBar__Slider.getAttribute("data-flickity-config"))),
                    window.addEventListener("resize", slideHeightCalculate2),
                    slideHeightCalculate2(),
                    (this.flickityInstance = new Flickity(this.AnnouncementBar__Slider, this.options)),
                    setTimeout(function () {
                        document.documentElement.style.setProperty("--announcement-bar-height", document.querySelector('[data-section-type="announcement-bar"]').offsetHeight + "px");
                    }, 200);
            }
            this.AnnouncementBar__close_button &&
                this.AnnouncementBar__close_button.addEventListener("click", function (e) {
                    e.preventDefault();
                    var parentSection = this.closest('[data-section-type="announcement-bar"]');
                    (parentSection.style.display = "none"), document.documentElement.style.setProperty("--announcement-bar-height", "0px");
                });
        }
        return AnnouncementBar;
    })()),
    (theme.LogoBar = (function () {
        function LogoBar(container) {
            this.container = container;
            var self2 = this;
            if (((this.LogoBar__Slider = this.container.querySelector(".logo-bar--slider")), this.LogoBar__Slider)) {
                (this.options = JSON.parse(this.LogoBar__Slider.getAttribute("data-flickity-config"))), (this.flickityInstance = new Flickity(this.LogoBar__Slider, this.options));
                var slider_custom_arrows = container.querySelector(".slider_custom_arrows");
                if (slider_custom_arrows) {
                    var slider_custom_btns = slider_custom_arrows.querySelectorAll(".btn");
                    slider_custom_btns.forEach(function (item, index) {
                        item.addEventListener("click", function (e) {
                            e.preventDefault();
                            var isNext = item.classList.contains("button-next");
                            isNext ? self2.flickityInstance.next() : self2.flickityInstance.previous();
                        });
                    });
                }
            }
        }
        return LogoBar;
    })());
var windowWidthCached = window.innerWidth;
(theme.HomepageAccordion = (function () {
    function HomepageAccordion(container) {
        var _this = this;
        if (((_this.container = container), (_this.accordion = _this.container.querySelector(".homepage_accordion")), _this.accordion)) {
            var questions_arr = _this.accordion.querySelectorAll(".question"),
                maxHeightAnswerBlock = 0,
                sectionDefaultHeight = this.container.offsetHeight,
                sectionHeight = this.container.closest(".shopify-section").offsetHeight,
                answer_arr = _this.accordion.querySelectorAll(".answer");
            answer_arr.length &&
                answer_arr.forEach(function (item, index) {
                    item.classList.add("active");
                    var blockHeight = item.offsetHeight;
                    blockHeight > maxHeightAnswerBlock && (maxHeightAnswerBlock = blockHeight), item.classList.remove("active");
                }),
                (sectionHeight += maxHeightAnswerBlock),
                (_this.container.style.minHeight = sectionHeight + "px"),
                questions_arr.length &&
                    questions_arr.forEach(function (item, index) {
                        item.addEventListener("click", function (e) {
                            e.preventDefault();
                            var self2 = this,
                                answer_block = this.closest(".homepage_accordion__block").querySelector(".answer"),
                                block_id = self2.getAttribute("data-id"),
                                current_active_block = _this.accordion.querySelector(".question.active"),
                                current_answer_active_block = _this.accordion.querySelector(".answer.active"),
                                delay = 0;
                            if (current_active_block) {
                                var current_block_id = current_active_block.getAttribute("data-id");
                                current_block_id != block_id &&
                                    ((current_answer_active_block.style.height = current_answer_active_block.scrollHeight + "px"),
                                    current_answer_active_block.offsetHeight,
                                    (current_answer_active_block.style.height = 0),
                                    current_answer_active_block.classList.remove("active"),
                                    current_active_block.classList.remove("active"));
                            }
                            if (answer_block.classList.contains("active"))
                                (answer_block.style.height = "0px"),
                                    answer_block.addEventListener(
                                        "transitionend",
                                        function () {
                                            answer_block.classList.remove("active"), self2.classList.remove("active");
                                        },
                                        { once: !0 }
                                    );
                            else {
                                self2.classList.add("active"), answer_block.classList.add("active"), (answer_block.style.height = "auto");
                                var height = answer_block.clientHeight + "px";
                                (answer_block.style.height = "0px"),
                                    setTimeout(function () {
                                        answer_block.style.height = height;
                                    }, delay);
                            }
                        });
                    }),
                window.addEventListener(
                    "resize",
                    theme.Helpers.debounce(function (e) {
                        if (window.innerWidth != windowWidthCached) {
                            windowWidthCached = window.innerWidth;
                            var findActiveBlock = _this.container.querySelector(".answer.active");
                            findActiveBlock && (findActiveBlock.classList.remove("active"), (findActiveBlock.style.height = "0px")), _this.container.removeAttribute("style");
                            var newSectionHeight = _this.container.closest(".shopify-section").offsetHeight,
                                maxHeightAnswerBlock2 = 0;
                            if (
                                (answer_arr.length &&
                                    answer_arr.forEach(function (item, index) {
                                        item.classList.add("active"), item.removeAttribute("style");
                                        var blockHeight = item.offsetHeight;
                                        item.classList.remove("active"), blockHeight > maxHeightAnswerBlock2 && (maxHeightAnswerBlock2 = blockHeight);
                                    }),
                                findActiveBlock)
                            ) {
                                findActiveBlock.classList.add("active"), (findActiveBlock.style.height = "auto");
                                var height = findActiveBlock.clientHeight + "px";
                                (findActiveBlock.style.height = "0px"),
                                    setTimeout(function () {
                                        findActiveBlock.style.height = height;
                                    }, 0);
                            }
                            (newSectionHeight += maxHeightAnswerBlock2), (_this.container.style.minHeight = newSectionHeight + "px");
                        }
                    })
                );
        }
    }
    return HomepageAccordion;
})()),
    (theme.PageAccordion = (function () {
        function PageAccordion(container) {
            var _this = this;
            if (((_this.container = container), (_this.accordion = _this.container.querySelector(".faq_accordion")), _this.accordion)) {
                var questions_arr = _this.accordion.querySelectorAll(".question");
                questions_arr.length &&
                    questions_arr.forEach(function (item, index) {
                        item.addEventListener("click", function (e) {
                            e.preventDefault();
                            var self2 = this,
                                answer_block = this.closest(".accordion__block").querySelector(".answer"),
                                block_id = self2.getAttribute("data-id");
                            if (answer_block.classList.contains("active"))
                                (answer_block.style.height = "0px"),
                                    answer_block.addEventListener(
                                        "transitionend",
                                        function () {
                                            answer_block.classList.remove("active"), self2.classList.remove("active");
                                        },
                                        { once: !0 }
                                    );
                            else {
                                self2.classList.add("active"), answer_block.classList.add("active"), (answer_block.style.height = "auto");
                                var height = answer_block.clientHeight + "px";
                                (answer_block.style.height = "0px"),
                                    setTimeout(function () {
                                        answer_block.style.height = height;
                                    }, 0);
                            }
                        });
                    });
            }
        }
        return PageAccordion;
    })()),
    (theme.MainSearchPage = (function () {
        function MainSearchPage(container) {
            var _this = this,
                pagination_mode = container.getAttribute("data-pagination_mode");
            if (pagination_mode != "standart") var endlessScroll = new Ajaxinate({ container: "#AjaxinateContainer", pagination: "#AjaxinatePagination", method: pagination_mode, offset: 500 });
            theme.ProductItemSwatches();
            var filter_titles = container.querySelectorAll(".category-filters-section-title");
            filter_titles.length &&
                filter_titles.forEach(function (item, index) {
                    var self2 = item,
                        parentArea = self2.closest(".category-filters-area-section"),
                        filtersBlock = parentArea.querySelector(".category-filters-area-list");
                    if (filtersBlock.classList.contains("active")) {
                        filtersBlock.style.height = "auto";
                        var height = filtersBlock.clientHeight + "px";
                        filtersBlock.style.height = height;
                    } else filtersBlock.style.height = "0px";
                    item.addEventListener("click", function (e) {
                        e.preventDefault();
                        var self3 = this,
                            parentArea2 = self3.closest(".category-filters-area-section"),
                            filtersBlock2 = parentArea2.querySelector(".category-filters-area-list");
                        if (filtersBlock2.classList.contains("active")) (filtersBlock2.style.height = "0px"), self3.classList.remove("active"), filtersBlock2.classList.remove("active");
                        else {
                            self3.classList.add("active"), filtersBlock2.classList.add("active"), (filtersBlock2.style.height = "auto");
                            var height2 = filtersBlock2.clientHeight + "px";
                            (filtersBlock2.style.height = "0px"),
                                setTimeout(function () {
                                    filtersBlock2.style.height = height2;
                                }, 0);
                        }
                    });
                });
            var show_more_options = container.querySelectorAll(".show_more_options");
            show_more_options.length &&
                (container.querySelectorAll(".advanced-filters").forEach(function (filter, index) {
                    var children_length = filter.querySelectorAll("li").length;
                    if (children_length > 5) {
                        for (var heigth_limit = 0, i = 0; i < filter.querySelectorAll("li").length; i++) {
                            var item = filter.querySelectorAll("li")[i];
                            if (((heigth_limit = heigth_limit + item.offsetHeight), i == 4)) break;
                        }
                        var show_more_option = filter.nextElementSibling;
                        show_more_option && (filter.setAttribute("data-heigth_limit", heigth_limit), (filter.style.maxHeight = heigth_limit + "px"), (show_more_option.style.display = "inline-block"));
                    }
                }),
                show_more_options.forEach(function (btn, index) {
                    btn.addEventListener("click", function (e) {
                        e.preventDefault();
                        var filters_list = this.previousElementSibling,
                            heigth_limit = filters_list.getAttribute("data-heigth_limit"),
                            default_text = this.getAttribute("data-default-text");
                        if (this.classList.contains("openedFilter")) (filters_list.style.maxHeight = heigth_limit + "px"), this.classList.remove("openedFilter"), (this.innerHTML = default_text);
                        else {
                            for (var filterBlockLength = 0, i = 0; i < filters_list.querySelectorAll("li").length; i++) {
                                var item = filters_list.querySelectorAll("li")[i];
                                filterBlockLength = filterBlockLength + item.offsetHeight;
                            }
                            (filters_list.style.maxHeight = filterBlockLength + "px"), this.classList.add("openedFilter"), (this.innerHTML = theme.strings.show_less);
                        }
                    });
                }));
            var open_sidebar_btn = container.querySelector(".open_mobile_sidebar"),
                close_sidebar_btn = container.querySelector(".close-collection-sidebar");
            open_sidebar_btn &&
                open_sidebar_btn.addEventListener("click", function (e) {
                    e.preventDefault();
                    var sidebarEl = container.querySelector(".collection-sidebar");
                    sidebarEl && (sidebarEl.classList.add("show"), document.querySelector("body").classList.add("show_overlay"));
                }),
                close_sidebar_btn &&
                    close_sidebar_btn.addEventListener("click", function (e) {
                        e.preventDefault();
                        var sidebarEl = container.querySelector(".collection-sidebar");
                        sidebarEl && (sidebarEl.classList.remove("show"), document.querySelector("body").classList.remove("show_overlay"));
                    });
            var check_filter_value_btns = container.querySelectorAll(".advanced-filter a");
            check_filter_value_btns.length &&
                check_filter_value_btns.forEach(function (item, index) {
                    item.addEventListener("click", function (e) {
                        e.preventDefault();
                        var parentFilterNode = this.closest(".advanced-filter"),
                            filterInput = parentFilterNode.querySelector('[type="checkbox"]');
                        filterInput && (filterInput.checked ? (filterInput.checked = !1) : (filterInput.checked = !0));
                        var FitersFormEl = item.closest("form");
                        if (FitersFormEl) {
                            const formData = new FormData(FitersFormEl),
                                searchParams = new URLSearchParams(formData).toString();
                            var pathname = window.location.pathname;
                            window.location.href = pathname + "?" + searchParams;
                        } else {
                            var href = this.getAttribute("href"),
                                pathname = window.location.pathname,
                                search_url_size = window.location.search.length;
                            search_url_size ? (window.location.href = href + window.location.search) : (window.location.href = href);
                        }
                    });
                });
            var group__price_rangeBlocks = container.querySelectorAll(".filter-group-display__price-range-input");
            group__price_rangeBlocks.length &&
                document.addEventListener("change", function (e) {
                    var el = e.target;
                    if (el.classList.contains("filter-group-display__price-range-input")) {
                        var FitersFormEl = el.closest("form");
                        if (FitersFormEl) {
                            const formData = new FormData(FitersFormEl),
                                searchParams = new URLSearchParams(formData).toString();
                            var pathname = window.location.pathname;
                            window.location.href = pathname + "?" + searchParams;
                        }
                    }
                });
            var price_range_inputs = container.querySelectorAll(".price_range");
            price_range_inputs.length &&
                document.addEventListener("change", function (e) {
                    var el = e.target;
                    if (el.classList.contains("price_range")) {
                        var FitersFormEl = el.closest("form");
                        if (FitersFormEl) {
                            var prices_arr = [],
                                price_range_inputs2 = FitersFormEl.querySelectorAll(".filter-group-display__price-range-input"),
                                price_range_container = el.closest(".price_range_container");
                            if (
                                price_range_container &&
                                (price_range_container.querySelectorAll(".price_range").forEach(function (item, index) {
                                    var input_val = item.value * 1;
                                    prices_arr.push(input_val);
                                }),
                                price_range_inputs2.length)
                            ) {
                                var min = Math.min.apply(null, prices_arr),
                                    max = Math.max.apply(null, prices_arr);
                                (price_range_inputs2[0].value = min), (price_range_inputs2[1].value = max);
                            }
                            const formData = new FormData(FitersFormEl),
                                searchParams = new URLSearchParams(formData).toString();
                            var pathname = window.location.pathname;
                            window.location.href = pathname + "?" + searchParams;
                        }
                    }
                });
        }
        return MainSearchPage;
    })()),
    (theme.AdvancedSearch = (function () {
        function AdvancedSearch(container) {
            var _this = this;
            _this.container = container;
            var submit_btn = this.container.querySelector(".search-form__connected-submit");
            submit_btn &&
                submit_btn.addEventListener("click", function (e) {
                    e.preventDefault();
                    var form = this.closest("form"),
                        formValue = form.querySelector(".search-form__input").value,
                        formProductType = form.querySelector("#advanced-search-product-type").value,
                        productQuery = "" + formValue + "*" + (formProductType !== "" ? " AND product_type:" + formProductType : ""),
                        formAction = window.routes.searchUrl + "?q=" + productQuery + "&type=product";
                    debugger;
                    window.location.href = formAction;
                });
        }
        return AdvancedSearch;
    })()),
    (theme.CountdownTimer = (function () {
        function CountdownTimer(container) {
            this.container = container;
            var countdown_timer = this.container.querySelector(".countdown_timer");
            if (countdown_timer)
                var dateStr = countdown_timer.getAttribute("data-time"),
                    timer_behaviour = countdown_timer.getAttribute("data-timer_behaviour"),
                    countDownDate = new Date(dateStr).getTime(),
                    timerDaysElem = countdown_timer.querySelector(".timer-days .timer-value"),
                    timerHoursElem = countdown_timer.querySelector(".timer-hours .timer-value"),
                    timerMinutesElem = countdown_timer.querySelector(".timer-minutes .timer-value"),
                    timerSecondsElem = countdown_timer.querySelector(".timer-seconds .timer-value"),
                    x = setInterval(function () {
                        var now = new Date().getTime(),
                            distance = countDownDate - now;
                        if (distance <= 0)
                            if (timer_behaviour == "use_current_day") (countDownDate = new Date().setHours(23, 59, 59, 999)), (distance = countDownDate - now);
                            else if (timer_behaviour == "show_zeros") (timerDaysElem.innerHTML = "00"), (timerHoursElem.innerHTML = "00"), (timerMinutesElem.innerHTML = "00"), (timerSecondsElem.innerHTML = "00"), clearInterval(x);
                            else {
                                (timerDaysElem.innerHTML = "00"), (timerHoursElem.innerHTML = "00"), (timerMinutesElem.innerHTML = "00"), (timerSecondsElem.innerHTML = "00"), clearInterval(x);
                                var sectionEl = container.closest(".shopify-section");
                                sectionEl && (sectionEl.style.display = "none");
                            }
                        if (distance >= 0) {
                            var days = Math.floor(distance / 864e5),
                                hours = Math.floor((distance % (1e3 * 60 * 60 * 24)) / (1e3 * 60 * 60)),
                                minutes = Math.floor((distance % (1e3 * 60 * 60)) / (1e3 * 60)),
                                seconds = Math.floor((distance % (1e3 * 60)) / 1e3);
                            days < 10 && (days = "0" + days),
                                hours < 10 && (hours = "0" + hours),
                                minutes < 10 && (minutes = "0" + minutes),
                                seconds < 10 && (seconds = "0" + seconds),
                                (timerDaysElem.innerHTML = days),
                                (timerHoursElem.innerHTML = hours),
                                (timerMinutesElem.innerHTML = minutes),
                                (timerSecondsElem.innerHTML = seconds);
                        }
                    }, 1e3);
        }
        return CountdownTimer;
    })()),
    (theme.FeaturedProducts = (function () {
        function FeaturedProducts(container) {
            var tabs_nav = container.querySelector(".index-tabs_nav"),
                sliderEl = container.querySelector(".index-tabs-content_block__slider"),
                flickityInstance,
                slider_options;
            if (sliderEl) {
                (slider_options = JSON.parse(sliderEl.getAttribute("data-flickity-config"))), (flickityInstance = new Flickity(sliderEl, slider_options)), flickityInstance.element.classList.add("rendered");
                var slider_custom_arrows = container.querySelector(".slider_custom_arrows");
                if (slider_custom_arrows) {
                    var slider_custom_btns = slider_custom_arrows.querySelectorAll(".btn");
                    slider_custom_btns.forEach(function (item, index) {
                        item.addEventListener("click", function (e) {
                            e.preventDefault();
                            var isNext = item.classList.contains("button-next");
                            isNext ? flickityInstance.next() : flickityInstance.previous();
                        });
                    });
                }
            }
            tabs_nav &&
                tabs_nav.querySelectorAll(".index-tabs_nav--item").forEach(function (item, index) {
                    item.addEventListener("click", function (e) {
                        e.preventDefault();
                        var activeItem = tabs_nav.querySelector(".index-tabs_nav--item.active"),
                            href_tab = this.getAttribute("data-href"),
                            content_block = document.querySelector("#" + href_tab);
                        if (activeItem) {
                            activeItem.classList.remove("active");
                            var active_content_block = document.querySelector("#" + activeItem.getAttribute("data-href"));
                            if (active_content_block) {
                                active_content_block.classList.remove("active");
                                var tab_content_slider = active_content_block.querySelector(".index-tabs-content_block__slider");
                                tab_content_slider && tab_content_slider.classList.contains("flickity-enabled") && (flickityInstance.destroy(), flickityInstance.element.classList.remove("rendered"));
                            }
                        }
                        if ((this.classList.add("active"), content_block)) {
                            content_block.classList.add("active");
                            var tab_content_slider = content_block.querySelector(".index-tabs-content_block__slider");
                            if (tab_content_slider) {
                                (slider_options = JSON.parse(tab_content_slider.getAttribute("data-flickity-config"))),
                                    (flickityInstance = new Flickity(tab_content_slider, slider_options)),
                                    flickityInstance.element.classList.add("rendered"),
                                    flickityInstance.on("select", function (index2) {
                                        var elementsCount2 = container.querySelector(".flickity-slider").childElementCount;
                                    });
                                var elementsCount = tab_content_slider.querySelector(".flickity-slider").childElementCount;
                                slider_custom_arrows && (elementsCount > 1 ? slider_custom_arrows && slider_custom_arrows.classList.remove("hide") : slider_custom_arrows && slider_custom_arrows.classList.add("hide"));
                            }
                        }
                    });
                });
            var formsArr = container.querySelectorAll('[action="/cart/add"]');
            formsArr.length &&
                formsArr.forEach(function (form, index) {
                    theme.AddItemToCart(form);
                }),
                theme.ProductItemSwatches();
        }
        return FeaturedProducts;
    })()),
    (theme.CollectionListSection = (function () {
        function CollectionListSection(container) {
            var sectionCarousel = container.querySelector(".collection-list__slider");
            if (sectionCarousel) {
                var slider_options = JSON.parse(sectionCarousel.getAttribute("data-flickity-config")),
                    flickityInstance = new Flickity(sectionCarousel, slider_options);
                if (slider_options.watchCSS) {
                    let resizeMobileSliderHeight2 = function () {
                        var windowWidth = window.innerWidth;
                        windowWidth <= 1199 &&
                            (resizeMobileFlag ||
                                (flickityInstance.element.classList.contains("rendered") && flickityInstance.element.classList.remove("rendered"),
                                flickityInstance.resize(),
                                setTimeout(function () {
                                    flickityInstance.element.classList.add("rendered"), (resizeMobileFlag = !0);
                                }, 1e3)));
                    };
                    var resizeMobileSliderHeight = resizeMobileSliderHeight2,
                        resizeMobileFlag = !1;
                    resizeMobileSliderHeight2(), window.addEventListener("resize", resizeMobileSliderHeight2);
                } else flickityInstance.element.classList.add("rendered");
                var slider_custom_arrows = container.querySelector(".slider_custom_arrows");
                if (slider_custom_arrows) {
                    slider_options.watchCSS && slider_custom_arrows.classList.add("desktopHide");
                    var slider_custom_btns = slider_custom_arrows.querySelectorAll(".btn");
                    slider_custom_btns.forEach(function (item, index) {
                        item.addEventListener("click", function (e) {
                            if ((e.preventDefault(), flickityInstance)) {
                                var isNext = item.classList.contains("button-next");
                                isNext ? flickityInstance.next() : flickityInstance.previous();
                            }
                        });
                    });
                }
            }
            var formsArr = container.querySelectorAll('[action="/cart/add"]');
            formsArr.length &&
                formsArr.forEach(function (form, index) {
                    theme.AddItemToCart(form);
                }),
                theme.ProductItemSwatches();
        }
        return CollectionListSection;
    })()),
    (theme.AddItemToCart = function (form) {
        var self2 = this,
            addToCartBtn = form.querySelector('[type="submit"]');
        form &&
            form.addEventListener("submit", function (e) {
                e.preventDefault(),
                    fetch("/cart/add.js", { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/x-www-form-urlencoded", "X-Requested-With": "XMLHttpRequest" }, body: theme.Helpers.serialize(form) })
                        .then(function (response) {
                            return response.json();
                        })
                        .then(function (json) {
                            if (addToCartBtn) {
                                
                                var addToCartBtnText = addToCartBtn.querySelector("[data-add-to-cart-text]");
                                addToCartBtn.classList.add("added"), (addToCartBtnText.innerHTML = theme.strings.added_to_cart), theme.Cart.prototype._onProductAdded();
                                var pre_order_textEl = form.querySelector(".pre_order_text");
                                setTimeout(function () {
                                    if ((addToCartBtn.classList.remove("added"), self2.show_preOrder_btn)) {
                                        var isPreOrderBtn = addToCartBtn.hasAttribute("data-preOrderButton");
                                        isPreOrderBtn
                                            ? ((addToCartBtnText.innerHTML = theme.strings.preOrder), pre_order_textEl && pre_order_textEl.classList.remove("hide"))
                                            : ((addToCartBtnText.innerHTML = theme.strings.addToCart), pre_order_textEl && pre_order_textEl.classList.add("hide"));
                                    } else (addToCartBtnText.innerHTML = theme.strings.addToCart), pre_order_textEl && pre_order_textEl.classList.add("hide");
                                }, 2e3);
                            }
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
            });
    }),
    (theme.ProductItemSwatches = function () {
        document.addEventListener("change", function (e) {
            var target = e.target;
            if (target.classList.contains("color-swatch__radio")) {
                var productItem = target.closest(".product-card"),
                    variantUrl = target.getAttribute("data-variant-url");
                productItem.querySelector(".product-card__link-image").setAttribute("href", variantUrl), productItem.querySelector(".product-card__link-title").setAttribute("href", variantUrl);
                var originalImageElement = productItem.querySelector(".product-card__image");
                target.hasAttribute("data-image-url") &&
                    target.getAttribute("data-media-id") !== originalImageElement.getAttribute("data-media-id") &&
                    (originalImageElement.setAttribute("data-media-id", target.getAttribute("data-media-id")),
                    originalImageElement.setAttribute("srcset", target.getAttribute("data-image-url")),
                    originalImageElement.setAttribute("src", target.getAttribute("data-image-src")),
                    originalImageElement.setAttribute("width", target.getAttribute("ddata-image-width")),
                    originalImageElement.setAttribute("height", target.getAttribute("data-image-height")),
                    target.hasAttribute("data-max_img_width") && originalImageElement.setAttribute("style", target.getAttribute("data-max_img_width")));
                var productItemBlock = target.closest(".product-item-block");
                productItemBlock && productItemBlock.classList.contains("product-item-block--withAlternateImage") && productItemBlock.classList.remove("product-item-block--withAlternateImage");
            }
        });
    }),
    (theme.Product = (function () {
        function Product(container) {
            this.container = container;
            var sectionId = container.getAttribute("data-section-id");
            (this.ajaxEnabled = container.getAttribute("data-ajax-enabled") === "true"),
                (this.pickAnOption = container.getAttribute("data-show_pick_an_option") === "true"),
                (this.show_preOrder_btn = container.getAttribute("data-show_preOrder_btn") === "true"),
                (this.enableLinkedOptions = container.getAttribute("data-enable_linked_options") === "true");
            var productJsonElement = container.querySelector("[data-product-json]");
            if (productJsonElement) {
                var jsonData = JSON.parse(productJsonElement.innerHTML);
                (this.productData = jsonData.product), (this.productOptionsWithValues = jsonData.options_with_values), (this.variantsInventories = jsonData.inventories || {}), (this.lowInventoryThreshold = jsonData.lowInventoryThreshold);
            }
            (this.settings = {
                mediaQueryMediumUp: "screen and (min-width: 750px)",
                mediaQuerySmall: "screen and (max-width: 749px)",
                bpSmall: !1,
                enableHistoryState: !!container.getAttribute("data-enable-history-state") || !1,
                namespace: ".slideshow-" + sectionId,
                sectionId,
                sliderActive: !1,
                zoomEnabled: !1,
            }),
                (this.selectors = {
                    addToCart: "[data-add-to-cart]",
                    addToCartText: "[data-add-to-cart-text]",
                    cartCount: "[data-cart-count]",
                    cartCountBubble: "[data-cart-count-bubble]",
                    loader: "[data-loader]",
                    loaderStatus: "[data-loader-status]",
                    quantity: "[data-quantity-input]",
                    SKU: ".variant-sku",
                    productStatus: "[data-product-status]",
                    originalSelectorId: "#ProductSelect-" + sectionId,
                    productForm: "[data-product-form]",
                    errorMessage: "[data-error-message]",
                    errorMessageWrapper: "[data-error-message-wrapper]",
                    productMediaWrapper: "[data-product-single-media-wrapper]",
                    productThumbs: ".product-single__thumbnails-" + sectionId,
                    productThumbsWrapper: ".thumbnails-wrapper",
                    singleOptionSelector: ".single-option-selector-" + sectionId,
                    singleOptionColorSelector: ".single_option_color_selector-" + sectionId,
                    shopifyPaymentButton: ".shopify-payment-button",
                    productMediaTypeVideo: "[data-product-media-type-video]",
                    productMediaTypeModel: "[data-product-media-type-model]",
                    priceContainer: "[data-price]",
                    regularPrice: "[data-regular-price]",
                    salePrice: "[data-sale-price]",
                    unitPrice: "[data-unit-price]",
                    unitPriceBaseUnit: "[data-unit-price-base-unit]",
                    productPolicies: "[data-product-policies]",
                    storeAvailabilityContainer: "[data-store-availability-container]",
                    swatchesWrapper: ".product_swatches",
                }),
                (this.classes = {
                    hidden: "hide",
                    visibilityHidden: "visibility-hidden",
                    inputError: "input--error",
                    productOnSale: "price--on-sale",
                    productUnitAvailable: "price--unit-available",
                    productUnavailable: "price--unavailable",
                    productSoldOut: "price--sold-out",
                    productFormErrorMessageWrapperHidden: "product-form__error-message-wrapper--hidden",
                    activeClass: "active-thumb",
                    variantSoldOut: "product-form--variant-sold-out",
                }),
                (this.eventHandlers = {}),
                (this.quantityInput = container.querySelector(this.selectors.quantity)),
                (this.errorMessageWrapper = container.querySelector(this.selectors.errorMessageWrapper)),
                (this.productForm = container.querySelector(this.selectors.productForm)),
                (this.addToCart = container.querySelector(this.selectors.addToCart)),
                this.addToCart && (this.addToCartText = this.addToCart.querySelector(this.selectors.addToCartText)),
                (this.shopifyPaymentButton = container.querySelector(this.selectors.shopifyPaymentButton)),
                (this.priceContainer = container.querySelector(this.selectors.priceContainer)),
                (this.productPolicies = container.querySelector(this.selectors.productPolicies)),
                (this.storeAvailabilityContainer = container.querySelector(this.selectors.storeAvailabilityContainer)),
                this.storeAvailabilityContainer && this._initStoreAvailability(),
                (this.swatchesWrapper = container.querySelector(this.selectors.swatchesWrapper)),
                (this.loaderStatus = container.querySelector(this.selectors.loaderStatus));
            var send_gift_card_to_recipient = container.querySelector("#send_gift_card_to_recipient");
            send_gift_card_to_recipient &&
                send_gift_card_to_recipient.addEventListener("change", function (e) {
                    var send_gift_card_to_recipient_fields_wrapper = this.closest(".gift-card-recipient").querySelector(".gift-card-recipient__fields"),
                        send_gift_card_to_recipient_field_email = send_gift_card_to_recipient_fields_wrapper.querySelector(".gift-card-recipient-field-email");
                    send_gift_card_to_recipient_fields_wrapper &&
                        (this.checked
                            ? ((send_gift_card_to_recipient_fields_wrapper.style.maxHeight = send_gift_card_to_recipient_fields_wrapper.scrollHeight + "px"), send_gift_card_to_recipient_field_email.setAttribute("required", ""))
                            : ((send_gift_card_to_recipient_fields_wrapper.style.maxHeight = null), send_gift_card_to_recipient_field_email.removeAttribute("required")));
                });
            var qty_btns = container.querySelectorAll(".qty_btn");
            qty_btns.length &&
                qty_btns.forEach(function (item, index) {
                    item.addEventListener("click", function (e) {
                        e.preventDefault();
                        var inputEl = this.closest(".qty").querySelector('[name="quantity"]'),
                            qty = +inputEl.value;
                        this.classList.contains("minus_btn") ? qty-- : qty++, qty <= 1 && (qty = 1), (inputEl.value = qty);
                    });
                });
            var product_description_accrordion = container.querySelectorAll(".product_description_accrordion");
            if (product_description_accrordion.length) {
                var isReviewAccordion = !1;
                product_description_accrordion.forEach(function (accordionEl, index) {
                    var product_accordion__blocks = accordionEl.querySelectorAll(".product_accordion__block");
                    product_accordion__blocks.length &&
                        product_accordion__blocks.forEach(function (accordionBlock, index2) {
                            var title = accordionBlock.querySelector(".product_accordion__heading"),
                                content = accordionBlock.querySelector(".product_accordion__content");
                            title.addEventListener("click", function (e) {
                                e.preventDefault();
                                var self2 = this;
                                if (content.classList.contains("active")) {
                                    var height = content.clientHeight + "px";
                                    (content.style.height = height),
                                        content.getAttribute("style") != null
                                            ? (setTimeout(function () {
                                                  content.style.height = "0px";
                                              }, 0),
                                              content.addEventListener(
                                                  "transitionend",
                                                  function () {
                                                      content.classList.remove("active"), self2.classList.remove("active");
                                                  },
                                                  { once: !0 }
                                              ))
                                            : (content.classList.remove("active"), self2.classList.remove("active"));
                                } else {
                                    self2.classList.add("active"), content.classList.add("active"), (content.style.height = "auto");
                                    var height = content.clientHeight + "px";
                                    (content.style.height = "0px"),
                                        content.addEventListener(
                                            "transitionend",
                                            function () {
                                                content.style.height = "auto";
                                            },
                                            { once: !0 }
                                        ),
                                        setTimeout(function () {
                                            content.style.height = height;
                                        }, 0);
                                }
                            });
                        });
                    var contaisReviews = accordionEl.querySelector("#shopify-product-reviews");
                    contaisReviews && (isReviewAccordion = !0);
                });
            }
            var tabing = container.querySelector(".tabing");
            tabing &&
                tabing.querySelectorAll(".nav-tabs a").forEach(function (item, index) {
                    item.addEventListener("click", function (e) {
                        e.preventDefault();
                        var navParent = this.closest(".nav-tabs"),
                            href = this.getAttribute("href"),
                            tab_contentWrapper = container.querySelector(".tab-content"),
                            tabContent = tab_contentWrapper.querySelector(href);
                        tabContent &&
                            (navParent.querySelector(".active").classList.remove("active"),
                            tab_contentWrapper.querySelector(".active").classList.remove("active"),
                            tabContent.classList.add("active"),
                            this.parentNode.classList.add("active"));
                    });
                });
            var productJson = document.getElementById("ProductJson-" + sectionId);
            if (!(!productJson || !productJson.innerHTML.length)) {
                if (
                    ((this.productSingleObject = JSON.parse(productJson.innerHTML)),
                    (this.productState = { available: !0, soldOut: !1, onSale: !1, showUnitPrice: !1 }),
                    this._stringOverrides(),
                    this._initVariants(),
                    this._initAddToCart(),
                    this._initProductVideo(),
                    this._initModelViewerLibraries(),
                    this._initShopifyXrLaunch(),
                    this._initSwatches(),
                    this.enableLinkedOptions)
                ) {
                    let inArray2 = function (needle, haystack) {
                        if (haystack) return haystack.indexOf(needle) !== -1;
                    };
                    var inArray = inArray2,
                        _this = this,
                        parentForm = _this.container.querySelector("[data-product-form]"),
                        initialValue,
                        availableOptions,
                        selector,
                        checkOptions = function () {
                            var updateOptions = !0;
                            if (_this.pickAnOption) {
                                var selectOptions = parentForm.querySelectorAll(".single-option-selector");
                                selectOptions.length &&
                                    selectOptions.forEach(function (selectOption) {
                                        var select_value = selectOption.value;
                                        select_value.length == 0 && (updateOptions = !1);
                                    });
                            }
                            return updateOptions;
                        },
                        Shopify2 = Shopify2 || {};
                    if (
                        ((Shopify2.arrayIncludes = function (e, t) {
                            for (var n = 0; n < e.length; n++) if (e[n] == t) return !0;
                            return !1;
                        }),
                        (Shopify2.uniq = function (e) {
                            for (var t = [], n = 0; n < e.length; n++) Shopify2.arrayIncludes(t, e[n]) || t.push(e[n]);
                            return t;
                        }),
                        (Shopify2.optionsMap = {}),
                        (Shopify2.updateOptionsInSelector = function (selectorIndex) {
                            switch (selectorIndex) {
                                case 0:
                                    var key = "root";
                                    selector = parentForm.querySelector(".single-option-selector");
                                    break;
                                case 1:
                                    var key = parentForm.querySelector(".single-option-selector").value;
                                    selector = parentForm.querySelectorAll(".single-option-selector")[1];
                                    break;
                                case 2:
                                    var key = parentForm.querySelector(".single-option-selector").value;
                                    (key += " / " + parentForm.querySelectorAll(".single-option-selector")[1].value), (selector = parentForm.querySelectorAll(".single-option-selector")[2]);
                            }
                            var check_swatch = !0;
                            if (_this.pickAnOption && selectorIndex != 0) {
                                var optionSelect = _this.variants.singleOptions[selectorIndex];
                                if (optionSelect) {
                                    var optionSelectVal = optionSelect.value;
                                    optionSelectVal.length == 0 && (check_swatch = !1);
                                }
                            }
                            (initialValue = selector.value), (selector.innerHTML = ""), (availableOptions = Shopify2.optionsMap[key]);
                            for (var i = 0; i < availableOptions.length; i++) {
                                var option = availableOptions[i],
                                    newOption = document.createElement("option");
                                (newOption.value = option), (newOption.innerHTML = option), selector.appendChild(newOption);
                            }
                            var swatchElements = parentForm.querySelectorAll('.swatch[data-option-index="' + selectorIndex + '"] .swatch-element');
                         
                            if (swatchElements.length) {
                                swatchElements.forEach(function (item, index) {
                                    var itemValue = item.getAttribute("data-value"),
                                        itemRadioBtn = item.querySelector('[type="radio"]');
                                    inArray2(itemValue, availableOptions)
                                        ? (item.classList.remove("soldout"), (item.style.display = "flex"), itemRadioBtn && itemRadioBtn.removeAttribute("disabled"))
                                        : (item.classList.add("soldout"), (item.style.display = "none"), itemRadioBtn && (itemRadioBtn.getAttribute("disabled", "disabled"), (itemRadioBtn.checked = !1)));
                                });
                                var inputElements = Array.from(parentForm.querySelectorAll('.swatch[data-option-index="' + selectorIndex + '"] .swatch-element input:checked'));
                                if (inputElements.length == 0) {
                                    var swatchFirstElements = Array.from(parentForm.querySelectorAll('.swatch[data-option-index="' + selectorIndex + '"] .swatch-element:not(.soldout)'));
                                    if (swatchFirstElements.length > 0) {
                                        var firstInput = swatchFirstElements[0].querySelector("input");
                                        firstInput.checked = !0;
                                    }
                                }
                                firstInput && firstInput.dispatchEvent(new Event("change", { bubbles: !0 }));
                            }
                            if (inArray2(initialValue, availableOptions)) {
                                console.log("sdasdasd");
                                if (selector) {
                                    if (check_swatch) selector.value = initialValue;
                                    else {
                                        selector.selectedIndex = -1;
                                        var opt = document.createElement("option");
                                        (opt.value = ""), opt.setAttribute("disabled", "disabled"), opt.setAttribute("selected", "selected"), (opt.innerHTML = theme.strings.pick_an_option), selector.prepend(opt);
                                    }
                                    var activeSwatch = parentForm.querySelector(`.swatch[data-option-index="${selectorIndex}"] .swatch-element[data-value="${initialValue.replace(/"/g, "&quot;")}"] [type="radio"]`);
                                    activeSwatch && check_swatch && (activeSwatch.checked = !0);
                                }
                            } else if (selector)
                                if (check_swatch) (selector.value = availableOptions[0]), selector.dispatchEvent(new Event("change", { bubbles: !0 }));
                                else {
                                    selector.selectedIndex = -1;
                                    var opt = document.createElement("option");
                                    (opt.value = ""), opt.setAttribute("disabled", "disabled"), opt.setAttribute("selected", "selected"), (opt.innerHTML = theme.strings.pick_an_option), selector.prepend(opt);
                                }
                        }),
                        (Shopify2.linkOptionSelectors = function (product) {
                            if (product) {
                                for (var i = 0; i < product.variants.length; i++) {
                                    var variant2 = product.variants[i];
                                    if (variant2.available) {
                                        if (
                                            ((Shopify2.optionsMap.root = Shopify2.optionsMap.root || []),
                                            Shopify2.optionsMap.root.push(variant2.option1),
                                            (Shopify2.optionsMap.root = Shopify2.uniq(Shopify2.optionsMap.root)),
                                            product.options.length > 1)
                                        ) {
                                            var key = variant2.option1;
                                            (Shopify2.optionsMap[key] = Shopify2.optionsMap[key] || []), Shopify2.optionsMap[key].push(variant2.option2), (Shopify2.optionsMap[key] = Shopify2.uniq(Shopify2.optionsMap[key]));
                                        }
                                        if (product.options.length === 3) {
                                            var key = variant2.option1 + " / " + variant2.option2;
                                            (Shopify2.optionsMap[key] = Shopify2.optionsMap[key] || []), Shopify2.optionsMap[key].push(variant2.option3), (Shopify2.optionsMap[key] = Shopify2.uniq(Shopify2.optionsMap[key]));
                                        }
                                    }
                                }
                                checkOptions() && (Shopify2.updateOptionsInSelector(0), product.options.length > 1 && Shopify2.updateOptionsInSelector(1), product.options.length === 3 && Shopify2.updateOptionsInSelector(2));
                                var firstSelectEl = parentForm.querySelectorAll(".single-option-selector")[0];
                                firstSelectEl &&
                                    firstSelectEl.addEventListener("change", function () {
                                        return checkOptions() && Shopify2.updateOptionsInSelector(1), product.options.length === 3 && checkOptions() && Shopify2.updateOptionsInSelector(2), !0;
                                    });
                                var secondSelectEl = parentForm.querySelectorAll(".single-option-selector")[1];
                                secondSelectEl &&
                                    secondSelectEl.addEventListener("change", function () {
                                        return checkOptions() && (_this.pickAnOption && Shopify2.updateOptionsInSelector(1), product.options.length === 3 && Shopify2.updateOptionsInSelector(2)), !0;
                                    });
                            }
                        }),
                        _this.productData.available && _this.productData.options.length > 1 && _this.productData.variants.length > 1 && window.MutationObserver && parentForm.length)
                    ) {
                        typeof observer == "object" && typeof observer.disconnect == "function" && observer.disconnect();
                        var config = { childList: !0, subtree: !0 },
                            observer = new MutationObserver(function () {
                                Shopify2.linkOptionSelectors(_this.productData), observer.disconnect();
                            });
                        observer.observe(parentForm, config);
                    }
                    var selector = parentForm.querySelector(".single-option-selector");
                    if ((selector && selector.dispatchEvent(new Event("change", { bubbles: !0 })), _this.productData.options.length == 1)) {
                       console.log("1212");
                        for (var v = 0; v < _this.productData.variants.length; v++) {
                            var variant = _this.productData.variants[v];
                            if (!variant.available) {
                                var allSelectOptionsEl = parentForm.querySelectorAll(".single-option-selector option");
                                allSelectOptionsEl.length &&
                                    allSelectOptionsEl.forEach(function (item, index) {
                                        var itemText = item.innerHTML.trim();
                                        if (itemText == variant.title) {
                                            item.parentNode.removeChild(item);
                                            var swatchEl = parentForm.querySelector(".product_swatches [data-value='" + variant.title + "']");
                                            swatchEl && swatchEl.parentNode.removeChild(swatchEl);
                                        }
                                    });
                            }
                        }
                        var selectors2 = parentForm.querySelectorAll(".single-option-selector");
                        selectors2.length &&
                            (selectors2.forEach(function (select, index) {
                                select.dispatchEvent(new Event("change", { bubbles: !0 }));
                            }),
                            selector.dispatchEvent(new Event("change", { bubbles: !0 })));
                    }
                }
                var back_in_stock_row = container.querySelector(".back_in_stock_row");
                if (back_in_stock_row) {
                    var back_in_stock_button = back_in_stock_row.querySelector(".back_in_stock_btn"),
                        contact_formID = back_in_stock_row.getAttribute("data-id"),
                        contactFormEl = document.querySelector("#" + contact_formID);
                    if (contactFormEl) {
                        var formStatusBlock = contactFormEl.querySelector(".form-status"),
                            formStatusBlockValue = formStatusBlock.innerHTML.trim();
                        if (formStatusBlockValue.length > 0) {
                            var back_in_stock_response = back_in_stock_row.querySelector(".back_in_stock_response");
                            back_in_stock_response &&
                                ((back_in_stock_response.innerHTML = formStatusBlockValue),
                                back_in_stock_response.classList.add("active"),
                                formStatusBlockValue.indexOf("form-message--success") >= 0 && back_in_stock_response.classList.add("success_response"),
                                back_in_stock_row.classList.remove("hide"));
                        }
                    }
                    back_in_stock_button &&
                        back_in_stock_button.addEventListener("click", function (e) {
                            e.preventDefault();
                            var back_in_stock_input = back_in_stock_row.querySelector(".Form__Input");
                            if (back_in_stock_input) {
                                var back_in_stock_input_val = back_in_stock_input.value,
                                    contactFormEl2 = document.querySelector("#" + contact_formID);
                                contactFormEl2 && ((contactFormEl2.querySelector(".contact-form_email").value = back_in_stock_input_val), contactFormEl2.submit());
                            }
                        });
                }
                var stickyBtnsParentEl = container.querySelector(".product-form-sticky-parent");
                if (stickyBtnsParentEl) {
                    let checkStickyCTA2 = function () {
                        var stickyBtnsParentHeight = stickyBtnsParentEl.offsetHeight,
                            headerEl = document.querySelector("[data-header-section]"),
                            bottomOffsetButton = stickyBtnsParentEl.offsetTop + stickyBtnsParentEl.offsetHeight + headerEl.offsetHeight,
                            productMetaEl = container.querySelector(".product-single__meta");
                        stickyBtnsParentEl.style.minHeight = stickyBtnsParentHeight + "px";
                        var window_scrollY = window.scrollY;
                        window_scrollY > bottomOffsetButton ? productMetaEl.classList.add("enabled_mobile_sticky_btns") : productMetaEl.classList.remove("enabled_mobile_sticky_btns");
                    };
                    var checkStickyCTA = checkStickyCTA2;
                    document.addEventListener("resize", checkStickyCTA2), document.addEventListener("scroll", checkStickyCTA2);
                }
                var form_popup_linkEl = container.querySelector(".form_popup_link");
                if (
                    form_popup_linkEl &&
                    (document.addEventListener("click", function (e) {
                        var target = e.target;
                        if (target.classList.contains("form_popup_link") || target.closest(".form_popup_link")) {
                            target.classList.contains("form_popup_link") || (target = target.closest(".form_popup_link")), e.preventDefault();
                            var modal2 = document.querySelector(target.getAttribute("href"));
                            modal2 && (document.querySelector("body").classList.add("show_overlay"), document.querySelector("body").classList.add("active_product_form_popup"), modal2.setAttribute("aria-hidden", "false"));
                        }
                    }),
                    document.addEventListener("click", function (e) {
                        var el = e.target;
                        if (el.classList.contains("close_form_popup") || el.closest(".close_form_popup")) {
                            e.preventDefault();
                            var modal2 = el.closest(".modal");
                            modal2.setAttribute("aria-hidden", "true"), document.querySelector("body").classList.remove("show_overlay"), document.querySelector("body").classList.remove("active_product_form_popup");
                        }
                    }),
                    document.querySelector(".active_product_form_popup"))
                ) {
                    var modal = document.querySelector(".form_popup");
                    modal && (document.querySelector("body").classList.add("show_overlay"), modal.setAttribute("aria-hidden", "false"));
                }
                var complementary_productsEl = container.querySelector(".complementary-products");
                if (complementary_productsEl) {
                    var recommendationsSectionUrl = complementary_productsEl.getAttribute("data-url");
                    window.performance.mark("pursuit:product:fetch_product_recommendations.start");
                    var complementary_products_wrapperEl = complementary_productsEl.querySelector(".complementary-products-slider");
                    fetch(recommendationsSectionUrl)
                        .then(function (response) {
                            return response.text();
                        })
                        .then(function (productHtml) {
                            if (productHtml.trim() !== "") {
                                var tempDiv = document.createElement("div");
                                tempDiv.innerHTML = productHtml;
                                var new_complementary_products_wrapperEl = tempDiv.querySelector(".complementary-products-slider"),
                                    new_complementary_products_arr = new_complementary_products_wrapperEl.querySelectorAll(".complementary_products_slide");
                                if (complementary_products_wrapperEl && new_complementary_products_arr.length) {
                                    (complementary_products_wrapperEl.innerHTML = new_complementary_products_wrapperEl.innerHTML), (complementary_products_wrapperEl.innerHTML = complementary_products_wrapperEl.firstElementChild.innerHTML);
                                    var add_Complementary_products = complementary_productsEl.querySelectorAll(".add_Complementary_product");
                                    add_Complementary_products.length &&
                                        add_Complementary_products.forEach(function (btn, index) {
                                            btn.addEventListener("click", function (e) {
                                                e.preventDefault();
                                                var itemId = btn.getAttribute("data-variant-id") * 1,
                                                    formData = { items: [{ id: itemId, quantity: 1 }] };
                                                fetch("/cart/add.js", { method: "POST", method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(formData) })
                                                    .then(function (response) {
                                                        return response.json();
                                                    })
                                                    .then(function (json) {
                                                        var addToCartBtnText = btn.querySelector("[data-add-to-cart-text]");
                                                        btn.classList.add("added"),
                                                            (addToCartBtnText.innerHTML = theme.strings.added_to_cart),
                                                            theme.Cart.prototype._onProductAdded(),
                                                            setTimeout(function () {
                                                                console.log("sdadasd");
                                                                if ((btn.classList.remove("added"), self.show_preOrder_btn)) {
                                                                    var isPreOrderBtn = btn.hasAttribute("data-preOrderButton");
                                                                    isPreOrderBtn ? (addToCartBtnText.innerHTML = theme.strings.preOrder) : (addToCartBtnText.innerHTML = theme.strings.addToCart);
                                                                } else addToCartBtnText.innerHTML = theme.strings.addToCart;
                                                            }, 2e3);
                                                    })
                                                    .catch(function (error) {
                                                        console.log(error);
                                                    });
                                            });
                                        });
                                    let slider_options = JSON.parse(complementary_products_wrapperEl.getAttribute("data-flickity-config"));
                                    var flickityInstance = new Flickity(complementary_products_wrapperEl, slider_options),
                                        slider_custom_arrows = complementary_productsEl.querySelector(".complementary-products-slider_custom_arrows");
                                    if (slider_custom_arrows) {
                                        var slider_custom_btns = slider_custom_arrows.querySelectorAll(".btn");
                                        slider_custom_btns.forEach(function (item, index) {
                                            item.addEventListener("click", function (e) {
                                                e.preventDefault();
                                                var isNext = item.classList.contains("button-next");
                                                isNext ? flickityInstance.next() : flickityInstance.previous();
                                            });
                                        });
                                    }
                                } else complementary_productsEl.style.display = "none";
                                new_complementary_products_wrapperEl.remove(),
                                    window.performance.mark("pursuit:product:fetch_product_recommendations.end"),
                                    performance.measure("pursuit:product:fetch_product_recommendations", "pursuit:product:fetch_product_recommendations.start", "pursuit:product:fetch_product_recommendations.end");
                            }
                        });
                }
            }
        }
        return (
            (Product.prototype = Object.assign({}, Product.prototype, {
                _stringOverrides: function () {
                    (theme.productStrings = theme.productStrings || {}), (theme.strings = Object.assign({}, theme.strings, theme.productStrings));
                },
                _initStoreAvailability: function () {
                    this.storeAvailability = new theme.StoreAvailability(this.storeAvailabilityContainer);
                    var storeAvailabilityModalOpenedCallback = function (event) {
                        this.cartPopupWrapper && !this.cartPopupWrapper.classList.contains(this.classes.cartPopupWrapperHidden) && this._hideCartPopup(event);
                    };
                    this.storeAvailabilityContainer.addEventListener("storeAvailabilityModalOpened", storeAvailabilityModalOpenedCallback.bind(this));
                },
                _initVariants: function () {
                    
                    var enableHistoryStateFlag = !1;
                    this.container.getAttribute("data-enable-history-state") == "true" && (enableHistoryStateFlag = !0);
                    var options = {
                        container: this.container,
                        enableHistoryState: enableHistoryStateFlag,
                        singleOptionSelector: this.selectors.singleOptionSelector,
                        singleOptionColorSelector: this.selectors.singleOptionColorSelector,
                        originalSelectorId: this.selectors.originalSelectorId,
                        product: this.productSingleObject,
                        pickAnOption: this.pickAnOption,
                        show_preOrder_btn: this.show_preOrder_btn,
                        enableLinkedOptions: this.enableLinkedOptions,
                    };
                    if (
                        ((this.variants = new slate.Variants(options)),
                        this.storeAvailability && this.variants.currentVariant.available && this.storeAvailability.updateContent(this.variants.currentVariant.id),
                        (this.eventHandlers.updateAvailability = this._updateAvailability.bind(this)),
                        (this.eventHandlers.updatePrice = this._updatePrice.bind(this)),
                        (this.eventHandlers.updateSKU = this._updateSKU.bind(this)),
                        this.container.addEventListener("variantChange", this.eventHandlers.updateAvailability),
                        this.container.addEventListener("variantPriceChange", this.eventHandlers.updatePrice),
                        this.container.addEventListener("variantSKUChange", this.eventHandlers.updateSKU),
                        this.pickAnOption)
                    ) {
                        
                        var variantsSize = this.productData.variants.length;
                        if (variantsSize > 1) {
                            var singleOptionSelectors = this.productForm.querySelectorAll(this.selectors.singleOptionSelector),
                                submitFormButton = this.productForm.querySelector(this.selectors.addToCart);
                            if (
                                (singleOptionSelectors.length &&
                                    singleOptionSelectors.forEach(function (item, index) {
                                        item.selectedIndex = -1;
                                        var opt = document.createElement("option");
                                        (opt.value = ""), opt.setAttribute("disabled", "disabled"), opt.setAttribute("selected", "selected"), (opt.innerHTML = theme.strings.pick_an_option), item.prepend(opt);
                                    }),
                                submitFormButton)
                            ) {
                                var submitFormButtonText = submitFormButton.querySelector(this.selectors.addToCartText);
                                submitFormButtonText && (submitFormButton.setAttribute("disabled", "disabled"), (submitFormButtonText.innerHTML = theme.strings.pick_an_option));
                            }
                            this.productForm.classList.add("disabled_btns"),
                                this.swatchesWrapper &&
                                    this.swatchesWrapper.querySelectorAll('[type="radio"]').forEach(function (item, index) {
                                        item.checked = !1;
                                    });
                        }
                    }
                },
                _initAddToCart: function () {
                    var self2 = this,
                        addToCartBtn = this.productForm.querySelector('[type="submit"]');
                    this.productForm.addEventListener("submit", function (e) {
                        e.preventDefault(),
                            fetch("/cart/add.js", {
                                method: "POST",
                                credentials: "same-origin",
                                headers: { "Content-Type": "application/x-www-form-urlencoded", "X-Requested-With": "XMLHttpRequest" },
                                body: theme.Helpers.serialize(self2.productForm),
                            })
                                .then(function (response) {
                                    return response.json();
                                })
                                .then(function (json) {
                                    if (addToCartBtn) {
                                        var addToCartBtnText = addToCartBtn.querySelector("[data-add-to-cart-text]");
                                        
                                        json.status == 422
                                            ? (typeof json.description != "object" ? self2._showErrorMessage(json.description) : self2._showErrorMessage(json.message), (addToCartBtnText.innerHTML = theme.strings.addToCart))
                                            : (addToCartBtn.classList.add("added"),
                                              (addToCartBtnText.innerHTML = theme.strings.added_to_cart),
                                              theme.Cart.prototype._onProductAdded(),
                                              $('.stciky-add-to-cart-text').css({"opacity":"0"}),
                                              $('.load-more-wrap').show(),
                                              $('.product-atc-text').css({"opacity":"0"}),
                                              $('.product-form__cart-submit').find('.product-atc-loader').removeClass('hide'),
                                              setTimeout(function () {
                                                  $('.load-more-wrap').hide();
                                                  $('.stciky-add-to-cart-text').css({"opacity":"1"});
                                                  $('.product-form__cart-submit').find('.product-atc-loader').addClass('hide'),
                                                  $('.product-atc-text').css({"opacity":"1"}),
                                                  addToCartBtn.classList.remove("added");
                                                  var pre_order_textEl = self2.container.querySelector(".pre_order_text");
                                                  if (self2.show_preOrder_btn) {
                                                      var originalSelectorId = self2.variants.originalSelectorId,
                                                          originalSelector = self2.container.querySelector(originalSelectorId);
                                                      if (originalSelector) {
                                                          var selectedElement = originalSelector.item(originalSelector.selectedIndex),
                                                              inventory_policy = selectedElement.getAttribute("data-inventory_policy"),
                                                              inventory_quantity = selectedElement.getAttribute("data-inventory_quantity") * 1;
                                                          inventory_policy == "continue" && inventory_quantity <= 0
                                                              ? ((addToCartBtnText.innerHTML = theme.strings.preOrder), pre_order_textEl && pre_order_textEl.classList.add("hide"))
                                                              : ((addToCartBtnText.innerHTML = theme.strings.addToCart), pre_order_textEl && pre_order_textEl.classList.add("hide"));
                                                      }
                                                  } else (addToCartBtnText.innerHTML = theme.strings.addToCart), pre_order_textEl && pre_order_textEl.classList.add("hide");
                                              }, 2e3));
                                    }
                                    if (addToCartBtn.hasAttribute("data-limited-quantity")) {
                                        var limitedQuantity = addToCartBtn.getAttribute("data-limited-quantity");
                                        console.log(limitedQuantity);
                                        if (limitedQuantity) {
                                          addToCartBtn.setAttribute("disabled", "disabled");
                                        }
                                    }
                                })
                                .catch(function (error) {
                                    console.log(error), self2._showErrorMessage(error.isFromServer && error.message.length ? error.message : theme.strings.cartError);
                                });
                    });
                },
                _initProductVideo: function () {
                    var sectionId = this.settings.sectionId,
                        productMediaTypeVideo = this.container.querySelectorAll(this.selectors.productMediaTypeVideo);
                    productMediaTypeVideo.forEach(function (el) {
                        theme.ProductVideo.init(el, sectionId);
                    });
                },
                _initModelViewerLibraries: function () {
                    var modelViewerElements = this.container.querySelectorAll(this.selectors.productMediaTypeModel);
                    modelViewerElements.length < 1 || theme.ProductModel.init(modelViewerElements, this.settings.sectionId);
                },
                _initShopifyXrLaunch: function () {
                    (this.eventHandlers.initShopifyXrLaunchHandler = this._initShopifyXrLaunchHandler.bind(this)), document.addEventListener("shopify_xr_launch", this.eventHandlers.initShopifyXrLaunchHandler);
                },
                _initShopifyXrLaunchHandler: function () {
                    var currentMedia = this.container.querySelector(this.selectors.productMediaWrapper + ":not(." + self.classes.hidden + ")");
                    currentMedia.dispatchEvent(new CustomEvent("xrLaunch", { bubbles: !0, cancelable: !0 }));
                },
                _showErrorMessage: function (errorMessage) {
                    var errorMessageContainer = this.container.querySelector(this.selectors.errorMessage);
                    (errorMessageContainer.innerHTML = errorMessage),
                        this.quantityInput && this.quantityInput.classList.add(this.classes.inputError),
                        this.errorMessageWrapper.classList.remove(this.classes.productFormErrorMessageWrapperHidden),
                        this.errorMessageWrapper.setAttribute("aria-hidden", !0),
                        this.errorMessageWrapper.removeAttribute("aria-hidden");
                },
                _hideErrorMessage: function () {
                    this.errorMessageWrapper.classList.add(this.classes.productFormErrorMessageWrapperHidden), this.quantityInput && this.quantityInput.classList.remove(this.classes.inputError);
                },
                _enableAddToCart: function (message) {
                    this.addToCart && (this.addToCart.removeAttribute("aria-disabled"), this.addToCart.setAttribute("aria-label", message)),
                        this.addToCartText && (this.addToCartText.innerHTML = message),
                        this.productForm && this.productForm.classList.remove(this.classes.variantSoldOut);
                },
                _disableAddToCart: function (message) {
                    (message = message || theme.strings.unavailable),
                        this.addToCart && (this.addToCart.setAttribute("aria-disabled", !0), this.addToCart.setAttribute("aria-label", message)),
                        this.addToCartText && (this.addToCartText.innerHTML = message),
                        this.productForm && this.productForm.classList.add(this.classes.variantSoldOut);
                },
                _updateAddToCart: function () {
                    var pre_order_textEl = this.container.querySelector(".pre_order_text");
                    if (!this.productState.available) {
                        this._disableAddToCart(theme.strings.unavailable);
                        return;
                    }
                    if (this.productState.soldOut) {
                        this._disableAddToCart(theme.strings.soldOut), pre_order_textEl && pre_order_textEl.classList.add("hide");
                        return;
                    }
                    if (this.show_preOrder_btn) {
                        var originalSelectorId = this.variants.originalSelectorId,
                            originalSelector = this.container.querySelector(originalSelectorId);
                        if (originalSelector) {
                            var selectedElement = originalSelector.item(originalSelector.selectedIndex),
                                inventory_policy = selectedElement.getAttribute("data-inventory_policy"),
                                inventory_quantity = selectedElement.getAttribute("data-inventory_quantity") * 1;
                            inventory_policy == "continue" && inventory_quantity <= 0
                                ? (this._enableAddToCart(theme.strings.preOrder), pre_order_textEl && pre_order_textEl.classList.remove("hide"))
                                : (this._enableAddToCart(theme.strings.addToCart), pre_order_textEl && pre_order_textEl.classList.add("hide"));
                        }
                    } else this._enableAddToCart(theme.strings.addToCart), pre_order_textEl && pre_order_textEl.classList.add("hide");
                },
                _setProductState: function (evt) {
                    var variant = evt.detail.variant;
                    if (!variant) {
                        this.productState.available = !1;
                        return;
                    }
                    (this.productState.available = !0), (this.productState.soldOut = !variant.available), (this.productState.onSale = variant.compare_at_price > variant.price), (this.productState.showUnitPrice = !!variant.unit_price);
                },
                _updateInventoryQuantity: function (evt) {
                    var variant = evt.detail.variant;
                    if (variant) {
                        var inventory_qty_info = this.container.querySelector(".inventory_qty_info");
                        if (inventory_qty_info) {
                            var variantInventoryIcon = this.variantsInventories[variant.id].inventory_icon,
                                variantInventoryType = this.variantsInventories[variant.id].inventory_type,
                                variantInventoryMessage = this.variantsInventories[variant.id].inventory_message,
                                inventory_icon_statusEl = this.container.querySelector(".product-form__inventory-icon-status"),
                                inventory_iconEl = inventory_icon_statusEl.querySelector("load-icon"),
                                inventory_textEl = this.container.querySelector(".product-form__inventory-text");
                            inventory_icon_statusEl.classList.remove("text-success"),
                                inventory_icon_statusEl.classList.remove("text-warning"),
                                inventory_icon_statusEl.classList.remove("text-danger"),
                                inventory_icon_statusEl.classList.add("text-" + variantInventoryType),
                                inventory_iconEl.setAttribute("name", variantInventoryIcon),
                                typeof inventory_iconEl.render < "u" && inventory_iconEl.render(),
                                (inventory_textEl.innerHTML = variantInventoryMessage);
                        }
                        var back_in_stock_row = this.container.querySelector(".back_in_stock_row");
                        back_in_stock_row && (variant.available ? back_in_stock_row.classList.add("hide") : back_in_stock_row.classList.remove("hide"));
                        var contant_form_current_variant_title = document.querySelector("#contant_form_current_variant_title");
                        contant_form_current_variant_title && (contant_form_current_variant_title.value = variant.title);
                    }
                },
                _updateAvailability: function (evt) {
                    this._hideErrorMessage(), this._setProductState(evt), this._updateInventoryQuantity(evt), this._updateStoreAvailabilityContent(evt), this._updatePriceComponentStyles(evt), this._updateAddToCart();
                },
                _updateStoreAvailabilityContent: function (evt) {
                    this.storeAvailability && (this.productState.available && !this.productState.soldOut ? this.storeAvailability.updateContent(evt.detail.variant.id) : this.storeAvailability.clearContent());
                },
                _hidePriceComponent: function () {
                    this.priceContainer.classList.add(this.classes.productUnavailable), this.priceContainer.setAttribute("aria-hidden", !0), this.productPolicies && this.productPolicies.classList.add(this.classes.visibilityHidden);
                },
                _updatePriceComponentStyles: function (evt) {
                    var variant = evt.detail.variant,
                        unitPriceBaseUnit = this.priceContainer.querySelector(this.selectors.unitPriceBaseUnit);
                    if (!this.productState.available) {
                        this._hidePriceComponent();
                        return;
                    }
                    this.productState.soldOut ? this.priceContainer.classList.add(this.classes.productSoldOut) : this.priceContainer.classList.remove(this.classes.productSoldOut),
                        this.productState.showUnitPrice
                            ? ((unitPriceBaseUnit.innerHTML = this._getBaseUnit(variant)), this.priceContainer.classList.add(this.classes.productUnitAvailable))
                            : this.priceContainer.classList.remove(this.classes.productUnitAvailable),
                        this.productState.onSale ? this.priceContainer.classList.add(this.classes.productOnSale) : this.priceContainer.classList.remove(this.classes.productOnSale),
                        this.priceContainer.classList.remove(this.classes.productUnavailable),
                        this.priceContainer.removeAttribute("aria-hidden"),
                        this.productPolicies && this.productPolicies.classList.remove(this.classes.visibilityHidden);
                },
                _updatePrice: function (evt) {
                    var variant = evt.detail.variant,
                        regularPrices = this.priceContainer.querySelectorAll(this.selectors.regularPrice),
                        salePrice = this.priceContainer.querySelector(this.selectors.salePrice),
                        unitPrice = this.priceContainer.querySelector(this.selectors.unitPrice),
                        formatRegularPrice = function (regularPriceElement, price) {
                            regularPriceElement.innerHTML = theme.Currency.formatMoney(price, theme.moneyFormat);
                        };
                    this.productState.onSale
                        ? (regularPrices.forEach(function (regularPrice) {
                              formatRegularPrice(regularPrice, variant.compare_at_price);
                          }),
                          (salePrice.innerHTML = theme.Currency.formatMoney(variant.price, theme.moneyFormat)))
                        : regularPrices.forEach(function (regularPrice) {
                              formatRegularPrice(regularPrice, variant.price);
                          }),
                        this.productState.showUnitPrice && (unitPrice.innerHTML = theme.Currency.formatMoney(variant.unit_price, theme.moneyFormat));
                },
                _getBaseUnit: function (variant) {
                    return variant.unit_price_measurement.reference_value === 1 ? variant.unit_price_measurement.reference_unit : variant.unit_price_measurement.reference_value + variant.unit_price_measurement.reference_unit;
                },
                _updateSKU: function (evt) {
                    var variant = evt.detail.variant,
                        sku = document.querySelector(this.selectors.SKU);
                    if (sku) {
                        sku.innerHTML = variant.sku;
                        var contant_form_current_variant_sku = document.querySelector("#contant_form_current_variant_sku");
                        contant_form_current_variant_sku && (contant_form_current_variant_sku.value = variant.sku);
                    }
                },
                _initSwatches: function () {
                    this.swatchesWrapper &&
                        this.swatchesWrapper.querySelectorAll('[type="radio"]').forEach(function (item, index) {
                            item.addEventListener("change", function (e) {
                               console.log("Dasdasd");
                                var optionIndex = this.closest(".swatch").getAttribute("data-option-index"),
                                    optionValue = this.value,
                                    triggerSelectEl = this.closest("form").querySelectorAll(".single-option-selector")[optionIndex];
                                triggerSelectEl && ((triggerSelectEl.value = optionValue), triggerSelectEl.dispatchEvent(new Event("change", { bubbles: !0 })));
                            });
                        });
                    for (var productJSON = this.productSingleObject, i = 0, length = productJSON.variants.length; i < length; i++) {
                        var productVariants = productJSON.variants[i];
                        if (productVariants.available)
                            for (var j = 0, optlength = productVariants.options.length; j < optlength; j++) {
                                var variantOption = productVariants.options[j];
                                variantOption = handleizeStr(variantOption);
                                var active_swatchEl = this.container.querySelector('.swatch[data-option-index="' + j + '"] .swatch_' + variantOption);
                                active_swatchEl && (active_swatchEl.classList.remove("soldout"), active_swatchEl.classList.add("available"), active_swatchEl.querySelector('[type="radio"]').removeAttribute("disabled"));
                            }
                    }
                },
                onUnload: function () {
                    this.container.removeEventListener("variantChange", this.eventHandlers.updateAvailability),
                        this.container.removeEventListener("variantPriceChange", this.eventHandlers.updatePrice),
                        this.container.removeEventListener("variantSKUChange", this.eventHandlers.updateSKU),
                        theme.ProductVideo.removeSectionVideos(this.settings.sectionId),
                        theme.ProductModel.removeSectionModels(this.settings.sectionId);
                },
            })),
            Product
        );
    })()),
    (theme.ProductRecommendations = (function () {
        function ProductRecommendations(container) {
            var baseUrl = container.dataset.baseUrl,
                productId = container.dataset.productId,
                sectionId = container.dataset.sectionId,
                recommendationsSectionUrl = baseUrl + "?section_id=" + sectionId + "&product_id=" + productId + "&limit=4";
            window.performance.mark("pursuit:product:fetch_product_recommendations.start"),
                fetch(recommendationsSectionUrl)
                    .then(function (response) {
                        return response.text();
                    })
                    .then(function (productHtml) {
                        if (productHtml.trim() !== "") {
                            (container.innerHTML = productHtml), (container.innerHTML = container.firstElementChild.innerHTML);
                            var formsArr = container.querySelectorAll('[action="/cart/add"]');
                            formsArr.length &&
                                formsArr.forEach(function (form, index) {
                                    theme.AddItemToCart(form);
                                }),
                                theme.ProductItemSwatches();
                            var zoomFadeAnimationElems = container.querySelectorAll(".zoom-fade-animation:not(.zoomFade-animation)");
                            zoomFadeAnimationElems.length &&
                                zoomFadeAnimationElems.forEach(function (block, index) {
                                    var containerPosition = block.getBoundingClientRect();
                                    containerPosition.top + 200 < window.innerHeight && block.classList.add("zoomFade-animation");
                                }),
                                window.performance.mark("pursuit:product:fetch_product_recommendations.end"),
                                performance.measure("pursuit:product:fetch_product_recommendations", "pursuit:product:fetch_product_recommendations.start", "pursuit:product:fetch_product_recommendations.end");
                        }
                    });
        }
        return ProductRecommendations;
    })()),
    (theme.Quotes = (function () {
        function Quotes(container) {
            this.container = container;
            var sectionId = container.getAttribute("data-section-id");
            if (((this.slider = container.querySelector(".testimonials_slider")), this.slider)) {
                this.options = JSON.parse(this.slider.getAttribute("data-flickity-config"));
                var flickityInstance = new Flickity(this.slider, this.options);
                flickityInstance.element.classList.add("rendered");
                var slider_custom_arrows = container.querySelector(".slider_custom_arrows");
                if (slider_custom_arrows) {
                    var slider_custom_btns = slider_custom_arrows.querySelectorAll(".btn");
                    slider_custom_btns.forEach(function (item, index) {
                        item.addEventListener("click", function (e) {
                            e.preventDefault();
                            var isNext = item.classList.contains("button-next");
                            isNext ? flickityInstance.next() : flickityInstance.previous();
                        });
                    });
                }
            }
        }
        return Quotes;
    })()),
    (theme.SlideshowSection = (function () {
        var selectors2 = { sliderMobileContentIndex: "[data-slider-mobile-content-index]" };
        function SlideshowSection(container) {
            var sectionId = container.dataset.sectionId,
                self2 = this;
            (this.container = container),
                (this.eventHandlers = {}),
                (this.slideshowDom = container.querySelector("#Slideshow-" + sectionId)),
                (this.sliderMobileContentIndex = container.querySelectorAll(selectors2.sliderMobileContentIndex)),
                this.slideshowDom &&
                    ((this.slideshow = new theme.Slideshow(container, { autoplay: this.slideshowDom.getAttribute("data-autorotate") === "true", slideInterval: this.slideshowDom.getAttribute("data-speed") })), this._setupEventListeners());
        }
        return SlideshowSection;
    })()),
    (theme.SlideshowSection.prototype = Object.assign({}, theme.SlideshowSection.prototype, {
        _setupEventListeners: function () {
            (this.eventHandlers.onSliderSlideChanged = function (event) {
                this._onSliderSlideChanged(event.detail);
            }.bind(this)),
                this.container.addEventListener("slider_slide_changed", this.eventHandlers.onSliderSlideChanged),
                this.container.dispatchEvent(new Event("slider_slide_changed", { bubbles: !0 })),
                console.log("slider_slide_changed init");
        },
        _onSliderSlideChanged: function (slideIndex) {
            var activeClass = "slideshow__text-content--mobile-active";
            this.sliderMobileContentIndex.forEach(function (element) {
                Number(element.getAttribute("data-slider-mobile-content-index")) === slideIndex ? element.classList.add(activeClass) : element.classList.remove(activeClass);
            });
            var videoSlides = this.container.querySelectorAll(".block_type__video"),
                _this = this;
            if (videoSlides.length) {
                var activeSlide = _this.container.querySelector(".slideshow__slide--active");
                if (activeSlide && activeSlide.classList.contains("block_type__video")) {
                    var isVideoTag = activeSlide.querySelector("video");
                    if (isVideoTag) {
                        var videoId = isVideoTag.getAttribute("id"),
                            videoObj = document.getElementById(videoId);
                        videoObj && videoObj.play();
                    }
                    var videoIframe = activeSlide.querySelector("iframe");
                    if (videoIframe) {
                        var videoId = videoIframe.getAttribute("id"),
                            player = YT.get(videoId);
                        player && player.playVideo();
                    } else {
                        var videoDivEl = activeSlide.querySelector("div.slideshow_video");
                        videoDivEl && (theme.Video.init(videoDivEl), theme.Video.editorLoadVideo(videoDivEl.id));
                    }
                }
                for (var i = 0; i < _this.slideshow.slides.length; i++) {
                    var slide = _this.slideshow.slides[i];
                    if (i != _this.slideshow.slideIndex) {
                        var hasVideoEl = slide.querySelector(".slideshow_video");
                        if (hasVideoEl) {
                            var isVideoTag = slide.querySelector("video");
                            if (isVideoTag) {
                                var videoId = isVideoTag.getAttribute("id"),
                                    videoObj = document.getElementById(videoId);
                                videoObj && videoObj.pause();
                            } else {
                                var videoIframe = slide.querySelector("iframe");
                                if (videoIframe) {
                                    var videoId = videoIframe.getAttribute("id"),
                                        player = YT.get(videoId);
                                    player && player.pauseVideo();
                                }
                            }
                        }
                    }
                }
            }
        },
        onUnload: function () {
            this.slideshow.destroy();
        },
        onBlockSelect: function (evt) {
            this.slideshow.adaptHeight && this.slideshow.setSlideshowHeight(), this.slideshow.checkSlideshowHeight();
            var slide = this.container.querySelector(".slideshow__slide--" + evt.detail.blockId),
                slideIndex = slide.getAttribute("data-slider-slide-index");
            this.slideshow.setSlide(slideIndex), this.slideshow.stopAutoplay();
        },
        onBlockDeselect: function () {
            this.slideshow.startAutoplay();
        },
    })),
    (window.theme = window.theme || {}),
    (theme.StoreAvailability = (function () {
        var selectors2 = {
                storeAvailabilityModalOpen: "[data-store-availability-modal-open]",
                storeAvailabilityModalProductTitle: "[data-store-availability-modal-product-title]",
                storeAvailabilityModalVariantTitle: "[data-store-availability-modal-variant-title]",
            },
            classes = { hidden: "hide" };
        function StoreAvailability(container) {
            (this.container = container),
                (this.productTitle = this.container.dataset.productTitle),
                (this.hasOnlyDefaultVariant = this.container.dataset.hasOnlyDefaultVariant === "true"),
                document.addEventListener("click", function (e) {
                    var el = e.target;
                    if (!el.classList.contains("store-availabilities-modal") && !el.closest(".store-availabilities-modal") && !el.closest(".store-availability-information-container")) {
                        var StoreAvailabilityModal = document.querySelector(".store-availabilities-modal");
                        if (StoreAvailabilityModal && StoreAvailabilityModal.classList.contains("store-availabilities-modal--active")) {
                            document.querySelector("body").classList.remove("show_overlay");
                            var close_btn = StoreAvailabilityModal.querySelector(".js-modal-close-store-availability-modal");
                            close_btn && close_btn.dispatchEvent(new Event("click", { bubbles: !0 }));
                        }
                    }
                });
        }
        return (
            (StoreAvailability.prototype = Object.assign({}, StoreAvailability.prototype, {
                updateContent: function (variantId) {
                    var variantSectionUrl = this.container.dataset.baseUrl + "/variants/" + variantId + "/?section_id=store-availability",
                        self2 = this,
                        storeAvailabilityModalOpen = self2.container.querySelector(selectors2.storeAvailabilityModalOpen);
                    (this.container.style.opacity = 0.5),
                        storeAvailabilityModalOpen && ((storeAvailabilityModalOpen.disabled = !0), storeAvailabilityModalOpen.setAttribute("aria-busy", !0)),
                        fetch(variantSectionUrl)
                            .then(function (response) {
                                return response.text();
                            })
                            .then(function (storeAvailabilityHTML) {
                                storeAvailabilityHTML.trim() !== "" &&
                                    ((self2.container.innerHTML = storeAvailabilityHTML),
                                    (self2.container.innerHTML = self2.container.firstElementChild.innerHTML),
                                    (self2.container.style.opacity = 1),
                                    (storeAvailabilityModalOpen = self2.container.querySelector(selectors2.storeAvailabilityModalOpen)),
                                    storeAvailabilityModalOpen &&
                                        (storeAvailabilityModalOpen.addEventListener("click", self2._onClickModalOpen.bind(self2)),
                                        (self2.modal = self2._initModal()),
                                        self2._updateProductTitle(),
                                        self2.hasOnlyDefaultVariant && self2._hideVariantTitle()));
                            });
                },
                clearContent: function () {
                    this.container.innerHTML = "";
                },
                _onClickModalOpen: function () {
                    this.container.dispatchEvent(new CustomEvent("storeAvailabilityModalOpened", { bubbles: !0, cancelable: !0 }));
                },
                _initModal: function () {
                    return new window.Modals("StoreAvailabilityModal", "store-availability-modal", { close: ".js-modal-close-store-availability-modal", closeModalOnClick: !0, openClass: "store-availabilities-modal--active" });
                },
                _updateProductTitle: function () {
                    var storeAvailabilityModalProductTitle = this.container.querySelector(selectors2.storeAvailabilityModalProductTitle);
                    storeAvailabilityModalProductTitle.textContent = this.productTitle;
                },
                _hideVariantTitle: function () {
                    var storeAvailabilityModalVariantTitle = this.container.querySelector(selectors2.storeAvailabilityModalVariantTitle);
                    storeAvailabilityModalVariantTitle.classList.add(classes.hidden);
                },
            })),
            StoreAvailability
        );
    })());
var selectors = { disclosureLocale: "[data-disclosure-locale]", disclosureCurrency: "[data-disclosure-currency]" };
(theme.FooterSection = (function () {
    function Footer(container) {
        (this.container = container),
            (this.cache = {}),
            this.cacheSelectors(),
            this.cache.localeDisclosure && (this.localeDisclosure = new theme.Disclosure(this.cache.localeDisclosure)),
            this.cache.currencyDisclosure && (this.currencyDisclosure = new theme.Disclosure(this.cache.currencyDisclosure));
    }
    return (
        (Footer.prototype = Object.assign({}, Footer.prototype, {
            cacheSelectors: function () {
                this.cache = { localeDisclosure: this.container.querySelector(selectors.disclosureLocale), currencyDisclosure: this.container.querySelector(selectors.disclosureCurrency) };
            },
            onUnload: function () {
                this.cache.localeDisclosure && this.localeDisclosure.destroy(), this.cache.currencyDisclosure && this.currencyDisclosure.destroy();
            },
        })),
        Footer
    );
})()),
    (theme.FeaturedBlog = (function () {
        function FeaturedBlog(container) {
            var sliderEl = container.querySelector(".featured-blog__slider"),
                flickityInstance,
                slider_options;
            if (sliderEl) {
                (slider_options = JSON.parse(sliderEl.getAttribute("data-flickity-config"))), (flickityInstance = new Flickity(sliderEl, slider_options)), flickityInstance.element.classList.add("rendered");
                var slider_custom_arrows = container.querySelector(".slider_custom_arrows");
                if (slider_custom_arrows) {
                    var slider_custom_btns = slider_custom_arrows.querySelectorAll(".btn");
                    slider_custom_btns.forEach(function (item, index) {
                        item.addEventListener("click", function (e) {
                            e.preventDefault();
                            var isNext = item.classList.contains("button-next");
                            isNext ? flickityInstance.next() : flickityInstance.previous();
                        });
                    });
                }
            }
        }
        return FeaturedBlog;
    })()),
    (theme.BlogPage = (function () {
        function BlogPage(container) {
            var sidebar_menu_items = container.querySelectorAll(".panel-heading.collapse");
            sidebar_menu_items.length &&
                sidebar_menu_items.forEach(function (item, index) {
                    item.addEventListener("click", function (e) {
                        e.preventDefault();
                        var self2 = this,
                            panelId = item.getAttribute("data-collapse-panel"),
                            itemPanel = document.querySelector("#" + panelId),
                            current_active_block = container.querySelector(".panel-heading.collapse.active");
                        if (current_active_block) {
                            var current_block_id = current_active_block.getAttribute("data-collapse-panel");
                            current_block_id != panelId && current_active_block.dispatchEvent(new Event("click", { bubbles: !0 }));
                        }
                        if (itemPanel.classList.contains("active"))
                            (itemPanel.style.height = "0px"),
                                itemPanel.addEventListener(
                                    "transitionend",
                                    function () {
                                        itemPanel.classList.remove("active"), self2.classList.remove("active");
                                    },
                                    { once: !0 }
                                );
                        else {
                            self2.classList.add("active"), itemPanel.classList.add("active"), (itemPanel.style.height = "auto");
                            var height = itemPanel.clientHeight + "px";
                            (itemPanel.style.height = "0px"),
                                setTimeout(function () {
                                    itemPanel.style.height = height;
                                }, 0);
                        }
                    });
                });
            var blog_page_top_bar_dropdowns = container.querySelectorAll(".blog_page_top_bar-dropdown");
            blog_page_top_bar_dropdowns.length &&
                blog_page_top_bar_dropdowns.forEach(function (dropdown, index) {
                    dropdown.addEventListener("change", function (e) {
                        e.preventDefault();
                        var val = this.value,
                            id = this.id,
                            new_url;
                        if (id == "top_bar_tags")
                            if (val.length) {
                                var hidden_top_bar_tags_linksEl = container.querySelectorAll(".hidden_top_bar_tags_link");
                                hidden_top_bar_tags_linksEl.length &&
                                    hidden_top_bar_tags_linksEl.forEach(function (item, index2) {
                                        var tag_handle = item.getAttribute("data-tag-handle");
                                        tag_handle == val && (new_url = item.querySelector("a").href);
                                    });
                            } else new_url = window.location.href.split("/tagged")[0];
                        else new_url = val;
                        window.location.href = new_url;
                    });
                });
            var pagination_mode = container.getAttribute("data-pagination_mode");
            if (pagination_mode != "standart") var endlessScroll = new Ajaxinate({ container: "#AjaxinateContainer", pagination: "#AjaxinatePagination", method: pagination_mode, offset: 500 });
            var open_sidebar_btn = container.querySelector(".open_mobile_sidebar"),
                close_sidebar_btn = container.querySelector(".close-blog-sidebar");
            open_sidebar_btn &&
                open_sidebar_btn.addEventListener("click", function (e) {
                    e.preventDefault();
                    var sidebarEl = container.querySelector(".blog-sidebar");
                    sidebarEl && (sidebarEl.classList.add("show"), document.querySelector("body").classList.add("show_overlay"));
                }),
                close_sidebar_btn &&
                    close_sidebar_btn.addEventListener("click", function (e) {
                        e.preventDefault();
                        var sidebarEl = container.querySelector(".blog-sidebar");
                        sidebarEl && (sidebarEl.classList.remove("show"), document.querySelector("body").classList.remove("show_overlay"));
                    });
        }
        return BlogPage;
    })()),
    (theme.ArticlePage = (function () {
        function ArticlePage(container) {
            var form_reset_btn = container.querySelector(".comment-reset-btn");
            form_reset_btn &&
                form_reset_btn.addEventListener("click", function (e) {
                    e.preventDefault();
                    var form = this.closest("form"),
                        inputs = form.querySelectorAll(".input-full");
                    inputs.length &&
                        inputs.forEach(function (item, index) {
                            (item.value = ""), (item.innerHTML = "");
                        });
                });
        }
        return ArticlePage;
    })()),
    (theme.Timeline = (function () {
        function Timeline(container) {
            var timeline_nav_items = container.querySelectorAll(".timeline_nav_item");
            if (timeline_nav_items.length) {
                var sectionHeightCalculate = function () {
                        var sectionHeight = container.getAttribute("data-blocks_height"),
                            timeline_blocks = container.querySelectorAll(".timeline_block");
                        timeline_blocks.length &&
                            timeline_blocks.forEach(function (item, index) {
                                var isActive = item.classList.contains("active");
                                item.classList.add("active");
                                var itemHeight = item.clientHeight;
                                itemHeight > sectionHeight && (sectionHeight = itemHeight), isActive != !0 && item.classList.remove("active");
                            });
                        var timeline_blocksEl = container.querySelector(".timeline_blocks");
                        timeline_blocksEl && (timeline_blocksEl.style.height = sectionHeight + "px");
                    },
                    sectionId = container.getAttribute("data-section-id");
                timeline_nav_items.forEach(function (item, index) {
                    item.addEventListener("click", function (e) {
                        e.preventDefault();
                        var active_nav_item = container.querySelector(".timeline_nav_item.active"),
                            active_timeline_block = container.querySelector(".timeline_block.active"),
                            year = this.getAttribute("data-year"),
                            year_timeline_blockId = "#block_" + sectionId + "_" + year,
                            newTimeline_block = container.querySelector(year_timeline_blockId);
                        active_nav_item.classList.remove("active"), active_timeline_block.classList.remove("active"), newTimeline_block && newTimeline_block.classList.add("active"), this.classList.add("active");
                    });
                });
            }
        }
        return Timeline;
    })()),
    (theme.Mosaic = (function () {
        function Mosaic(container) {
            var use_lightbox = container.querySelector(".use_lightbox");
            if (use_lightbox) {
                var mosaic_blocks = container.querySelectorAll(".mosaic_block");
                if (mosaic_blocks.length) {
                    var items = [],
                        pswpElement = document.querySelectorAll(".pswp")[0];
                    mosaic_blocks.forEach(function (item, index) {
                        var imageObj = { src: item.getAttribute("data-image-url"), w: +item.getAttribute("data-image-width"), h: +item.getAttribute("data-image-height") };
                        items.push(imageObj),
                            item.addEventListener("click", function (e) {
                                var target = e.target;
                                if (!(target.classList.contains("mosaic_block-link") || target.closest(".mosaic_block-link"))) {
                                    e.preventDefault();
                                    var options = { index },
                                        gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
                                    gallery.init();
                                }
                            });
                    });
                }
            }
        }
        return Mosaic;
    })()),
    (theme.SearchBar = (function () {
        function SearchBar(element) {
            (this.element = element),
                (this.delegateElement = new Delegate(this.element)),
                (this.headerElement = this.element.closest(".site-header")),
                (this.searchBarElement = this.element.querySelector(".search-form")),
                (this.inputElement = this.element.querySelector('[name="q"]')),
                (this.searchResultsElement = this.element.querySelector(".search-bar__results")),
                (this.searchPopoverEl = this.element.querySelector(".predictive-search-wrapper--drawer")),
                (this.productTypeFilter = ""),
                (this.isSearchOpen = !1),
                this._attachListeners();
        }
        return (
            (SearchBar.prototype = Object.assign({}, SearchBar.prototype, {
                _destroy: function () {
                    this.delegateElement.off();
                },
                _attachListeners: function () {
                    this.delegateElement.on("focusin", '[name="q"]', this._onInputFocus.bind(this)),
                        this.delegateElement.on("focusout", '[name="q"]', this._onFocusOut.bind(this)),
                        this.delegateElement.on("keydown", '[name="q"]', this._handleTab.bind(this)),
                        this.delegateElement.on("input", '[name="q"]', this._debounce(this._doSearch.bind(this), 250)),
                        this.delegateElement.on("click", "#search-product-type", this._productTypeChanged.bind(this)),
                        this.delegateElement.on("submit", '[type="submit"]', this._onFormSubmit.bind(this));
                    var _this = this;
                    document.addEventListener("click", function (e) {
                        var el = e.target;
                        !el.classList.contains("search-bar__form") &&
                            !el.closest(".search-bar__form") &&
                            (_this.element.classList.remove("is-fixed"),
                            document.body.classList.remove("no-mobile-scroll"),
                            _this.element.contains(e.relatedTarget) || (_this.searchPopoverEl.setAttribute("aria-hidden", "true"), _this.searchBarElement.classList.remove("is-expanded")));
                    });
                },
                _toggleMobileSearch: function () {
                    this.isSearchOpen
                        ? (this.headerElement.classList.remove("header--search-expanded"), this.element.classList.remove("is-visible"))
                        : (this.headerElement.classList.add("header--search-expanded"), this.element.classList.add("is-visible")),
                        (this.isSearchOpen = !this.isSearchOpen);
                },
                _onInputFocus: function () {
                    this.element.classList.add("is-fixed"),
                        document.body.classList.add("no-mobile-scroll"),
                        this.searchPopoverEl.setAttribute("aria-hidden", "false"),
                        this.inputElement.classList.add("is-filled"),
                        this.searchBarElement.classList.add("is-expanded");
                },
                _onFocusOut: function (event) {
                    theme.Helpers.setTouch(),
                        !theme.Helpers.isTouch() &&
                            (this.element.classList.remove("is-fixed"),
                            document.body.classList.remove("no-mobile-scroll"),
                            this.element.contains(event.relatedTarget) || (this.searchPopoverEl.setAttribute("aria-hidden", "true"), this.searchBarElement.classList.remove("is-expanded")));
                },
                _handleTab: function (event) {
                    if (event.keyCode === 9) {
                        var firstFocusableElement = this.searchResultsElement.querySelector("a");
                        firstFocusableElement && (firstFocusableElement.focus(), event.preventDefault());
                    }
                },
                _supportsPredictiveApi: function () {
                    return JSON.parse(document.getElementById("shopify-features").innerHTML).predictiveSearch;
                },
                _doSearch: function () {
                    var _this33 = this,
                        currentInput = this.inputElement.value;
                    if (((this.lastInputValue = currentInput), currentInput === "")) _this33.searchPopoverEl.classList.remove("added_results"), (_this33.searchBarElement.querySelector(".search-bar__results-inner").innerHTML = "");
                    else {
                        this.searchPopoverEl.setAttribute("aria-hidden", "false");
                        var queryOptions = { method: "GET", credentials: "same-origin" },
                            url = "".concat(window.routes.searchUrl).concat(this._supportsPredictiveApi() ? "/suggest" : ""),
                            productQuery = "".concat(this.productTypeFilter !== "" ? "product_type:".concat(this.productTypeFilter, " AND ") : "").concat(encodeURIComponent(this.lastInputValue)),
                            queries = [fetch("".concat(url, "?section_id=predictive-search&q=").concat(productQuery, "&resources[limit]=3&resources[limit_scope]=each"), queryOptions)];
                        Promise.all(queries).then(function (responses) {
                            _this33.lastInputValue === currentInput &&
                                Promise.all(
                                    responses.map(function (response) {
                                        return response.text();
                                    })
                                ).then(function (contents) {
                                    var contents_length = contents.join("").trim().length,
                                        searchContent = document.createElement("div");
                                    searchContent.innerHTML = contents.join("").trim();
                                    var viewAll = searchContent.querySelector(".search-bar__view-all-button-wrapper");
                                    viewAll && searchContent.insertAdjacentElement("beforeend", viewAll),
                                        (_this33.searchBarElement.querySelector(".search-bar__results-inner").innerHTML = searchContent.innerHTML),
                                        contents_length ? _this33.searchPopoverEl.classList.add("added_results") : _this33.searchPopoverEl.classList.remove("added_results");
                                });
                        });
                    }
                },
                _productTypeChanged: function (event, target) {
                    (this.productTypeFilter = target.getAttribute("data-search-type")), this.productTypeFilter == "All Categories" && (this.productTypeFilter = ""), this.inputElement.value !== "" && this._doSearch();
                },
                _onFormSubmit: function (event) {
                    if (this.inputElement.value === "") event.preventDefault();
                    else {
                        var cloneNode = this.inputElement.cloneNode();
                        cloneNode.setAttribute("type", "hidden"),
                            (cloneNode.value = (this.productTypeFilter !== "" ? "product_type:" + this.productTypeFilter + " AND " : "") + this.inputElement.value + "*"),
                            this.inputElement.removeAttribute("name"),
                            this.inputElement.insertAdjacentElement("afterend", cloneNode);
                    }
                },
                _debounce(fn, delay) {
                    var _this34 = this,
                        timer = null;
                    return function () {
                        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
                        clearTimeout(timer),
                            (timer = setTimeout(function () {
                                fn.apply(_this34, args);
                            }, delay));
                    };
                },
            })),
            SearchBar
        );
    })()),
    (theme.Shop_the_Look = (function () {
        function Shop_the_Look(container) {
            var shop_the_look_product_carousel = container.querySelector(".shop_the_look_product_carousel");
            if (shop_the_look_product_carousel) {
                var options = JSON.parse(shop_the_look_product_carousel.getAttribute("data-flickity_options")),
                    shop_the_look_productSize = shop_the_look_product_carousel.querySelectorAll(".shop_the_look_product").length;
                if (shop_the_look_productSize > 1) {
                    var flickityInstance = new Flickity(shop_the_look_product_carousel, options);
                    flickityInstance.on("select", function (index) {
                        if (shop_the_look_product_carousel.classList.contains("is-active")) {
                            var product_dot = container.querySelector('.shop_the_look_dot[data-index="' + index + '"]'),
                                prevProduct_dot = container.querySelector(".shop_the_look_dot.is-active");
                            prevProduct_dot && prevProduct_dot.classList.remove("is-active"), product_dot && product_dot.classList.add("is-active");
                        }
                    });
                }
            }
            var shop_the_look_dots = container.querySelectorAll(".shop_the_look_dot");
            shop_the_look_dots.length &&
                shop_the_look_dots.forEach(function (shop_the_look_dot, index) {
                    shop_the_look_dot.addEventListener("click", function (e) {
                        e.preventDefault();
                        var container2 = this.closest(".shop-the-look-section"),
                            isActive = this.classList.contains("is-active"),
                            _thisProductBlockId = this.getAttribute("data-block-id"),
                            shop_the_look_product_carousel2 = container2.querySelector(".shop_the_look_product_carousel");
                        if (_thisProductBlockId) var _thisProductBlock = container2.querySelector("#" + _thisProductBlockId);
                        if (isActive) this.classList.remove("is-active"), shop_the_look_product_carousel2.classList.remove("is-active"), container2.classList.remove("active_dot");
                        else {
                            var prevActiveDot = container2.querySelector(".shop_the_look_dot.is-active");
                            if (
                                (prevActiveDot && prevActiveDot.classList.remove("is-active"),
                                this.classList.add("is-active"),
                                shop_the_look_product_carousel2.classList.add("is-active"),
                                container2.classList.add("active_dot"),
                                flickityInstance)
                            ) {
                                var activeDotIndex = this.getAttribute("data-index") * 1;
                                flickityInstance.selectCell(activeDotIndex);
                            }
                        }
                    });
                });
            var formsArr = container.querySelectorAll('[action="/cart/add"]');
            if (
                (formsArr.length &&
                    formsArr.forEach(function (form, index) {
                        theme.AddItemToCart(form);
                    }),
                shop_the_look_product_carousel)
            ) {
                let minHeightCarouselBlock2 = function () {
                    var section_block_content = container.querySelector(".section_block_content"),
                        static_block = container.querySelector(".static_block"),
                        static_block_Height = static_block.offsetHeight,
                        product_carousel_Height = shop_the_look_product_carousel.offsetHeight,
                        minHeightForBlock = Math.max(static_block_Height, product_carousel_Height) + 44;
                    section_block_content.style.minHeight = minHeightForBlock + "px";
                };
                var minHeightCarouselBlock = minHeightCarouselBlock2;
                minHeightCarouselBlock2(),
                    window.addEventListener(
                        "resize",
                        theme.Helpers.debounce(function (event) {
                            minHeightCarouselBlock2();
                        }, 100)
                    );
            }
        }
        return Shop_the_Look;
    })()),
    (theme.HomepageVideo = (function () {
        function HomepageVideo(container) {
            var play_video_btns = container.querySelectorAll(".play_video_btn");
            play_video_btns.length &&
                play_video_btns.forEach(function (btn, index) {
                    btn.addEventListener("click", function (e) {
                        e.preventDefault();
                        var pswpElement = document.querySelectorAll(".pswp")[0],
                            videoWrapperEl = this.closest(".VideoWrapper"),
                            videoContentEl = videoWrapperEl.querySelector(".VideoModalContent"),
                            items = [{ html: videoContentEl.innerHTML }],
                            options = { index: 0 },
                            gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
                        gallery.init();
                        var galleryContentEl = gallery.template.querySelector(".pswp__zoom-wrap iframe");
                        if (galleryContentEl) {
                            var videoSrc = galleryContentEl.getAttribute("src"),
                                newvideoSrc = (videoSrc = videoSrc.replace("autoplay=0", "autoplay=1"));
                            galleryContentEl.setAttribute("src", newvideoSrc);
                        } else (galleryContentEl = gallery.template.querySelector(".pswp__zoom-wrap video")), galleryContentEl.setAttribute("autoplay", ""), galleryContentEl.setAttribute("playsinline", "");
                        gallery.listen("close", function () {
                            var galleryContentEl2 = gallery.template.querySelector(".pswp__zoom-wrap iframe");
                            galleryContentEl2 || (galleryContentEl2 = gallery.template.querySelector(".pswp__zoom-wrap video")), galleryContentEl2.remove();
                        });
                    });
                });
            var tabs_nav = container.querySelector(".index-tabs_nav");
            tabs_nav &&
                tabs_nav.querySelectorAll(".index-tabs_nav--item").forEach(function (item, index) {
                    item.addEventListener("click", function (e) {
                        e.preventDefault();
                        var activeItem = tabs_nav.querySelector(".index-tabs_nav--item.active"),
                            href_tab = this.getAttribute("data-href"),
                            content_block = document.querySelector("#" + href_tab);
                        if (activeItem) {
                            activeItem.classList.remove("active");
                            var active_content_block = document.querySelector("#" + activeItem.getAttribute("data-href"));
                            if (active_content_block) {
                                active_content_block.classList.remove("active");
                                var isVideoTag = active_content_block.querySelector("video"),
                                    isIframeVideo = active_content_block.querySelector("iframe");
                                if (isIframeVideo) {
                                    var videoSrc = isIframeVideo.getAttribute("src"),
                                        newvideoSrc = (videoSrc = videoSrc.replace("autoplay=1", "autoplay=0"));
                                    isIframeVideo.setAttribute("src", newvideoSrc);
                                }
                                isVideoTag && (isVideoTag.removeAttribute("autoplay"), isVideoTag.removeAttribute("playsinline"));
                            }
                        }
                        this.classList.add("active"), content_block && content_block.classList.add("active");
                    });
                });
        }
        return HomepageVideo;
    })()),
    document.addEventListener("DOMContentLoaded", function () {
        var sections = new theme.Sections();
        sections.register("video", theme.HomepageVideo),
            sections.register("shop-the-look", theme.Shop_the_Look),
            sections.register("search-template", theme.MainSearchPage),
            sections.register("mosaic", theme.Mosaic),
            sections.register("timeline", theme.Timeline),
            sections.register("featured-blog", theme.FeaturedBlog),
            sections.register("blog-page", theme.BlogPage),
            sections.register("article-page", theme.ArticlePage),
            sections.register("collection-list", theme.CollectionListSection),
            sections.register("featured-products", theme.FeaturedProducts),
            sections.register("index-countdown-timer", theme.CountdownTimer),
            sections.register("page-accordion", theme.PageAccordion),
            sections.register("index-accordion", theme.HomepageAccordion),
            sections.register("logo-bar", theme.LogoBar),
            sections.register("announcement-bar", theme.AnnouncementBar),
            sections.register("cart-template", theme.Cart),
            sections.register("product", theme.Product),
            sections.register("product-template", theme.Product),
            sections.register("header-section", theme.HeaderSection),
            sections.register("slideshow-section", theme.SlideshowSection),
            sections.register("store-availability", theme.StoreAvailability),
            sections.register("quotes", theme.Quotes),
            sections.register("product-recommendations", theme.ProductRecommendations),
            sections.register("advanced-search", theme.AdvancedSearch),
            sections.register("footer-section", theme.FooterSection);
        var quick_viewModal = document.querySelector("#modal-quick-view");
        quick_viewModal &&
            (document.addEventListener("click", function (e) {
                var target = e.target;
                if (target.classList.contains("open-quick-view--btn") || target.closest(".open-quick-view--btn")) {
                    target.classList.contains("open-quick-view--btn") || (target = target.closest(".open-quick-view--btn")), e.preventDefault();
                    var productUrl = new URL("".concat(window.location.origin).concat(target.getAttribute("data-product-url"))),
                        modal = document.getElementById(target.getAttribute("aria-controls"));
                    modal.classList.add("is-loading"),
                        productUrl.searchParams.set("view", "quick-view"),
                        fetch(productUrl.href, { credentials: "same-origin", method: "GET" }).then(function (response) {
                            response.text().then(function (content) {
                                (modal.querySelector(".modal__inner").innerHTML = content), modal.classList.remove("is-loading");
                                var modalProductSection = new theme.Product(modal.querySelector('[data-section-type="product"]'));
                                window.Shopify.PaymentButton && window.Shopify.PaymentButton.init && window.Shopify.PaymentButton.init(),
                                    document.querySelector("body").classList.add("show_overlay"),
                                    modal.setAttribute("aria-hidden", "false");
                            });
                        });
                }
            }),
            document.addEventListener("click", function (e) {
                var el = e.target;
                if (el.classList.contains("close-quick-view") || el.closest(".close-quick-view")) {
                    e.preventDefault();
                    var modal = el.closest(".modal");
                    modal.setAttribute("aria-hidden", "true"), (modal.querySelector(".modal__inner").innerHTML = ""), document.querySelector("body").classList.remove("show_overlay");
                }
            })),
            theme.customerTemplates.init();
        var tableSelectors = ".rte table,.custom__item-inner--html table";
        slate.rte.wrapTable({ tables: document.querySelectorAll(tableSelectors), tableWrapperClass: "scrollable-wrapper" });
        var iframeSelectors = '.rte iframe[src*="youtube.com/embed"],.rte iframe[src*="player.vimeo"],.custom__item-inner--html iframe[src*="youtube.com/embed"],.custom__item-inner--html iframe[src*="player.vimeo"]';
        slate.rte.wrapIframe({ iframes: document.querySelectorAll(iframeSelectors), iframeWrapperClass: "video-wrapper" }), slate.a11y.pageLinkFocus(document.getElementById(window.location.hash.substr(1)));
        var inPageLink = document.querySelector(".in-page-link");
        inPageLink &&
            inPageLink.addEventListener("click", function (evt) {
                slate.a11y.pageLinkFocus(document.getElementById(evt.currentTarget.hash.substr(1)));
            }),
            document.querySelectorAll('a[href="#"]').forEach(function (anchor) {
                anchor.addEventListener("click", function (evt) {
                    evt.preventDefault();
                });
            }),
            slate.a11y.accessibleLinks({
                messages: { newWindow: theme.strings.newWindow, external: theme.strings.external, newWindowExternal: theme.strings.newWindowExternal },
                links: document.querySelectorAll("a[href]:not([aria-describedby]), .product-single__thumbnail"),
            }),
            theme.FormStatus.init(),
            document.addEventListener(
                "touchstart",
                function () {
                    theme.Helpers.setTouch();
                },
                { once: !0 }
            ),
            document.fonts &&
                document.fonts.ready.then(function () {
                    window.performance.mark("pursuit:fonts_loaded");
                });
        function setCookie(name, value, days) {
            var expires = "";
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + days * 24 * 60 * 60 * 1e3), (expires = "; expires=" + date.toUTCString());
            }
            document.cookie = name + "=" + (value || "") + expires + "; path=/";
        }
        function getCookie(name) {
            let parts = `; ${document.cookie}`.split(`; ${name}=`);
            if (parts.length === 2) return parts.pop().split(";").shift();
        }
        var cookie_popup = document.querySelector(".cookie_popup");
        if (cookie_popup) {
            var cookie_popup_wrapper = document.querySelector(".cookie_popup_wrapper");
            document.addEventListener("click", function (e) {
                var el = e.target;
                (el.classList.contains("modal_close_btn") || el.closest(".modal_close_btn")) &&
                    (el.classList.contains("modal_close_btn") || (el = el.closest(".modal_close_btn")),
                    el.closest(".cookie_popup_wrapper") && (cookie_popup_wrapper.classList.remove("show"), window.history.replaceState(null, null, window.location.pathname)));
            }),
                document.addEventListener("click", function (e) {
                    var el = e.target;
                    (el.classList.contains("accept_cookie_popup") || el.closest(".accept_cookie_popup")) &&
                        (el.classList.contains("accept_cookie_popup") || (el = el.closest(".accept_cookie_popup ")),
                        (document.cookie = "accept_use_policy=true"),
                        cookie_popup_wrapper.classList.remove("show"),
                        window.Shopify.loadFeatures(
                            [
                                {
                                    name: "consent-tracking-api",
                                    version: "0.1",
                                    onLoad: function () {
                                        window.Shopify.customerPrivacy.setTrackingConsent({ analytics: !0, marketing: !0 });
                                    },
                                },
                            ],
                            (error) => {}
                        ));
                });
            var isShowCookiePopup = getCookie("accept_use_policy");
            isShowCookiePopup || (window.location.href.indexOf("challenge") < 0 && cookie_popup_wrapper.classList.add("show"));
        }
        function otherFormMessage(formId2) {
            var contact_forms = document.querySelectorAll(".contact-form");
            contact_forms.length &&
                contact_forms.forEach(function (item, index) {
                    var itemId = item.id;
                    if (formId2 != itemId) {
                        var form_messageEl = item.querySelector(".form-message");
                        form_messageEl ? form_messageEl.remove() : ((form_messageEl = item.querySelector(".input-error-message")), form_messageEl && form_messageEl.remove());
                        var form_inputs = item.querySelectorAll(".input--error");
                        form_inputs.length &&
                            form_inputs.forEach(function (input, indexInput) {
                                input.classList.remove("input--error");
                            });
                    }
                });
        }
        var entry_popup_wrapper = document.querySelector(".entry_popup_wrapper");
        if (entry_popup_wrapper) {
            var $container = entry_popup_wrapper.querySelector(".entry-modal"),
                delay = $container.getAttribute("data-delay") * 1e3,
                cookie = $container.getAttribute("data-cookie"),
                sumbitted_form = !1,
                pswpElement = document.querySelectorAll(".pswp")[0],
                items = [{ html: $container }],
                options = {
                    index: 0,
                    modal: !1,
                    mainClass: "entry-modal_wrapper",
                    zoomEl: !1,
                    shareEl: !1,
                    counterEl: !1,
                    arrowEl: !1,
                    fullscreenEl: !1,
                    closeOnScroll: !1,
                    closeOnVerticalDrag: !1,
                    clickToCloseNonZoomable: !1,
                    closeElClasses: " ",
                    closeEl: !1,
                    isClickableElement: function (el) {
                        return !0;
                    },
                },
                entry_popup_gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options),
                form = $container.querySelector("form"),
                formId;
            if (form) {
                formId = form.getAttribute("id");
                var submitCookieCustomerForm = function (event) {
                    event.preventDefault();
                    var cookieTime2 = cookie * 1;
                    setCookie("pop_confirm", "pop_newsletter", cookieTime2);
                };
                form.addEventListener("submit", submitCookieCustomerForm, !1), form.removeEventListener("submit", submitCookieCustomerForm, !1);
            }
            if (
                (document.addEventListener("click", function (e) {
                    var el = e.target;
                    (el.classList.contains("modal_close_btn") || el.closest(".modal_close_btn")) &&
                        (el.classList.contains("modal_close_btn") || (el = el.closest(".modal_close_btn")),
                        el.closest(".entry-modal_wrapper") &&
                            (document.querySelector("body").classList.remove("active_modal"),
                            entry_popup_gallery.close(),
                            window.setTimeout(function () {
                                window.history.replaceState(null, null, window.location.pathname);
                            }, 500)));
                }),
                getCookie("pop_confirm") != null && window.location.hash.indexOf(formId) >= 0 && (window.location.search == "?customer_posted=true" || window.location.hash == "#contact_form" || $container.querySelector("form .errors")))
            )
                var sumbitted_form = !0;
            if (window.location.href.indexOf("challenge") < 0) {
                let show_modal2 = function () {
                    entry_popup_gallery.init(),
                        document.querySelector("body").classList.add("active_modal"),
                        entry_popup_gallery.listen("close", function () {
                            var cookieTime2 = cookie * 1;
                            setCookie("pop", "modal", cookieTime2), setCookie("pop_confirm", null), document.querySelector("body").classList.remove("active_modal");
                        });
                };
                var show_modal = show_modal2;
                if (getCookie("pop") == null || cookie == "use_test_popup" || sumbitted_form) {
                    if ((window.setTimeout(show_modal2, delay), cookie != "use_test_popup" || !sumbitted_form)) {
                        var cookieTime = cookie * 1;
                        setCookie("pop", "modal", cookieTime);
                    }
                    sumbitted_form &&
                        (setCookie("pop_confirm", null), $container.querySelector("form .errors") || $container.querySelector("form").classList.add("successForm"), window.setTimeout(show_modal2, delay), otherFormMessage(formId));
                } else
                    window.location.hash.indexOf(formId) >= 0 &&
                        window.location.search == "?contact%5Btags%5D=newsletter&form_type=customer" &&
                        getCookie("pop") == "modal" &&
                        sumbitted_form == !1 &&
                        (window.setTimeout(show_modal2, delay), otherFormMessage(formId));
            }
        }
        if (window.location.href.indexOf("/?contact%5Btags%5D=newsletter") >= 0) {
            var formId = window.location.href.split("form_type=customer")[1];
            if (formId.length) {
                var formEl = document.querySelector(formId);
                formEl && otherFormMessage(formEl.id);
            }
        }
        function resizeProductsCarousel() {
            document.querySelectorAll(".index-tabs-content_block__slider.flickity-enabled").length &&
                document.querySelectorAll(".index-tabs-content_block__slider.flickity-enabled").forEach(function (item, index) {
                    var flkty = Flickity.data(item),
                        hadRenderedClass = !1;
                    item.classList.contains("rendered") && (hadRenderedClass = !0), hadRenderedClass && item.classList.remove("rendered"), flkty.resize(), hadRenderedClass && item.classList.add("rendered");
                });
        }
        var reLoadProductsCarousel = theme.Helpers.debounce(function (event) {
            resizeProductsCarousel();
        }, 100);
        window.addEventListener("resize", reLoadProductsCarousel);
        function checkSectionVisibility() {
            var fadeInAnimationElems = document.querySelectorAll(".fade-in-animation:not(.fadeIn-animation)"),
                zoomFadeAnimationElems = document.querySelectorAll(".zoom-fade-animation:not(.zoomFade-animation)"),
                removeEvent = !1;
            fadeInAnimationElems.length &&
                fadeInAnimationElems.forEach(function (block, index) {
                    var containerPosition = block.getBoundingClientRect();
                    containerPosition.top + 200 < window.innerHeight && block.classList.add("fadeIn-animation");
                }),
                zoomFadeAnimationElems.length &&
                    zoomFadeAnimationElems.forEach(function (block, index) {
                        var containerPosition = block.getBoundingClientRect();
                        containerPosition.top + 200 < window.innerHeight && block.classList.add("zoomFade-animation");
                    }),
                fadeInAnimationElems.length == 0 && zoomFadeAnimationElems.length == 0 && (removeEvent = !0),
                removeEvent && window.removeEventListener("scroll", checkSectionVisibility);
        }
        checkSectionVisibility(), window.addEventListener("scroll", checkSectionVisibility);
    });
//# sourceMappingURL=/s/files/1/0669/5672/2428/t/15/assets/theme.js.map?v=1723736137
